export const data = {
    "get": "fixtures",
    "parameters": {
        "live": "all"
    },
    "errors": [],
    "results": 195,
    "paging": {
        "current": 1,
        "total": 1
    },
    "response": [
        {
            "fixture": {
                "id": 865368,
                "referee": "Bartosz Frankowski, Poland",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 18628,
                    "name": "Tarczyński Arena",
                    "city": "Wrocław"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 106,
                "name": "Ekstraklasa",
                "country": "Poland",
                "logo": "https://media-3.api-sports.io/football/leagues/106.png",
                "flag": "https://media-1.api-sports.io/flags/pl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 337,
                    "name": "Slask Wroclaw",
                    "logo": "https://media-2.api-sports.io/football/teams/337.png",
                    "winner": false
                },
                "away": {
                    "id": 341,
                    "name": "Wisla Plock",
                    "logo": "https://media-3.api-sports.io/football/teams/341.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 341,
                        "name": "Wisla Plock",
                        "logo": "https://media-2.api-sports.io/football/teams/341.png"
                    },
                    "player": {
                        "id": 40999,
                        "name": "B. Spiaczka"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 867139,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2285,
                    "name": "Stadion ul. Bukowa",
                    "city": "Katowice"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 107,
                "name": "Champions League",
                "country": "Poland",
                "logo": "https://media-1.api-sports.io/football/leagues/107.png",
                "flag": "https://media-2.api-sports.io/flags/pl.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 3484,
                    "name": "GKS Katowice",
                    "logo": "https://media-2.api-sports.io/football/teams/3484.png",
                    "winner": false
                },
                "away": {
                    "id": 3490,
                    "name": "Puszcza Niepołomice",
                    "logo": "https://media-1.api-sports.io/football/teams/3490.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 3484,
                        "name": "GKS Katowice",
                        "logo": "https://media-3.api-sports.io/football/teams/3484.png"
                    },
                    "player": {
                        "id": 40980,
                        "name": "A. Jedrych"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 3490,
                        "name": "Puszcza Niepołomice",
                        "logo": "https://media-1.api-sports.io/football/teams/3490.png"
                    },
                    "player": {
                        "id": 148547,
                        "name": "P. Mrozinski"
                    },
                    "assist": {
                        "id": 40226,
                        "name": "M. Koj"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 871443,
                "referee": "Robert Schroder, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 700,
                    "name": "Allianz Arena",
                    "city": "München"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 7
                }
            },
            "league": {
                "id": 78,
                "name": "Bundesliga",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/78.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 157,
                    "name": "Bayern Munich",
                    "logo": "https://media-3.api-sports.io/football/teams/157.png",
                    "winner": null
                },
                "away": {
                    "id": 174,
                    "name": "FC Schalke 04",
                    "logo": "https://media-1.api-sports.io/football/teams/174.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 871446,
                "referee": "Marco Fritz, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 748,
                    "name": "Stadion An der Alten Försterei",
                    "city": "Berlin"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 6
                }
            },
            "league": {
                "id": 78,
                "name": "Bundesliga",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/78.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 182,
                    "name": "Union Berlin",
                    "logo": "https://media-3.api-sports.io/football/teams/182.png",
                    "winner": true
                },
                "away": {
                    "id": 160,
                    "name": "SC Freiburg",
                    "logo": "https://media-3.api-sports.io/football/teams/160.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 182,
                        "name": "Union Berlin",
                        "logo": "https://media-1.api-sports.io/football/teams/182.png"
                    },
                    "player": {
                        "id": 25192,
                        "name": "K. Behrens"
                    },
                    "assist": {
                        "id": 37938,
                        "name": "S. Becker"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 871448,
                "referee": "Felix Brych, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 10491,
                    "name": "Deutsche Bank Park",
                    "city": "Frankfurt am Main"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 6
                }
            },
            "league": {
                "id": 78,
                "name": "Bundesliga",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/78.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 169,
                    "name": "Eintracht Frankfurt",
                    "logo": "https://media-3.api-sports.io/football/teams/169.png",
                    "winner": null
                },
                "away": {
                    "id": 164,
                    "name": "FSV Mainz 05",
                    "logo": "https://media-1.api-sports.io/football/teams/164.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 871449,
                "referee": "Tobias Stieler, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 752,
                    "name": "VOLKSWAGEN ARENA",
                    "city": "Wolfsburg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 7
                }
            },
            "league": {
                "id": 78,
                "name": "Bundesliga",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/78.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 161,
                    "name": "VfL Wolfsburg",
                    "logo": "https://media-1.api-sports.io/football/teams/161.png",
                    "winner": null
                },
                "away": {
                    "id": 167,
                    "name": "1899 Hoffenheim",
                    "logo": "https://media-3.api-sports.io/football/teams/167.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 871450,
                "referee": "Patrick Ittrich, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 751,
                    "name": "Vonovia Ruhrstadion",
                    "city": "Bochum"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 6
                }
            },
            "league": {
                "id": 78,
                "name": "Bundesliga",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/78.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 176,
                    "name": "VfL BOCHUM",
                    "logo": "https://media-2.api-sports.io/football/teams/176.png",
                    "winner": true
                },
                "away": {
                    "id": 170,
                    "name": "FC Augsburg",
                    "logo": "https://media-3.api-sports.io/football/teams/170.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 176,
                        "name": "VfL BOCHUM",
                        "logo": "https://media-2.api-sports.io/football/teams/176.png"
                    },
                    "player": {
                        "id": 24815,
                        "name": "C. Antwi-Adjei"
                    },
                    "assist": {
                        "id": 26287,
                        "name": "P. Hofmann"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 176,
                        "name": "VfL BOCHUM",
                        "logo": "https://media-1.api-sports.io/football/teams/176.png"
                    },
                    "player": {
                        "id": 25294,
                        "name": "K. Stafylidis"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Foul"
                }
            ]
        },
        {
            "fixture": {
                "id": 876908,
                "referee": "Alen Borosak, Slovenia",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3201,
                    "name": "Mestni Štadion Fazanerija",
                    "city": "Murska Sobota"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 373,
                "name": "1. SNL",
                "country": "Slovenia",
                "logo": "https://media-2.api-sports.io/football/leagues/373.png",
                "flag": "https://media-2.api-sports.io/flags/si.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 4197,
                    "name": "Mura",
                    "logo": "https://media-3.api-sports.io/football/teams/4197.png",
                    "winner": null
                },
                "away": {
                    "id": 4364,
                    "name": "Gorica",
                    "logo": "https://media-2.api-sports.io/football/teams/4364.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 4364,
                        "name": "Gorica",
                        "logo": "https://media-2.api-sports.io/football/teams/4364.png"
                    },
                    "player": {
                        "id": 64344,
                        "name": "B. Karrica"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 4197,
                        "name": "Mura",
                        "logo": "https://media-1.api-sports.io/football/teams/4197.png"
                    },
                    "player": {
                        "id": 290181,
                        "name": "F. Tripi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 4364,
                        "name": "Gorica",
                        "logo": "https://media-2.api-sports.io/football/teams/4364.png"
                    },
                    "player": {
                        "id": 48821,
                        "name": "N. Mevlja"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 4197,
                        "name": "Mura",
                        "logo": "https://media-3.api-sports.io/football/teams/4197.png"
                    },
                    "player": {
                        "id": 80034,
                        "name": "D. K. Morris"
                    },
                    "assist": {
                        "id": 109746,
                        "name": "M. Marusko"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 880075,
                "referee": "Roman Safyan, Russia",
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 1356,
                    "name": "Saint-Petersburg Stadium",
                    "city": "St. Petersburg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 3
                }
            },
            "league": {
                "id": 235,
                "name": "Premier League",
                "country": "Russia",
                "logo": "https://media-2.api-sports.io/football/leagues/235.png",
                "flag": "https://media-1.api-sports.io/flags/ru.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 596,
                    "name": "Zenit Saint Petersburg",
                    "logo": "https://media-2.api-sports.io/football/teams/596.png",
                    "winner": null
                },
                "away": {
                    "id": 621,
                    "name": "Krasnodar",
                    "logo": "https://media-1.api-sports.io/football/teams/621.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 881582,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Stadion Trud",
                    "city": "Ulyanovsk"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 236,
                "name": "First League",
                "country": "Russia",
                "logo": "https://media-1.api-sports.io/football/leagues/236.png",
                "flag": "https://media-3.api-sports.io/flags/ru.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 6834,
                    "name": "Volga Ulyanovsk",
                    "logo": "https://media-1.api-sports.io/football/teams/6834.png",
                    "winner": null
                },
                "away": {
                    "id": 2006,
                    "name": "Baltika",
                    "logo": "https://media-1.api-sports.io/football/teams/2006.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 882126,
                "referee": "Marco Piccinini, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 933,
                    "name": "Stadio Arechi",
                    "city": "Salerno"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 135,
                "name": "Serie A",
                "country": "Italy",
                "logo": "https://media-1.api-sports.io/football/leagues/135.png",
                "flag": "https://media-3.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 514,
                    "name": "Salernitana",
                    "logo": "https://media-2.api-sports.io/football/teams/514.png",
                    "winner": null
                },
                "away": {
                    "id": 499,
                    "name": "Atalanta",
                    "logo": "https://media-3.api-sports.io/football/teams/499.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 899197,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1277,
                    "name": "Estádio Marcolino de Castro",
                    "city": "Santa Maria da Feira"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 95,
                "name": "Segunda Liga",
                "country": "Portugal",
                "logo": "https://media-2.api-sports.io/football/leagues/95.png",
                "flag": "https://media-3.api-sports.io/flags/pt.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 213,
                    "name": "Feirense",
                    "logo": "https://media-1.api-sports.io/football/teams/213.png",
                    "winner": false
                },
                "away": {
                    "id": 229,
                    "name": "Benfica B",
                    "logo": "https://media-1.api-sports.io/football/teams/229.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 229,
                        "name": "Benfica B",
                        "logo": "https://media-3.api-sports.io/football/teams/229.png"
                    },
                    "player": {
                        "id": null,
                        "name": "Maestro"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 229,
                        "name": "Benfica B",
                        "logo": "https://media-2.api-sports.io/football/teams/229.png"
                    },
                    "player": {
                        "id": 271580,
                        "name": "M. Neto"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 229,
                        "name": "Benfica B",
                        "logo": "https://media-3.api-sports.io/football/teams/229.png"
                    },
                    "player": {
                        "id": 162593,
                        "name": "H. Pereira"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 213,
                        "name": "Feirense",
                        "logo": "https://media-2.api-sports.io/football/teams/213.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Rodrigues"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 900114,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2876,
                    "name": "Sportpark Middelmors Veld 2",
                    "city": "Rijnsburg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1248,
                    "name": "Rijnsburgse Boys",
                    "logo": "https://media-2.api-sports.io/football/teams/1248.png",
                    "winner": null
                },
                "away": {
                    "id": 1249,
                    "name": "Spakenburg",
                    "logo": "https://media-3.api-sports.io/football/teams/1249.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 900115,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Sportpark De Westmaat",
                    "city": "Bunschoten"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1280,
                    "name": "Ijsselmeervogels",
                    "logo": "https://media-2.api-sports.io/football/teams/1280.png",
                    "winner": null
                },
                "away": {
                    "id": 1247,
                    "name": "Noordwijk",
                    "logo": "https://media-3.api-sports.io/football/teams/1247.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 1280,
                        "name": "Ijsselmeervogels",
                        "logo": "https://media-1.api-sports.io/football/teams/1280.png"
                    },
                    "player": {
                        "id": 37962,
                        "name": "M. Afaker"
                    },
                    "assist": {
                        "id": 37962,
                        "name": "M. Afaker"
                    },
                    "type": "Goal",
                    "detail": "Missed Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 1280,
                        "name": "Ijsselmeervogels",
                        "logo": "https://media-1.api-sports.io/football/teams/1280.png"
                    },
                    "player": {
                        "id": 37425,
                        "name": "B. Martis"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 900116,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 2868,
                    "name": "Sportpark de Krom",
                    "city": "Katwijk"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 3
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1237,
                    "name": "Katwijk",
                    "logo": "https://media-2.api-sports.io/football/teams/1237.png",
                    "winner": null
                },
                "away": {
                    "id": 1242,
                    "name": "Kozakken Boys",
                    "logo": "https://media-3.api-sports.io/football/teams/1242.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 900117,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1116,
                    "name": "Sportpark Goed Genoeg",
                    "city": "Amsterdam"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1252,
                    "name": "AFC Amsterdam",
                    "logo": "https://media-1.api-sports.io/football/teams/1252.png",
                    "winner": null
                },
                "away": {
                    "id": 1272,
                    "name": "Quick Boys",
                    "logo": "https://media-1.api-sports.io/football/teams/1272.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 1252,
                        "name": "AFC Amsterdam",
                        "logo": "https://media-2.api-sports.io/football/teams/1252.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 900119,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 2869,
                    "name": "Sportpark Spanjaardslaan",
                    "city": "Haarlem"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 2
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1246,
                    "name": "Koninklijke HFC",
                    "logo": "https://media-3.api-sports.io/football/teams/1246.png",
                    "winner": null
                },
                "away": {
                    "id": 10320,
                    "name": "Sparta Rotterdam II",
                    "logo": "https://media-1.api-sports.io/football/teams/10320.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 901618,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3939,
                    "name": "Nakambala Stadium",
                    "city": "Mazabuka"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 32
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5205,
                    "name": "Man Utd Zambia Academy",
                    "logo": "https://media-2.api-sports.io/football/teams/5205.png",
                    "winner": true
                },
                "away": {
                    "id": 5215,
                    "name": "Zanaco",
                    "logo": "https://media-3.api-sports.io/football/teams/5215.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 5205,
                        "name": "Man Utd Zambia Academy",
                        "logo": "https://media-1.api-sports.io/football/teams/5205.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Ng'ambi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 901619,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3936,
                    "name": "Lumwana Football Pitch",
                    "city": "Lumwana"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 32
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5203,
                    "name": "Lumwana Radiants",
                    "logo": "https://media-1.api-sports.io/football/teams/5203.png",
                    "winner": null
                },
                "away": {
                    "id": 5210,
                    "name": "Nkwazi",
                    "logo": "https://media-2.api-sports.io/football/teams/5210.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 901620,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3931,
                    "name": "Dag Hammerskjold Stadium",
                    "city": "Ndola"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 30
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5196,
                    "name": "Buildcon",
                    "logo": "https://media-1.api-sports.io/football/teams/5196.png",
                    "winner": null
                },
                "away": {
                    "id": 5199,
                    "name": "Green Buffaloes",
                    "logo": "https://media-3.api-sports.io/football/teams/5199.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 901621,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3933,
                    "name": "Eagles Ground",
                    "city": "Choma"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5200,
                    "name": "Green Eagles",
                    "logo": "https://media-1.api-sports.io/football/teams/5200.png",
                    "winner": null
                },
                "away": {
                    "id": 5213,
                    "name": "Red Arrows",
                    "logo": "https://media-3.api-sports.io/football/teams/5213.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 5213,
                        "name": "Red Arrows",
                        "logo": "https://media-2.api-sports.io/football/teams/5213.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Chikondi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 5213,
                        "name": "Red Arrows",
                        "logo": "https://media-2.api-sports.io/football/teams/5213.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Banda"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 5200,
                        "name": "Green Eagles",
                        "logo": "https://media-3.api-sports.io/football/teams/5200.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Shamende"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 5200,
                        "name": "Green Eagles",
                        "logo": "https://media-2.api-sports.io/football/teams/5200.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Mugala"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 901622,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3934,
                    "name": "Godfrey Chitalu Stadium",
                    "city": "Kabwe"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5201,
                    "name": "Kabwe Warriors",
                    "logo": "https://media-3.api-sports.io/football/teams/5201.png",
                    "winner": true
                },
                "away": {
                    "id": 17711,
                    "name": "Chambishi",
                    "logo": "https://media-3.api-sports.io/football/teams/17711.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 5201,
                        "name": "Kabwe Warriors",
                        "logo": "https://media-1.api-sports.io/football/teams/5201.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Mwachiaba"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 901626,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3930,
                    "name": "Levy Mwanawasa Stadium",
                    "city": "Ndola"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 400,
                "name": "Super League",
                "country": "Zambia",
                "logo": "https://media-1.api-sports.io/football/leagues/400.png",
                "flag": "https://media-3.api-sports.io/flags/zm.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 5214,
                    "name": "ZESCO United",
                    "logo": "https://media-2.api-sports.io/football/teams/5214.png",
                    "winner": null
                },
                "away": {
                    "id": 5209,
                    "name": "Nkana",
                    "logo": "https://media-3.api-sports.io/football/teams/5209.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 904981,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2728,
                    "name": "Stadion am Bruchweg",
                    "city": "Mainz"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 86,
                "name": "Regionalliga - SudWest",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/86.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Südwest - 32"
            },
            "teams": {
                "home": {
                    "id": 1331,
                    "name": "FSV Mainz 05 II",
                    "logo": "https://media-3.api-sports.io/football/teams/1331.png",
                    "winner": true
                },
                "away": {
                    "id": 1628,
                    "name": "Kickers Offenbach",
                    "logo": "https://media-1.api-sports.io/football/teams/1628.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 1331,
                        "name": "FSV Mainz 05 II",
                        "logo": "https://media-1.api-sports.io/football/teams/1331.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Schmidt"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907190,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 2724,
                    "name": "Kleiner-Arena",
                    "city": "Remchingen"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 4
                }
            },
            "league": {
                "id": 753,
                "name": "Oberliga - Baden-Württemberg",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/753.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Baden-Württemberg - 32"
            },
            "teams": {
                "home": {
                    "id": 1638,
                    "name": "FC Nottingen",
                    "logo": "https://media-1.api-sports.io/football/teams/1638.png",
                    "winner": null
                },
                "away": {
                    "id": 1642,
                    "name": "FC Rielasingen-Arlen",
                    "logo": "https://media-1.api-sports.io/football/teams/1642.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 907553,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 10688,
                    "name": "Sportanlage Auf dem Zipfen Platz 2",
                    "city": "Hadamar"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 32
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 14550,
                    "name": "Hadamar",
                    "logo": "https://media-3.api-sports.io/football/teams/14550.png",
                    "winner": true
                },
                "away": {
                    "id": 19468,
                    "name": "TSV Steinbach II",
                    "logo": "https://media-3.api-sports.io/football/teams/19468.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 14550,
                        "name": "Hadamar",
                        "logo": "https://media-1.api-sports.io/football/teams/14550.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907554,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Sportplatz Chattenloh",
                    "city": "Meißner"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 28
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 19469,
                    "name": "Weidenhausen",
                    "logo": "https://media-2.api-sports.io/football/teams/19469.png",
                    "winner": false
                },
                "away": {
                    "id": 16099,
                    "name": "Dietkirchen",
                    "logo": "https://media-3.api-sports.io/football/teams/16099.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 1,
                        "extra": null
                    },
                    "team": {
                        "id": 19469,
                        "name": "Weidenhausen",
                        "logo": "https://media-2.api-sports.io/football/teams/19469.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 16099,
                        "name": "Dietkirchen",
                        "logo": "https://media-1.api-sports.io/football/teams/16099.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 16099,
                        "name": "Dietkirchen",
                        "logo": "https://media-1.api-sports.io/football/teams/16099.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Bergs"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907555,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 6466,
                    "name": "Städtisches Stadion im Sportzentrum am Prischoß",
                    "city": "Alzenau"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 32
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 9361,
                    "name": "Bayern Alzenau",
                    "logo": "https://media-2.api-sports.io/football/teams/9361.png",
                    "winner": null
                },
                "away": {
                    "id": 16101,
                    "name": "Neuhof",
                    "logo": "https://media-1.api-sports.io/football/teams/16101.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 907556,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 19427,
                    "name": "Ahorn Camp Sportpark",
                    "city": "Dreieich"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 26
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 19217,
                    "name": "Eintracht Frankfurt II",
                    "logo": "https://media-2.api-sports.io/football/teams/19217.png",
                    "winner": null
                },
                "away": {
                    "id": 14677,
                    "name": "Fernwald",
                    "logo": "https://media-1.api-sports.io/football/teams/14677.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 907557,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 8135,
                    "name": "Sportplatz an der Kastanienallee",
                    "city": "Hanau"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 28
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 12779,
                    "name": "Hanau 93",
                    "logo": "https://media-1.api-sports.io/football/teams/12779.png",
                    "winner": null
                },
                "away": {
                    "id": 12761,
                    "name": "Eintracht Stadtallendorf",
                    "logo": "https://media-1.api-sports.io/football/teams/12761.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 908714,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 11271,
                    "name": "Wahrendorff-Arena",
                    "city": "Burgdorf"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 748,
                "name": "Oberliga - Niedersachsen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/748.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Niedersachsen - 33"
            },
            "teams": {
                "home": {
                    "id": 16089,
                    "name": "Ramlingen / Ehlershausen",
                    "logo": "https://media-2.api-sports.io/football/teams/16089.png",
                    "winner": null
                },
                "away": {
                    "id": 12729,
                    "name": "Arminia Hannover",
                    "logo": "https://media-2.api-sports.io/football/teams/12729.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 908719,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 10740,
                    "name": "Sportanlage In der Ahe",
                    "city": "Rotenburg/Wümme"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 29
                }
            },
            "league": {
                "id": 748,
                "name": "Oberliga - Niedersachsen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/748.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Niedersachsen - 33"
            },
            "teams": {
                "home": {
                    "id": 14764,
                    "name": "Rotenburger SV",
                    "logo": "https://media-1.api-sports.io/football/teams/14764.png",
                    "winner": true
                },
                "away": {
                    "id": 12811,
                    "name": "Lupo-Martini",
                    "logo": "https://media-1.api-sports.io/football/teams/12811.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 3,
                        "extra": null
                    },
                    "team": {
                        "id": 14764,
                        "name": "Rotenburger SV",
                        "logo": "https://media-1.api-sports.io/football/teams/14764.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Kohler"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 915589,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Centro Sportivo Ercole Cellino",
                    "city": "Assemini"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 705,
                "name": "Campionato Primavera - 1",
                "country": "Italy",
                "logo": "https://media-3.api-sports.io/football/leagues/705.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 15658,
                    "name": "Cagliari U19",
                    "logo": "https://media-1.api-sports.io/football/teams/15658.png",
                    "winner": null
                },
                "away": {
                    "id": 15656,
                    "name": "Bologna U19",
                    "logo": "https://media-1.api-sports.io/football/teams/15656.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 14,
                        "extra": null
                    },
                    "team": {
                        "id": 15658,
                        "name": "Cagliari U19",
                        "logo": "https://media-1.api-sports.io/football/teams/15658.png"
                    },
                    "player": {
                        "id": 333033,
                        "name": "D. Veroli"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 15656,
                        "name": "Bologna U19",
                        "logo": "https://media-1.api-sports.io/football/teams/15656.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 915595,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Stadio Enzo Ricci",
                    "city": "Sassuolo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 705,
                "name": "Campionato Primavera - 1",
                "country": "Italy",
                "logo": "https://media-3.api-sports.io/football/leagues/705.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 15681,
                    "name": "Sassuolo U19",
                    "logo": "https://media-2.api-sports.io/football/teams/15681.png",
                    "winner": true
                },
                "away": {
                    "id": 7966,
                    "name": "Roma U19",
                    "logo": "https://media-2.api-sports.io/football/teams/7966.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 7966,
                        "name": "Roma U19",
                        "logo": "https://media-2.api-sports.io/football/teams/7966.png"
                    },
                    "player": {
                        "id": 403634,
                        "name": "B. Silva"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 15681,
                        "name": "Sassuolo U19",
                        "logo": "https://media-2.api-sports.io/football/teams/15681.png"
                    },
                    "player": {
                        "id": null,
                        "name": "F. Russo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 7966,
                        "name": "Roma U19",
                        "logo": "https://media-1.api-sports.io/football/teams/7966.png"
                    },
                    "player": {
                        "id": null,
                        "name": "F. D'Alessio"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 7966,
                        "name": "Roma U19",
                        "logo": "https://media-1.api-sports.io/football/teams/7966.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 924395,
                "referee": "Benjamin Lepaysant, France",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 672,
                    "name": "Stade Robert Diochon",
                    "city": "Le Petit-Quevilly"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 62,
                "name": "Ligue 2",
                "country": "France",
                "logo": "https://media-2.api-sports.io/football/leagues/62.png",
                "flag": "https://media-1.api-sports.io/flags/fr.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 431,
                    "name": "Quevilly",
                    "logo": "https://media-2.api-sports.io/football/teams/431.png",
                    "winner": null
                },
                "away": {
                    "id": 78,
                    "name": "Bordeaux",
                    "logo": "https://media-2.api-sports.io/football/teams/78.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 431,
                        "name": "Quevilly",
                        "logo": "https://media-1.api-sports.io/football/teams/431.png"
                    },
                    "player": {
                        "id": 1255,
                        "name": "T. Cissokho"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 926508,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 18910,
                    "name": "Stadion am Deininger Weg",
                    "city": "Neumarkt in der Oberpfalz"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 938,
                "name": "Oberliga - Bayern Nord",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/938.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Nord - 32"
            },
            "teams": {
                "home": {
                    "id": 19758,
                    "name": "ASV Neumarkt",
                    "logo": "https://media-2.api-sports.io/football/teams/19758.png",
                    "winner": null
                },
                "away": {
                    "id": 19228,
                    "name": "Gebenbach",
                    "logo": "https://media-2.api-sports.io/football/teams/19228.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 926509,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 12078,
                    "name": "Sportzentrum Donaustauf - Platz 1",
                    "city": "Donaustauf"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 938,
                "name": "Oberliga - Bayern Nord",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/938.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Nord - 32"
            },
            "teams": {
                "home": {
                    "id": 17030,
                    "name": "Donaustauf",
                    "logo": "https://media-3.api-sports.io/football/teams/17030.png",
                    "winner": null
                },
                "away": {
                    "id": 12737,
                    "name": "Bayern Hof",
                    "logo": "https://media-1.api-sports.io/football/teams/12737.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 926811,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 6442,
                    "name": "Sportanlage Reuthinger Weg",
                    "city": "Passau"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 939,
                "name": "Oberliga - Bayern Süd",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/939.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Süd - 32"
            },
            "teams": {
                "home": {
                    "id": 9334,
                    "name": "Schalding-Heining",
                    "logo": "https://media-2.api-sports.io/football/teams/9334.png",
                    "winner": true
                },
                "away": {
                    "id": 9322,
                    "name": "1860 Rosenheim",
                    "logo": "https://media-3.api-sports.io/football/teams/9322.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 9334,
                        "name": "Schalding-Heining",
                        "logo": "https://media-3.api-sports.io/football/teams/9334.png"
                    },
                    "player": {
                        "id": 177345,
                        "name": "C. Bruckl"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 25,
                        "extra": null
                    },
                    "team": {
                        "id": 9334,
                        "name": "Schalding-Heining",
                        "logo": "https://media-1.api-sports.io/football/teams/9334.png"
                    },
                    "player": {
                        "id": 177495,
                        "name": "M. Gallmaier"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 926813,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 8196,
                    "name": "Ernst-Lehner-Stadion",
                    "city": "Augsburg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 939,
                "name": "Oberliga - Bayern Süd",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/939.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Süd - 32"
            },
            "teams": {
                "home": {
                    "id": 12849,
                    "name": "Schwaben Augsburg",
                    "logo": "https://media-2.api-sports.io/football/teams/12849.png",
                    "winner": true
                },
                "away": {
                    "id": 12805,
                    "name": "Kirchanschöring",
                    "logo": "https://media-2.api-sports.io/football/teams/12805.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 12849,
                        "name": "Schwaben Augsburg",
                        "logo": "https://media-2.api-sports.io/football/teams/12849.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Kania"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 12849,
                        "name": "Schwaben Augsburg",
                        "logo": "https://media-1.api-sports.io/football/teams/12849.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Kania"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 926815,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 18720,
                    "name": "Schwabenstadion",
                    "city": "Gundelfingen"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 30
                }
            },
            "league": {
                "id": 939,
                "name": "Oberliga - Bayern Süd",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/939.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Süd - 32"
            },
            "teams": {
                "home": {
                    "id": 19234,
                    "name": "Gundelfingen",
                    "logo": "https://media-1.api-sports.io/football/teams/19234.png",
                    "winner": false
                },
                "away": {
                    "id": 12792,
                    "name": "Ingolstadt II",
                    "logo": "https://media-3.api-sports.io/football/teams/12792.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 12792,
                        "name": "Ingolstadt II",
                        "logo": "https://media-3.api-sports.io/football/teams/12792.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Krupa"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 930595,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 7254,
                    "name": "Athlone Stadium",
                    "city": "Cape Town, WC"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 2697,
                    "name": "Cape Town City",
                    "logo": "https://media-3.api-sports.io/football/teams/2697.png",
                    "winner": null
                },
                "away": {
                    "id": 10567,
                    "name": "Richards Bay",
                    "logo": "https://media-1.api-sports.io/football/teams/10567.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 25,
                        "extra": null
                    },
                    "team": {
                        "id": 2697,
                        "name": "Cape Town City",
                        "logo": "https://media-2.api-sports.io/football/teams/2697.png"
                    },
                    "player": {
                        "id": 46272,
                        "name": "T. Fielies"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 930596,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 7259,
                    "name": "Princess Magogo Stadium",
                    "city": "Durban"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 2690,
                    "name": "Golden Arrows",
                    "logo": "https://media-3.api-sports.io/football/teams/2690.png",
                    "winner": null
                },
                "away": {
                    "id": 2669,
                    "name": "Amazulu",
                    "logo": "https://media-3.api-sports.io/football/teams/2669.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 930597,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1452,
                    "name": "Harry Gwala Stadium",
                    "city": "Pietermaritzburg, KN"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 2692,
                    "name": "Maritzburg Utd",
                    "logo": "https://media-3.api-sports.io/football/teams/2692.png",
                    "winner": null
                },
                "away": {
                    "id": 4905,
                    "name": "Stellenbosch",
                    "logo": "https://media-2.api-sports.io/football/teams/4905.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 930599,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1453,
                    "name": "Orlando Stadium",
                    "city": "Johannesburg, GA"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 2700,
                    "name": "Orlando Pirates",
                    "logo": "https://media-3.api-sports.io/football/teams/2700.png",
                    "winner": true
                },
                "away": {
                    "id": 15537,
                    "name": "Sekhukhune United",
                    "logo": "https://media-2.api-sports.io/football/teams/15537.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 2700,
                        "name": "Orlando Pirates",
                        "logo": "https://media-1.api-sports.io/football/teams/2700.png"
                    },
                    "player": {
                        "id": 46489,
                        "name": "T. Xoki"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 2700,
                        "name": "Orlando Pirates",
                        "logo": "https://media-2.api-sports.io/football/teams/2700.png"
                    },
                    "player": {
                        "id": 3072,
                        "name": "T. Dzvukamanja"
                    },
                    "assist": {
                        "id": 134235,
                        "name": "M. Saleng"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 930600,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 7262,
                    "name": "Chatsworth Stadium",
                    "city": "Durban, KN"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 33
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 10566,
                    "name": "Royal AM",
                    "logo": "https://media-2.api-sports.io/football/teams/10566.png",
                    "winner": false
                },
                "away": {
                    "id": 10563,
                    "name": "Moroka Swallows",
                    "logo": "https://media-2.api-sports.io/football/teams/10563.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 10566,
                        "name": "Royal AM",
                        "logo": "https://media-1.api-sports.io/football/teams/10566.png"
                    },
                    "player": {
                        "id": 46501,
                        "name": "J. N. Ncobeni"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 10563,
                        "name": "Moroka Swallows",
                        "logo": "https://media-1.api-sports.io/football/teams/10563.png"
                    },
                    "player": {
                        "id": 46343,
                        "name": "K. Malinga"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 930601,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1454,
                    "name": "Royal Bafokeng Stadium",
                    "city": "Phokeng, NW"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 2694,
                    "name": "Supersport United",
                    "logo": "https://media-3.api-sports.io/football/teams/2694.png",
                    "winner": null
                },
                "away": {
                    "id": 2691,
                    "name": "Kaizer Chiefs",
                    "logo": "https://media-2.api-sports.io/football/teams/2691.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 2694,
                        "name": "Supersport United",
                        "logo": "https://media-1.api-sports.io/football/teams/2694.png"
                    },
                    "player": {
                        "id": 203472,
                        "name": "K. Phillips"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 2691,
                        "name": "Kaizer Chiefs",
                        "logo": "https://media-3.api-sports.io/football/teams/2691.png"
                    },
                    "player": {
                        "id": 46507,
                        "name": "S. Sithebe"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 2694,
                        "name": "Supersport United",
                        "logo": "https://media-1.api-sports.io/football/teams/2694.png"
                    },
                    "player": {
                        "id": 3277,
                        "name": "T. Hlatshwayo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 2691,
                        "name": "Kaizer Chiefs",
                        "logo": "https://media-3.api-sports.io/football/teams/2691.png"
                    },
                    "player": {
                        "id": 127434,
                        "name": "A. Du Preez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 930602,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 12715,
                    "name": "Mbombela Stadium",
                    "city": "Nelspruit"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 288,
                "name": "Premier Soccer League",
                "country": "South-Africa",
                "logo": "https://media-1.api-sports.io/football/leagues/288.png",
                "flag": "https://media-3.api-sports.io/flags/za.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 8074,
                    "name": "TS Galaxy",
                    "logo": "https://media-3.api-sports.io/football/teams/8074.png",
                    "winner": true
                },
                "away": {
                    "id": 2698,
                    "name": "Chippa United",
                    "logo": "https://media-2.api-sports.io/football/teams/2698.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 8074,
                        "name": "TS Galaxy",
                        "logo": "https://media-3.api-sports.io/football/teams/8074.png"
                    },
                    "player": {
                        "id": 46603,
                        "name": "M. Munyai"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 8074,
                        "name": "TS Galaxy",
                        "logo": "https://media-1.api-sports.io/football/teams/8074.png"
                    },
                    "player": {
                        "id": 359561,
                        "name": "K. Sebelebele"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 931757,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 12393,
                    "name": "Azam Complex Stadium",
                    "city": "Mbagala"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 567,
                "name": "Ligi kuu Bara",
                "country": "Tanzania",
                "logo": "https://media-2.api-sports.io/football/leagues/567.png",
                "flag": "https://media-2.api-sports.io/flags/tz.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 5370,
                    "name": "Young Africans",
                    "logo": "https://media-1.api-sports.io/football/teams/5370.png",
                    "winner": null
                },
                "away": {
                    "id": 14345,
                    "name": "Dodoma Jiji",
                    "logo": "https://media-1.api-sports.io/football/teams/14345.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 943752,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1125,
                    "name": "Sportpark Zuid DVS '33",
                    "city": "Ermelo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1244,
                    "name": "DVS 33 Ermelo",
                    "logo": "https://media-2.api-sports.io/football/teams/1244.png",
                    "winner": null
                },
                "away": {
                    "id": 1261,
                    "name": "GVVV Veenendaal",
                    "logo": "https://media-2.api-sports.io/football/teams/1261.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 943753,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1150,
                    "name": "Sportpark De Vormt",
                    "city": "Urk"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1253,
                    "name": "URK",
                    "logo": "https://media-2.api-sports.io/football/teams/1253.png",
                    "winner": true
                },
                "away": {
                    "id": 6263,
                    "name": "Excelsior '31",
                    "logo": "https://media-2.api-sports.io/football/teams/6263.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 1253,
                        "name": "URK",
                        "logo": "https://media-3.api-sports.io/football/teams/1253.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 943754,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2889,
                    "name": "Sportpark De Roodemolen",
                    "city": "Sassenheim"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 32
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1279,
                    "name": "Ter Leede",
                    "logo": "https://media-1.api-sports.io/football/teams/1279.png",
                    "winner": null
                },
                "away": {
                    "id": 1254,
                    "name": "ASWH",
                    "logo": "https://media-2.api-sports.io/football/teams/1254.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 964817,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 12567,
                    "name": "Al Assiouty Sport Stadium",
                    "city": "Beni Suef"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 4
                }
            },
            "league": {
                "id": 887,
                "name": "Second League - Group A",
                "country": "Egypt",
                "logo": "https://media-2.api-sports.io/football/leagues/887.png",
                "flag": "https://media-3.api-sports.io/flags/eg.svg",
                "season": 2022,
                "round": "Group A - 25"
            },
            "teams": {
                "home": {
                    "id": 16436,
                    "name": "La Viena FC",
                    "logo": "https://media-1.api-sports.io/football/teams/16436.png",
                    "winner": null
                },
                "away": {
                    "id": 18027,
                    "name": "Tamya",
                    "logo": "https://media-3.api-sports.io/football/teams/18027.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 966649,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 7898,
                    "name": "Gipedo Neas Efkarpias Makedonikou",
                    "city": "Thessaloníki"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 494,
                "name": "Super League 2",
                "country": "Greece",
                "logo": "https://media-1.api-sports.io/football/leagues/494.png",
                "flag": "https://media-3.api-sports.io/flags/gr.svg",
                "season": 2022,
                "round": "Group A - 25"
            },
            "teams": {
                "home": {
                    "id": 18018,
                    "name": "PAOK II",
                    "logo": "https://media-2.api-sports.io/football/teams/18018.png",
                    "winner": null
                },
                "away": {
                    "id": 5062,
                    "name": "Thesprotos",
                    "logo": "https://media-3.api-sports.io/football/teams/5062.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 966652,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 762,
                    "name": "Dimotiko Stadio Polikastro",
                    "city": "Polikastro"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 494,
                "name": "Super League 2",
                "country": "Greece",
                "logo": "https://media-1.api-sports.io/football/leagues/494.png",
                "flag": "https://media-3.api-sports.io/flags/gr.svg",
                "season": 2022,
                "round": "Group A - 25"
            },
            "teams": {
                "home": {
                    "id": 2102,
                    "name": "Apollon Pontou",
                    "logo": "https://media-2.api-sports.io/football/teams/2102.png",
                    "winner": true
                },
                "away": {
                    "id": 18019,
                    "name": "Panathinaikos II",
                    "logo": "https://media-3.api-sports.io/football/teams/18019.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 2102,
                        "name": "Apollon Pontou",
                        "logo": "https://media-3.api-sports.io/football/teams/2102.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Nguemechieu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 2102,
                        "name": "Apollon Pontou",
                        "logo": "https://media-1.api-sports.io/football/teams/2102.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 966849,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2732,
                    "name": "Stadio Kallitheas Grigóris Lamprákis",
                    "city": "Athens"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 494,
                "name": "Super League 2",
                "country": "Greece",
                "logo": "https://media-1.api-sports.io/football/leagues/494.png",
                "flag": "https://media-3.api-sports.io/flags/gr.svg",
                "season": 2022,
                "round": "Group B - 25"
            },
            "teams": {
                "home": {
                    "id": 2095,
                    "name": "Kallithea",
                    "logo": "https://media-1.api-sports.io/football/teams/2095.png",
                    "winner": true
                },
                "away": {
                    "id": 5038,
                    "name": "Episkopi",
                    "logo": "https://media-2.api-sports.io/football/teams/5038.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 2095,
                        "name": "Kallithea",
                        "logo": "https://media-1.api-sports.io/football/teams/2095.png"
                    },
                    "player": {
                        "id": 26723,
                        "name": "K. Bouloulis"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 966855,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 7917,
                    "name": "Stadio Spyros Yalabidis",
                    "city": "Athens"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 494,
                "name": "Super League 2",
                "country": "Greece",
                "logo": "https://media-1.api-sports.io/football/leagues/494.png",
                "flag": "https://media-3.api-sports.io/flags/gr.svg",
                "season": 2022,
                "round": "Group B - 25"
            },
            "teams": {
                "home": {
                    "id": 13931,
                    "name": "PAO Rouf",
                    "logo": "https://media-2.api-sports.io/football/teams/13931.png",
                    "winner": null
                },
                "away": {
                    "id": 5046,
                    "name": "Kalamata",
                    "logo": "https://media-2.api-sports.io/football/teams/5046.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 979949,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1198,
                    "name": "Strømmen Stadion",
                    "city": "Strømmen"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 38
                }
            },
            "league": {
                "id": 474,
                "name": "2. Division - Group 2",
                "country": "Norway",
                "logo": "https://media-2.api-sports.io/football/leagues/474.png",
                "flag": "https://media-3.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Group 2 - 6"
            },
            "teams": {
                "home": {
                    "id": 2147,
                    "name": "Strommen",
                    "logo": "https://media-2.api-sports.io/football/teams/2147.png",
                    "winner": true
                },
                "away": {
                    "id": 7028,
                    "name": "Sotra",
                    "logo": "https://media-1.api-sports.io/football/teams/7028.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 7028,
                        "name": "Sotra",
                        "logo": "https://media-1.api-sports.io/football/teams/7028.png"
                    },
                    "player": {
                        "id": null,
                        "name": "H. Nyland"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 2147,
                        "name": "Strommen",
                        "logo": "https://media-3.api-sports.io/football/teams/2147.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 980131,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 5161,
                    "name": "Lystlunden Stadion",
                    "city": "Horten"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 473,
                "name": "2. Division - Group 1",
                "country": "Norway",
                "logo": "https://media-2.api-sports.io/football/leagues/473.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Group 1 - 6"
            },
            "teams": {
                "home": {
                    "id": 7052,
                    "name": "Ørn Horten",
                    "logo": "https://media-3.api-sports.io/football/teams/7052.png",
                    "winner": null
                },
                "away": {
                    "id": 6986,
                    "name": "Fram",
                    "logo": "https://media-2.api-sports.io/football/teams/6986.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 980132,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2790,
                    "name": "Norac Stadion",
                    "city": "Arendal"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 473,
                "name": "2. Division - Group 1",
                "country": "Norway",
                "logo": "https://media-2.api-sports.io/football/leagues/473.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Group 1 - 6"
            },
            "teams": {
                "home": {
                    "id": 2155,
                    "name": "Arendal",
                    "logo": "https://media-1.api-sports.io/football/teams/2155.png",
                    "winner": null
                },
                "away": {
                    "id": 7006,
                    "name": "Lyn",
                    "logo": "https://media-2.api-sports.io/football/teams/7006.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 988787,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Bollstanäs IP",
                    "city": "Upplands Väsby"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 33
                }
            },
            "league": {
                "id": 736,
                "name": "Elitettan",
                "country": "Sweden",
                "logo": "https://media-1.api-sports.io/football/leagues/736.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 16002,
                    "name": "Bollstanäs W",
                    "logo": "https://media-2.api-sports.io/football/teams/16002.png",
                    "winner": false
                },
                "away": {
                    "id": 16001,
                    "name": "Alingsås W",
                    "logo": "https://media-3.api-sports.io/football/teams/16001.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 16001,
                        "name": "Alingsås W",
                        "logo": "https://media-1.api-sports.io/football/teams/16001.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Cameras"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 16002,
                        "name": "Bollstanäs W",
                        "logo": "https://media-1.api-sports.io/football/teams/16002.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 988788,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Lötens IP",
                    "city": "Uppsala"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 31
                }
            },
            "league": {
                "id": 736,
                "name": "Elitettan",
                "country": "Sweden",
                "logo": "https://media-1.api-sports.io/football/leagues/736.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 16032,
                    "name": "Gamla Upsala W",
                    "logo": "https://media-3.api-sports.io/football/teams/16032.png",
                    "winner": true
                },
                "away": {
                    "id": 20820,
                    "name": "Häcken II",
                    "logo": "https://media-1.api-sports.io/football/teams/20820.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 16032,
                        "name": "Gamla Upsala W",
                        "logo": "https://media-3.api-sports.io/football/teams/16032.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Ohlund"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 988789,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Fridhemsvallen",
                    "city": "Uddevalla"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 33
                }
            },
            "league": {
                "id": 736,
                "name": "Elitettan",
                "country": "Sweden",
                "logo": "https://media-1.api-sports.io/football/leagues/736.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 16036,
                    "name": "Uddevalla W",
                    "logo": "https://media-2.api-sports.io/football/teams/16036.png",
                    "winner": null
                },
                "away": {
                    "id": 15629,
                    "name": "AIK",
                    "logo": "https://media-2.api-sports.io/football/teams/15629.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 989005,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3196,
                    "name": "Undir Mýruhjalla",
                    "city": "Skáli, Eysturoy"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 366,
                "name": "1. Deild",
                "country": "Faroe-Islands",
                "logo": "https://media-3.api-sports.io/football/leagues/366.png",
                "flag": "https://media-1.api-sports.io/flags/fo.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 4191,
                    "name": "Skála",
                    "logo": "https://media-1.api-sports.io/football/teams/4191.png",
                    "winner": true
                },
                "away": {
                    "id": 4179,
                    "name": "HB II",
                    "logo": "https://media-1.api-sports.io/football/teams/4179.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 4191,
                        "name": "Skála",
                        "logo": "https://media-2.api-sports.io/football/teams/4191.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Ferreira"
                    },
                    "assist": {
                        "id": null,
                        "name": "B. Thorleifsson"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998973,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 6353,
                    "name": "Mikkelin Urheilupuisto",
                    "city": "Mikkeli"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 245,
                "name": "Ykkönen",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/245.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 9175,
                    "name": "MP",
                    "logo": "https://media-3.api-sports.io/football/teams/9175.png",
                    "winner": true
                },
                "away": {
                    "id": 2075,
                    "name": "FF Jaro",
                    "logo": "https://media-1.api-sports.io/football/teams/2075.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 9175,
                        "name": "MP",
                        "logo": "https://media-3.api-sports.io/football/teams/9175.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Ylonen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 2075,
                        "name": "FF Jaro",
                        "logo": "https://media-2.api-sports.io/football/teams/2075.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Wargh"
                    },
                    "assist": {
                        "id": 55647,
                        "name": "J. Brunell"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998974,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 620,
                    "name": "Kokkolan Keskuskenttä",
                    "city": "Kokkola"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 245,
                "name": "Ykkönen",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/245.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 10199,
                    "name": "KPV-j",
                    "logo": "https://media-1.api-sports.io/football/teams/10199.png",
                    "winner": null
                },
                "away": {
                    "id": 9173,
                    "name": "JäPS",
                    "logo": "https://media-2.api-sports.io/football/teams/9173.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 10199,
                        "name": "KPV-j",
                        "logo": "https://media-2.api-sports.io/football/teams/10199.png"
                    },
                    "player": {
                        "id": 83458,
                        "name": "P. Byskata"
                    },
                    "assist": {
                        "id": 55803,
                        "name": "S. Mahlamaki"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 10199,
                        "name": "KPV-j",
                        "logo": "https://media-3.api-sports.io/football/teams/10199.png"
                    },
                    "player": {
                        "id": 55612,
                        "name": "S. Mannstrom"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 9173,
                        "name": "JäPS",
                        "logo": "https://media-1.api-sports.io/football/teams/9173.png"
                    },
                    "player": {
                        "id": 83579,
                        "name": "G. Zolameso"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998975,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1939,
                    "name": "Harjun stadion",
                    "city": "Jyväskylä"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 245,
                "name": "Ykkönen",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/245.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 1171,
                    "name": "JJK",
                    "logo": "https://media-3.api-sports.io/football/teams/1171.png",
                    "winner": null
                },
                "away": {
                    "id": 1172,
                    "name": "HIFK Elsinki",
                    "logo": "https://media-2.api-sports.io/football/teams/1172.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 1172,
                        "name": "HIFK Elsinki",
                        "logo": "https://media-3.api-sports.io/football/teams/1172.png"
                    },
                    "player": {
                        "id": 16226,
                        "name": "S. Tukiainen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998976,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 10542,
                    "name": "Ekenäs Centrumplan",
                    "city": "Raseborg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 245,
                "name": "Ykkönen",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/245.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 2078,
                    "name": "EIF",
                    "logo": "https://media-3.api-sports.io/football/teams/2078.png",
                    "winner": true
                },
                "away": {
                    "id": 9198,
                    "name": "SJK Akatemia",
                    "logo": "https://media-1.api-sports.io/football/teams/9198.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 7,
                        "extra": null
                    },
                    "team": {
                        "id": 2078,
                        "name": "EIF",
                        "logo": "https://media-2.api-sports.io/football/teams/2078.png"
                    },
                    "player": {
                        "id": 78526,
                        "name": "J. Esua"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 9198,
                        "name": "SJK Akatemia",
                        "logo": "https://media-2.api-sports.io/football/teams/9198.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Vaisto"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 11,
                        "extra": null
                    },
                    "team": {
                        "id": 2078,
                        "name": "EIF",
                        "logo": "https://media-3.api-sports.io/football/teams/2078.png"
                    },
                    "player": {
                        "id": 65553,
                        "name": "S. Efimov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998977,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 8442,
                    "name": "Urheilupuiston Yläkenttä",
                    "city": "Åbo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 245,
                "name": "Ykkönen",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/245.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 1168,
                    "name": "Turku PS",
                    "logo": "https://media-3.api-sports.io/football/teams/1168.png",
                    "winner": false
                },
                "away": {
                    "id": 2082,
                    "name": "IF Gnistan",
                    "logo": "https://media-2.api-sports.io/football/teams/2082.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 1168,
                        "name": "Turku PS",
                        "logo": "https://media-3.api-sports.io/football/teams/1168.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Pohjolainen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 2082,
                        "name": "IF Gnistan",
                        "logo": "https://media-3.api-sports.io/football/teams/2082.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 999978,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Tikkurila urheilupuisto tekonurmi",
                    "city": "Vantaa"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 247,
                "name": "Kakkonen - Lohko A",
                "country": "Finland",
                "logo": "https://media-2.api-sports.io/football/leagues/247.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Group A - 3"
            },
            "teams": {
                "home": {
                    "id": 10324,
                    "name": "TiPS",
                    "logo": "https://media-3.api-sports.io/football/teams/10324.png",
                    "winner": false
                },
                "away": {
                    "id": 9203,
                    "name": "PKKU",
                    "logo": "https://media-1.api-sports.io/football/teams/9203.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 7,
                        "extra": null
                    },
                    "team": {
                        "id": 9203,
                        "name": "PKKU",
                        "logo": "https://media-2.api-sports.io/football/teams/9203.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Kaijasilta"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 10324,
                        "name": "TiPS",
                        "logo": "https://media-2.api-sports.io/football/teams/10324.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Hussein"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 999979,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Porvoon pallokentän tekonurmi",
                    "city": "Porvoo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 247,
                "name": "Kakkonen - Lohko A",
                "country": "Finland",
                "logo": "https://media-2.api-sports.io/football/leagues/247.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Group A - 3"
            },
            "teams": {
                "home": {
                    "id": 13516,
                    "name": "Futura",
                    "logo": "https://media-3.api-sports.io/football/teams/13516.png",
                    "winner": null
                },
                "away": {
                    "id": 9172,
                    "name": "JIPPO",
                    "logo": "https://media-3.api-sports.io/football/teams/9172.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1000113,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2697,
                    "name": "Kauniaisten Keskuskenttä",
                    "city": "Grankulla"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 248,
                "name": "Kakkonen - Lohko B",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/248.png",
                "flag": "https://media-3.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Group B - 3"
            },
            "teams": {
                "home": {
                    "id": 2079,
                    "name": "GrIFK",
                    "logo": "https://media-1.api-sports.io/football/teams/2079.png",
                    "winner": true
                },
                "away": {
                    "id": 9185,
                    "name": "Ilves II",
                    "logo": "https://media-2.api-sports.io/football/teams/9185.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 1,
                        "extra": null
                    },
                    "team": {
                        "id": 2079,
                        "name": "GrIFK",
                        "logo": "https://media-3.api-sports.io/football/teams/2079.png"
                    },
                    "player": {
                        "id": 83573,
                        "name": "D. Langhoff"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1000242,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 6381,
                    "name": "Puuluoto Tekonurmi",
                    "city": "Tornio"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 249,
                "name": "Kakkonen - Lohko C",
                "country": "Finland",
                "logo": "https://media-3.api-sports.io/football/leagues/249.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Group C - 3"
            },
            "teams": {
                "home": {
                    "id": 9214,
                    "name": "TP-47",
                    "logo": "https://media-2.api-sports.io/football/teams/9214.png",
                    "winner": null
                },
                "away": {
                    "id": 9213,
                    "name": "Kraft",
                    "logo": "https://media-1.api-sports.io/football/teams/9213.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 9213,
                        "name": "Kraft",
                        "logo": "https://media-3.api-sports.io/football/teams/9213.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Storfors"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1001863,
                "referee": "Adam Ladeback, Sweden",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1511,
                    "name": "Bravida Arena",
                    "city": "Göteborg"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 113,
                "name": "Allsvenskan",
                "country": "Sweden",
                "logo": "https://media-2.api-sports.io/football/leagues/113.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 367,
                    "name": "BK Hacken",
                    "logo": "https://media-2.api-sports.io/football/teams/367.png",
                    "winner": null
                },
                "away": {
                    "id": 2172,
                    "name": "Degerfors IF",
                    "logo": "https://media-3.api-sports.io/football/teams/2172.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 3,
                        "extra": null
                    },
                    "team": {
                        "id": 367,
                        "name": "BK Hacken",
                        "logo": "https://media-1.api-sports.io/football/teams/367.png"
                    },
                    "player": {
                        "id": 304161,
                        "name": "B. Traore"
                    },
                    "assist": {
                        "id": 30931,
                        "name": "S. Gustafson"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 2172,
                        "name": "Degerfors IF",
                        "logo": "https://media-2.api-sports.io/football/teams/2172.png"
                    },
                    "player": {
                        "id": 47631,
                        "name": "D. Vukojevic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002095,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2793,
                    "name": "Bryne Stadion",
                    "city": "Bryne"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2142,
                    "name": "Bryne",
                    "logo": "https://media-1.api-sports.io/football/teams/2142.png",
                    "winner": true
                },
                "away": {
                    "id": 2152,
                    "name": "Mjondalen",
                    "logo": "https://media-2.api-sports.io/football/teams/2152.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 2142,
                        "name": "Bryne",
                        "logo": "https://media-3.api-sports.io/football/teams/2142.png"
                    },
                    "player": {
                        "id": 286673,
                        "name": "M. Diaw"
                    },
                    "assist": {
                        "id": 94629,
                        "name": "A. Dybevik"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002096,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2794,
                    "name": "Nye Høddvoll Stadion",
                    "city": "Ulsteinvik"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2150,
                    "name": "hodd",
                    "logo": "https://media-2.api-sports.io/football/teams/2150.png",
                    "winner": null
                },
                "away": {
                    "id": 7012,
                    "name": "Moss",
                    "logo": "https://media-1.api-sports.io/football/teams/7012.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1002097,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1751,
                    "name": "J.J. Ugland Stadion",
                    "city": "Grimstad"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2151,
                    "name": "jerv",
                    "logo": "https://media-3.api-sports.io/football/teams/2151.png",
                    "winner": false
                },
                "away": {
                    "id": 2149,
                    "name": "Fredrikstad",
                    "logo": "https://media-3.api-sports.io/football/teams/2149.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 2149,
                        "name": "Fredrikstad",
                        "logo": "https://media-3.api-sports.io/football/teams/2149.png"
                    },
                    "player": {
                        "id": 39318,
                        "name": "E. Brenden"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002098,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1179,
                    "name": "KFUM Arena",
                    "city": "Oslo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2143,
                    "name": "KFUM Oslo",
                    "logo": "https://media-3.api-sports.io/football/teams/2143.png",
                    "winner": null
                },
                "away": {
                    "id": 2144,
                    "name": "Kongsvinger",
                    "logo": "https://media-1.api-sports.io/football/teams/2144.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1002099,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1189,
                    "name": "NAMMO stadion",
                    "city": "Raufoss"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2153,
                    "name": "Raufoss",
                    "logo": "https://media-1.api-sports.io/football/teams/2153.png",
                    "winner": null
                },
                "away": {
                    "id": 322,
                    "name": "Ranheim",
                    "logo": "https://media-1.api-sports.io/football/teams/322.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 322,
                        "name": "Ranheim",
                        "logo": "https://media-3.api-sports.io/football/teams/322.png"
                    },
                    "player": {
                        "id": 39358,
                        "name": "M. Pedersen"
                    },
                    "assist": {
                        "id": 57200,
                        "name": "H. Kristiansen"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002101,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1194,
                    "name": "Nordre Åsen kunstgress",
                    "city": "Oslo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2239,
                    "name": "Skeid",
                    "logo": "https://media-2.api-sports.io/football/teams/2239.png",
                    "winner": false
                },
                "away": {
                    "id": 334,
                    "name": "Start",
                    "logo": "https://media-2.api-sports.io/football/teams/334.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 334,
                        "name": "Start",
                        "logo": "https://media-2.api-sports.io/football/teams/334.png"
                    },
                    "player": {
                        "id": 314341,
                        "name": "H. Skogvold"
                    },
                    "assist": {
                        "id": 26899,
                        "name": "V. Sakor"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002102,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 12683,
                    "name": "Åsane Arena",
                    "city": "Bergen"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 104,
                "name": "1. Division",
                "country": "Norway",
                "logo": "https://media-1.api-sports.io/football/leagues/104.png",
                "flag": "https://media-1.api-sports.io/flags/no.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2148,
                    "name": "Asane",
                    "logo": "https://media-3.api-sports.io/football/teams/2148.png",
                    "winner": true
                },
                "away": {
                    "id": 758,
                    "name": "Sogndal",
                    "logo": "https://media-3.api-sports.io/football/teams/758.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 2148,
                        "name": "Asane",
                        "logo": "https://media-1.api-sports.io/football/teams/2148.png"
                    },
                    "player": {
                        "id": 57424,
                        "name": "E. Sildnes"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 758,
                        "name": "Sogndal",
                        "logo": "https://media-1.api-sports.io/football/teams/758.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Orjasaeter"
                    },
                    "assist": {
                        "id": 265451,
                        "name": "M. Sjolstad"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 28,
                        "extra": null
                    },
                    "team": {
                        "id": 2148,
                        "name": "Asane",
                        "logo": "https://media-2.api-sports.io/football/teams/2148.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Ndiaye"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002336,
                "referee": "Andreas Johansson, Sweden",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 12718,
                    "name": "Hitachi Energy Arena",
                    "city": "Västerås"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 114,
                "name": "Superettan",
                "country": "Sweden",
                "logo": "https://media-1.api-sports.io/football/leagues/114.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2241,
                    "name": "Vasteras SK FK",
                    "logo": "https://media-1.api-sports.io/football/teams/2241.png",
                    "winner": null
                },
                "away": {
                    "id": 2176,
                    "name": "Landskrona BoIS",
                    "logo": "https://media-3.api-sports.io/football/teams/2176.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 2176,
                        "name": "Landskrona BoIS",
                        "logo": "https://media-2.api-sports.io/football/teams/2176.png"
                    },
                    "player": {
                        "id": 269463,
                        "name": "J. Rapp"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1002337,
                "referee": "Oscar Johnson, Sweden",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 11916,
                    "name": "Visma Arena",
                    "city": "Växjö"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 114,
                "name": "Superettan",
                "country": "Sweden",
                "logo": "https://media-1.api-sports.io/football/leagues/114.png",
                "flag": "https://media-2.api-sports.io/flags/se.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 2174,
                    "name": "Osters IF",
                    "logo": "https://media-2.api-sports.io/football/teams/2174.png",
                    "winner": null
                },
                "away": {
                    "id": 2170,
                    "name": "Gais",
                    "logo": "https://media-2.api-sports.io/football/teams/2170.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 2174,
                        "name": "Osters IF",
                        "logo": "https://media-3.api-sports.io/football/teams/2174.png"
                    },
                    "player": {
                        "id": 48054,
                        "name": "A. Bergmark-Wiberg"
                    },
                    "assist": {
                        "id": 48048,
                        "name": "D. Kozica"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 2170,
                        "name": "Gais",
                        "logo": "https://media-2.api-sports.io/football/teams/2170.png"
                    },
                    "player": {
                        "id": 239472,
                        "name": "G. Lundgren"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 2174,
                        "name": "Osters IF",
                        "logo": "https://media-3.api-sports.io/football/teams/2174.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1006867,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3451,
                    "name": "Stadion Munayşı",
                    "city": "Atyrau"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 389,
                "name": "Premier League",
                "country": "Kazakhstan",
                "logo": "https://media-3.api-sports.io/football/leagues/389.png",
                "flag": "https://media-1.api-sports.io/flags/kz.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 4564,
                    "name": "Atyrau",
                    "logo": "https://media-1.api-sports.io/football/teams/4564.png",
                    "winner": null
                },
                "away": {
                    "id": 4566,
                    "name": "Shakhter Karagandy",
                    "logo": "https://media-2.api-sports.io/football/teams/4566.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 4566,
                        "name": "Shakhter Karagandy",
                        "logo": "https://media-1.api-sports.io/football/teams/4566.png"
                    },
                    "player": {
                        "id": 24768,
                        "name": "T. Chogadze"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 4564,
                        "name": "Atyrau",
                        "logo": "https://media-2.api-sports.io/football/teams/4564.png"
                    },
                    "player": {
                        "id": 262820,
                        "name": "N. Efiong"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 4564,
                        "name": "Atyrau",
                        "logo": "https://media-3.api-sports.io/football/teams/4564.png"
                    },
                    "player": {
                        "id": 262820,
                        "name": "N. Efiong"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1009087,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1629,
                    "name": "Estadio Monumental Luis Tróccoli",
                    "city": "Montevideo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 269,
                "name": "Segunda División",
                "country": "Uruguay",
                "logo": "https://media-1.api-sports.io/football/leagues/269.png",
                "flag": "https://media-2.api-sports.io/flags/uy.svg",
                "season": 2023,
                "round": "2nd Phase - 2"
            },
            "teams": {
                "home": {
                    "id": 19347,
                    "name": "Potencia",
                    "logo": "https://media-2.api-sports.io/football/teams/19347.png",
                    "winner": false
                },
                "away": {
                    "id": 2347,
                    "name": "SUD America",
                    "logo": "https://media-2.api-sports.io/football/teams/2347.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 2347,
                        "name": "SUD America",
                        "logo": "https://media-1.api-sports.io/football/teams/2347.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1009351,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 19577,
                    "name": "LNK Sporta Parks",
                    "city": "Riga"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 365,
                "name": "Virsliga",
                "country": "Latvia",
                "logo": "https://media-1.api-sports.io/football/leagues/365.png",
                "flag": "https://media-1.api-sports.io/flags/lv.svg",
                "season": 2023,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 4160,
                    "name": "Rīgas FS",
                    "logo": "https://media-1.api-sports.io/football/teams/4160.png",
                    "winner": true
                },
                "away": {
                    "id": 18834,
                    "name": "FS Jelgava",
                    "logo": "https://media-1.api-sports.io/football/teams/18834.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 4160,
                        "name": "Rīgas FS",
                        "logo": "https://media-2.api-sports.io/football/teams/4160.png"
                    },
                    "player": {
                        "id": 72373,
                        "name": "C. Kouadio"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 4160,
                        "name": "Rīgas FS",
                        "logo": "https://media-1.api-sports.io/football/teams/4160.png"
                    },
                    "player": {
                        "id": 45892,
                        "name": "A. Ilic"
                    },
                    "assist": {
                        "id": 72373,
                        "name": "C. Kouadio"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1010556,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 4293,
                    "name": "Het Pierre Cornelisstadion",
                    "city": "Aalst"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 4
                }
            },
            "league": {
                "id": 146,
                "name": "Super League Women",
                "country": "Belgium",
                "logo": "https://media-3.api-sports.io/football/leagues/146.png",
                "flag": "https://media-1.api-sports.io/flags/be.svg",
                "season": 2022,
                "round": "Lower Table Round - 10"
            },
            "teams": {
                "home": {
                    "id": 14037,
                    "name": "Eendracht Aalst W",
                    "logo": "https://media-2.api-sports.io/football/teams/14037.png",
                    "winner": null
                },
                "away": {
                    "id": 14034,
                    "name": "White Star Woluwe W",
                    "logo": "https://media-2.api-sports.io/football/teams/14034.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1017514,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1800,
                    "name": "Igralište NK Kustošija",
                    "city": "Zagreb"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 211,
                "name": "First NL",
                "country": "Croatia",
                "logo": "https://media-1.api-sports.io/football/leagues/211.png",
                "flag": "https://media-3.api-sports.io/flags/hr.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 6255,
                    "name": "Dubrava Zagreb",
                    "logo": "https://media-1.api-sports.io/football/teams/6255.png",
                    "winner": null
                },
                "away": {
                    "id": 1019,
                    "name": "Rudes",
                    "logo": "https://media-1.api-sports.io/football/teams/1019.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 1019,
                        "name": "Rudes",
                        "logo": "https://media-3.api-sports.io/football/teams/1019.png"
                    },
                    "player": {
                        "id": 14508,
                        "name": "A. Borsic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 6255,
                        "name": "Dubrava Zagreb",
                        "logo": "https://media-2.api-sports.io/football/teams/6255.png"
                    },
                    "player": {
                        "id": null,
                        "name": "P. Agba"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 1019,
                        "name": "Rudes",
                        "logo": "https://media-1.api-sports.io/football/teams/1019.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1021935,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 4512,
                    "name": "Vanløse IP",
                    "city": "Vanløse"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 7
                }
            },
            "league": {
                "id": 862,
                "name": "3. Division",
                "country": "Denmark",
                "logo": "https://media-3.api-sports.io/football/leagues/862.png",
                "flag": "https://media-3.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Promotion Group - 5"
            },
            "teams": {
                "home": {
                    "id": 6065,
                    "name": "Vanløse",
                    "logo": "https://media-1.api-sports.io/football/teams/6065.png",
                    "winner": null
                },
                "away": {
                    "id": 8634,
                    "name": "FA 2000",
                    "logo": "https://media-1.api-sports.io/football/teams/8634.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1022410,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 4471,
                    "name": "Østerbro Stadion",
                    "city": "København"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 122,
                "name": "2nd Division - Group 1",
                "country": "Denmark",
                "logo": "https://media-2.api-sports.io/football/leagues/122.png",
                "flag": "https://media-1.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Promotion Group - 5"
            },
            "teams": {
                "home": {
                    "id": 6009,
                    "name": "B 93",
                    "logo": "https://media-2.api-sports.io/football/teams/6009.png",
                    "winner": false
                },
                "away": {
                    "id": 4676,
                    "name": "Kolding IF",
                    "logo": "https://media-3.api-sports.io/football/teams/4676.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 3
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 6009,
                        "name": "B 93",
                        "logo": "https://media-2.api-sports.io/football/teams/6009.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Petersen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 4676,
                        "name": "Kolding IF",
                        "logo": "https://media-1.api-sports.io/football/teams/4676.png"
                    },
                    "player": {
                        "id": null,
                        "name": "P. Ngongo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 4676,
                        "name": "Kolding IF",
                        "logo": "https://media-3.api-sports.io/football/teams/4676.png"
                    },
                    "player": {
                        "id": 28738,
                        "name": "T. Mikkelsen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 4676,
                        "name": "Kolding IF",
                        "logo": "https://media-3.api-sports.io/football/teams/4676.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1023512,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 1727,
                    "name": "Sportpark Höhenberg",
                    "city": "Köln"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 488,
                "name": "U19 Bundesliga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/488.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Special Stage - League B - 2"
            },
            "teams": {
                "home": {
                    "id": 10276,
                    "name": "Viktoria Köln U19",
                    "logo": "https://media-3.api-sports.io/football/teams/10276.png",
                    "winner": true
                },
                "away": {
                    "id": 19445,
                    "name": "Reutlingen U19",
                    "logo": "https://media-3.api-sports.io/football/teams/19445.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 10276,
                        "name": "Viktoria Köln U19",
                        "logo": "https://media-2.api-sports.io/football/teams/10276.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 10276,
                        "name": "Viktoria Köln U19",
                        "logo": "https://media-1.api-sports.io/football/teams/10276.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 10276,
                        "name": "Viktoria Köln U19",
                        "logo": "https://media-2.api-sports.io/football/teams/10276.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1024713,
                "referee": "Ulrich Tomas, Czech Republic",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2493,
                    "name": "Stadion u Nisy",
                    "city": "Liberec"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 345,
                "name": "Czech Liga",
                "country": "Czech-Republic",
                "logo": "https://media-1.api-sports.io/football/leagues/345.png",
                "flag": "https://media-1.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Middle Play-offs - Semi-finals"
            },
            "teams": {
                "home": {
                    "id": 782,
                    "name": "Slovan Liberec",
                    "logo": "https://media-2.api-sports.io/football/teams/782.png",
                    "winner": null
                },
                "away": {
                    "id": 3736,
                    "name": "České Budějovice",
                    "logo": "https://media-1.api-sports.io/football/teams/3736.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 3736,
                        "name": "České Budějovice",
                        "logo": "https://media-1.api-sports.io/football/teams/3736.png"
                    },
                    "player": {
                        "id": 330467,
                        "name": "Q. Adediran"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Roughing"
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 782,
                        "name": "Slovan Liberec",
                        "logo": "https://media-2.api-sports.io/football/teams/782.png"
                    },
                    "player": {
                        "id": 66012,
                        "name": "D. Plechaty"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Var",
                    "detail": "Goal Disallowed - offside",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1024715,
                "referee": "Michael Kvitek, Czech Republic",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2494,
                    "name": "Lokotrans Aréna",
                    "city": "Mladá Boleslav"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 345,
                "name": "Czech Liga",
                "country": "Czech-Republic",
                "logo": "https://media-1.api-sports.io/football/leagues/345.png",
                "flag": "https://media-1.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Middle Play-offs - Semi-finals"
            },
            "teams": {
                "home": {
                    "id": 3723,
                    "name": "Hradec Králové",
                    "logo": "https://media-3.api-sports.io/football/teams/3723.png",
                    "winner": true
                },
                "away": {
                    "id": 640,
                    "name": "Mlada Boleslav",
                    "logo": "https://media-2.api-sports.io/football/teams/640.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 3723,
                        "name": "Hradec Králové",
                        "logo": "https://media-1.api-sports.io/football/teams/3723.png"
                    },
                    "player": {
                        "id": 66743,
                        "name": "F. Kubala"
                    },
                    "assist": {
                        "id": 66288,
                        "name": "P. Dvorak"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 640,
                        "name": "Mlada Boleslav",
                        "logo": "https://media-1.api-sports.io/football/teams/640.png"
                    },
                    "player": {
                        "id": 415620,
                        "name": "D. Kaulfus"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Var",
                    "detail": "Goal Disallowed - offside",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 3723,
                        "name": "Hradec Králové",
                        "logo": "https://media-2.api-sports.io/football/teams/3723.png"
                    },
                    "player": {
                        "id": 66146,
                        "name": "M. Koubek"
                    },
                    "assist": {
                        "id": 66383,
                        "name": "F. Novotny"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 28,
                        "extra": null
                    },
                    "team": {
                        "id": 3723,
                        "name": "Hradec Králové",
                        "logo": "https://media-3.api-sports.io/football/teams/3723.png"
                    },
                    "player": {
                        "id": 66659,
                        "name": "D. Vasulin"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 3723,
                        "name": "Hradec Králové",
                        "logo": "https://media-1.api-sports.io/football/teams/3723.png"
                    },
                    "player": {
                        "id": 66243,
                        "name": "J. Klima"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Unsportsmanlike conduct"
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 640,
                        "name": "Mlada Boleslav",
                        "logo": "https://media-3.api-sports.io/football/teams/640.png"
                    },
                    "player": {
                        "id": 272145,
                        "name": "L. Masek"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Tripping"
                }
            ]
        },
        {
            "fixture": {
                "id": 1024719,
                "referee": "Marek Radina, Czech Republic",
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 438,
                    "name": "Doosan Aréna",
                    "city": "Plzeň"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 345,
                "name": "Czech Liga",
                "country": "Czech-Republic",
                "logo": "https://media-1.api-sports.io/football/leagues/345.png",
                "flag": "https://media-1.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Championship Round - 2"
            },
            "teams": {
                "home": {
                    "id": 567,
                    "name": "Plzen",
                    "logo": "https://media-2.api-sports.io/football/teams/567.png",
                    "winner": null
                },
                "away": {
                    "id": 2250,
                    "name": "Sigma Olomouc",
                    "logo": "https://media-1.api-sports.io/football/teams/2250.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 567,
                        "name": "Plzen",
                        "logo": "https://media-2.api-sports.io/football/teams/567.png"
                    },
                    "player": {
                        "id": 61222,
                        "name": "F. Kasa"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Var",
                    "detail": "Goal Disallowed - Foul",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 567,
                        "name": "Plzen",
                        "logo": "https://media-2.api-sports.io/football/teams/567.png"
                    },
                    "player": {
                        "id": 818,
                        "name": "T. Chory"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Elbowing"
                },
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 567,
                        "name": "Plzen",
                        "logo": "https://media-1.api-sports.io/football/teams/567.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Bilek"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 2250,
                        "name": "Sigma Olomouc",
                        "logo": "https://media-2.api-sports.io/football/teams/2250.png"
                    },
                    "player": {
                        "id": 210180,
                        "name": "D. Israel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Foul"
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 2250,
                        "name": "Sigma Olomouc",
                        "logo": "https://media-3.api-sports.io/football/teams/2250.png"
                    },
                    "player": {
                        "id": 66403,
                        "name": "L. Vrastil"
                    },
                    "assist": {
                        "id": 66427,
                        "name": "J. Pokorny"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1024758,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2770,
                    "name": "Stadio Comunale Franco Scoglio",
                    "city": "Messina"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 975,
                "name": "Serie C - Relegation - Play-offs",
                "country": "Italy",
                "logo": "https://media-1.api-sports.io/football/leagues/975.png",
                "flag": "https://media-3.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Relegation Play-offs - Finals"
            },
            "teams": {
                "home": {
                    "id": 898,
                    "name": "Messina",
                    "logo": "https://media-2.api-sports.io/football/teams/898.png",
                    "winner": null
                },
                "away": {
                    "id": 9544,
                    "name": "Gelbison",
                    "logo": "https://media-3.api-sports.io/football/teams/9544.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 12,
                        "extra": null
                    },
                    "team": {
                        "id": 9544,
                        "name": "Gelbison",
                        "logo": "https://media-3.api-sports.io/football/teams/9544.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Gilli"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 9544,
                        "name": "Gelbison",
                        "logo": "https://media-3.api-sports.io/football/teams/9544.png"
                    },
                    "player": {
                        "id": 767,
                        "name": "R. Cargnelutti"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1024896,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 2838,
                    "name": "Stadion Spartak",
                    "city": "Nal'chik"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 35
                }
            },
            "league": {
                "id": 651,
                "name": "Second League - Group 1",
                "country": "Russia",
                "logo": "https://media-3.api-sports.io/football/leagues/651.png",
                "flag": "https://media-2.api-sports.io/flags/ru.svg",
                "season": 2022,
                "round": "Group 1 - 2nd Phase - 2"
            },
            "teams": {
                "home": {
                    "id": 2002,
                    "name": "Spartak Nalchik",
                    "logo": "https://media-2.api-sports.io/football/teams/2002.png",
                    "winner": true
                },
                "away": {
                    "id": 6798,
                    "name": "Druzhba",
                    "logo": "https://media-2.api-sports.io/football/teams/6798.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 7,
                        "extra": null
                    },
                    "team": {
                        "id": 6798,
                        "name": "Druzhba",
                        "logo": "https://media-1.api-sports.io/football/teams/6798.png"
                    },
                    "player": {
                        "id": null,
                        "name": "I. Orazaev"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 2002,
                        "name": "Spartak Nalchik",
                        "logo": "https://media-1.api-sports.io/football/teams/2002.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Khachirov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1024897,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 4974,
                    "name": "Central'nyj Stadion Mashuk",
                    "city": "Pyatigorsk"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 36
                }
            },
            "league": {
                "id": 651,
                "name": "Second League - Group 1",
                "country": "Russia",
                "logo": "https://media-3.api-sports.io/football/leagues/651.png",
                "flag": "https://media-2.api-sports.io/flags/ru.svg",
                "season": 2022,
                "round": "Group 1 - 2nd Phase - 2"
            },
            "teams": {
                "home": {
                    "id": 6814,
                    "name": "Mashuk-KMV",
                    "logo": "https://media-2.api-sports.io/football/teams/6814.png",
                    "winner": true
                },
                "away": {
                    "id": 6796,
                    "name": "Dinamo Stavropol",
                    "logo": "https://media-1.api-sports.io/football/teams/6796.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 6814,
                        "name": "Mashuk-KMV",
                        "logo": "https://media-3.api-sports.io/football/teams/6814.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Naniev"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1025285,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 4011,
                    "name": "Campo Sportivo di Acquaviva",
                    "city": "Acquaviva"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 33
                }
            },
            "league": {
                "id": 404,
                "name": "Campionato",
                "country": "San-Marino",
                "logo": "https://media-1.api-sports.io/football/leagues/404.png",
                "flag": "https://media-3.api-sports.io/flags/sm.svg",
                "season": 2022,
                "round": "Conference League Play-offs - Semi-finals"
            },
            "teams": {
                "home": {
                    "id": 2249,
                    "name": "La Fiorita",
                    "logo": "https://media-3.api-sports.io/football/teams/2249.png",
                    "winner": null
                },
                "away": {
                    "id": 5308,
                    "name": "Virtus",
                    "logo": "https://media-3.api-sports.io/football/teams/5308.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 2249,
                        "name": "La Fiorita",
                        "logo": "https://media-1.api-sports.io/football/teams/2249.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Russo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 5308,
                        "name": "Virtus",
                        "logo": "https://media-2.api-sports.io/football/teams/5308.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Fatica"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1026344,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 12292,
                    "name": "Sportstätten auf dem Quintinsberg",
                    "city": "Karbach"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 5
                }
            },
            "league": {
                "id": 988,
                "name": "Oberliga - Promotion Round",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/988.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Rh/Pf/S - Promotion Round - 8"
            },
            "teams": {
                "home": {
                    "id": 16112,
                    "name": "Karbach",
                    "logo": "https://media-3.api-sports.io/football/teams/16112.png",
                    "winner": null
                },
                "away": {
                    "id": 14724,
                    "name": "Mechtersheim",
                    "logo": "https://media-2.api-sports.io/football/teams/14724.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1026345,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:30:00+00:00",
                "timestamp": 1683984600,
                "periods": {
                    "first": 1683984600,
                    "second": null
                },
                "venue": {
                    "id": 8123,
                    "name": "Stadion am Wasserturm",
                    "city": "Neuwied"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 1
                }
            },
            "league": {
                "id": 988,
                "name": "Oberliga - Promotion Round",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/988.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Rh/Pf/S - Promotion Round - 8"
            },
            "teams": {
                "home": {
                    "id": 12767,
                    "name": "FV Engers 07",
                    "logo": "https://media-1.api-sports.io/football/teams/12767.png",
                    "winner": null
                },
                "away": {
                    "id": 14655,
                    "name": "Diefflen",
                    "logo": "https://media-1.api-sports.io/football/teams/14655.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1026580,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3946,
                    "name": "Luveve Stadium",
                    "city": "Bulawayo"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 38
                }
            },
            "league": {
                "id": 401,
                "name": "Premier Soccer League",
                "country": "Zimbabwe",
                "logo": "https://media-3.api-sports.io/football/leagues/401.png",
                "flag": "https://media-1.api-sports.io/flags/zw.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 5217,
                    "name": "Bulawayo Chiefs",
                    "logo": "https://media-3.api-sports.io/football/teams/5217.png",
                    "winner": true
                },
                "away": {
                    "id": 21054,
                    "name": "Sheasham",
                    "logo": "https://media-1.api-sports.io/football/teams/21054.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 5217,
                        "name": "Bulawayo Chiefs",
                        "logo": "https://media-1.api-sports.io/football/teams/5217.png"
                    },
                    "player": {
                        "id": null,
                        "name": "B. Veremu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1026581,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3953,
                    "name": "Gibbo Stadium",
                    "city": "Triangle"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 34
                }
            },
            "league": {
                "id": 401,
                "name": "Premier Soccer League",
                "country": "Zimbabwe",
                "logo": "https://media-3.api-sports.io/football/leagues/401.png",
                "flag": "https://media-1.api-sports.io/flags/zw.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 5227,
                    "name": "Manica Diamonds",
                    "logo": "https://media-1.api-sports.io/football/teams/5227.png",
                    "winner": null
                },
                "away": {
                    "id": 5220,
                    "name": "Chicken Inn",
                    "logo": "https://media-1.api-sports.io/football/teams/5220.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1026897,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T13:00:00+00:00",
                "timestamp": 1683982800,
                "periods": {
                    "first": 1683982800,
                    "second": null
                },
                "venue": {
                    "id": 3889,
                    "name": "Phnom Penh National Olympic Stadium",
                    "city": "Phnom Penh"
                },
                "status": {
                    "long": "First Half",
                    "short": "1H",
                    "elapsed": 37
                }
            },
            "league": {
                "id": 911,
                "name": "Southeast Asian Games",
                "country": "World",
                "logo": "https://media-1.api-sports.io/football/leagues/911.png",
                "flag": null,
                "season": 2023,
                "round": "Semi-finals"
            },
            "teams": {
                "home": {
                    "id": 21227,
                    "name": "Thailand U22",
                    "logo": "https://media-3.api-sports.io/football/teams/21227.png",
                    "winner": null
                },
                "away": {
                    "id": 21225,
                    "name": "Myanmar U22",
                    "logo": "https://media-1.api-sports.io/football/teams/21225.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 878281,
                "referee": "Jorge Figueroa Vazquez, Spain",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 1491,
                    "name": "Reale Arena",
                    "city": "Donostia-San Sebastián"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 140,
                "name": "La Liga",
                "country": "Spain",
                "logo": "https://media-2.api-sports.io/football/leagues/140.png",
                "flag": "https://media-2.api-sports.io/flags/es.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 548,
                    "name": "Real Sociedad",
                    "logo": "https://media-3.api-sports.io/football/teams/548.png",
                    "winner": null
                },
                "away": {
                    "id": 547,
                    "name": "Girona",
                    "logo": "https://media-3.api-sports.io/football/teams/547.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-2.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 47323,
                        "name": "M. Oyarzabal"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 11,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-3.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 47314,
                        "name": "I. Zubeldia"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Holding"
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-1.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 634,
                        "name": "D. Silva"
                    },
                    "assist": {
                        "id": 32862,
                        "name": "T. Kubo"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 37,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-2.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 197448,
                        "name": "Y. Couto"
                    },
                    "assist": {
                        "id": 2182,
                        "name": "V. Tsygankov"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 38,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-2.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 47301,
                        "name": "R. Le Normand"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Roughing"
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 3
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-2.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 2617,
                        "name": "C. Stuani"
                    },
                    "assist": {
                        "id": 136117,
                        "name": "R. Riquelme"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 49,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-1.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 18949,
                        "name": "O. Romeu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Tripping"
                },
                {
                    "time": {
                        "elapsed": 55,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-3.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 283668,
                        "name": "A. Martinez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Tripping"
                },
                {
                    "time": {
                        "elapsed": 60,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-2.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 162032,
                        "name": "M. Gutierrez"
                    },
                    "assist": {
                        "id": 46849,
                        "name": "J. Hernandez"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-2.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 47323,
                        "name": "M. Oyarzabal"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": "Diving"
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-3.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 182546,
                        "name": "J. Pacheco"
                    },
                    "assist": {
                        "id": 47323,
                        "name": "M. Oyarzabal"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 548,
                        "name": "Real Sociedad",
                        "logo": "https://media-3.api-sports.io/football/teams/548.png"
                    },
                    "player": {
                        "id": 47317,
                        "name": "A. Barrenetxea"
                    },
                    "assist": {
                        "id": 47314,
                        "name": "I. Zubeldia"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-1.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 10166,
                        "name": "Reinier"
                    },
                    "assist": {
                        "id": 2617,
                        "name": "C. Stuani"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 547,
                        "name": "Girona",
                        "logo": "https://media-3.api-sports.io/football/teams/547.png"
                    },
                    "player": {
                        "id": 327628,
                        "name": "R. Artero"
                    },
                    "assist": {
                        "id": 197448,
                        "name": "Y. Couto"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879048,
                "referee": "Emil Ristoskov, Austria",
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 3250,
                    "name": "Stadion Birkenwiese",
                    "city": "Dornbirn"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 52
                }
            },
            "league": {
                "id": 219,
                "name": "2. Liga",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/219.png",
                "flag": "https://media-3.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 4255,
                    "name": "Dornbirn",
                    "logo": "https://media-3.api-sports.io/football/teams/4255.png",
                    "winner": null
                },
                "away": {
                    "id": 1023,
                    "name": "Admira Wacker",
                    "logo": "https://media-2.api-sports.io/football/teams/1023.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 1023,
                        "name": "Admira Wacker",
                        "logo": "https://media-1.api-sports.io/football/teams/1023.png"
                    },
                    "player": {
                        "id": 202911,
                        "name": "N. Keckeisen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 4255,
                        "name": "Dornbirn",
                        "logo": "https://media-3.api-sports.io/football/teams/4255.png"
                    },
                    "player": {
                        "id": 264512,
                        "name": "F. Kerber"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 1023,
                        "name": "Admira Wacker",
                        "logo": "https://media-3.api-sports.io/football/teams/1023.png"
                    },
                    "player": {
                        "id": 355216,
                        "name": "J. Tranziska"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 1023,
                        "name": "Admira Wacker",
                        "logo": "https://media-3.api-sports.io/football/teams/1023.png"
                    },
                    "player": {
                        "id": 355216,
                        "name": "J. Tranziska"
                    },
                    "assist": {
                        "id": 271287,
                        "name": "A. Gattermayer"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 4255,
                        "name": "Dornbirn",
                        "logo": "https://media-2.api-sports.io/football/teams/4255.png"
                    },
                    "player": {
                        "id": 264512,
                        "name": "F. Kerber"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879051,
                "referee": "Gabriel Gmeiner, Austria",
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 145,
                    "name": "Allianz Stadion",
                    "city": "Wien"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 49
                }
            },
            "league": {
                "id": 219,
                "name": "2. Liga",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/219.png",
                "flag": "https://media-3.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 8247,
                    "name": "Rapid Wien II",
                    "logo": "https://media-2.api-sports.io/football/teams/8247.png",
                    "winner": null
                },
                "away": {
                    "id": 1400,
                    "name": "FC Liefering",
                    "logo": "https://media-3.api-sports.io/football/teams/1400.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 7,
                        "extra": null
                    },
                    "team": {
                        "id": 8247,
                        "name": "Rapid Wien II",
                        "logo": "https://media-3.api-sports.io/football/teams/8247.png"
                    },
                    "player": {
                        "id": 7470,
                        "name": "F. Eggenfellner"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 8247,
                        "name": "Rapid Wien II",
                        "logo": "https://media-2.api-sports.io/football/teams/8247.png"
                    },
                    "player": {
                        "id": 372584,
                        "name": "N. Lang"
                    },
                    "assist": {
                        "id": 339922,
                        "name": "F. Dursun"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879462,
                "referee": "Robin Braun, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 753,
                    "name": "BRITA-Arena",
                    "city": "Wiesbaden"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 1319,
                    "name": "SV Wehen",
                    "logo": "https://media-2.api-sports.io/football/teams/1319.png",
                    "winner": true
                },
                "away": {
                    "id": 4265,
                    "name": "Verl",
                    "logo": "https://media-3.api-sports.io/football/teams/4265.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-2.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 203160,
                        "name": "B. Ezeh"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-2.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 177685,
                        "name": "B. Pernot"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 14,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-2.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 90694,
                        "name": "K. Froese"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 20,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-1.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 25056,
                        "name": "J. Wurtz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-3.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 24956,
                        "name": "P. Kammerbauer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-3.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 177685,
                        "name": "B. Pernot"
                    },
                    "assist": {
                        "id": 88126,
                        "name": "M. Corboz"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-1.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 24923,
                        "name": "F. Carstens"
                    },
                    "assist": {
                        "id": 25912,
                        "name": "A. Gurleyen"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-1.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 25092,
                        "name": "D. Kempe"
                    },
                    "assist": {
                        "id": 203160,
                        "name": "B. Ezeh"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-2.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 25580,
                        "name": "N. Rieble"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 1319,
                        "name": "SV Wehen",
                        "logo": "https://media-2.api-sports.io/football/teams/1319.png"
                    },
                    "player": {
                        "id": 14605,
                        "name": "I. Prtajin"
                    },
                    "assist": {
                        "id": 25092,
                        "name": "D. Kempe"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-3.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 260953,
                        "name": "J. Tugbenyo"
                    },
                    "assist": {
                        "id": 24956,
                        "name": "P. Kammerbauer"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-2.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 203052,
                        "name": "E. Probst"
                    },
                    "assist": {
                        "id": 26289,
                        "name": "Y. Otto"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-2.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-2.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 161940,
                        "name": "J. Wosz"
                    },
                    "assist": {
                        "id": 87801,
                        "name": "J. Grodowski"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 4265,
                        "name": "Verl",
                        "logo": "https://media-2.api-sports.io/football/teams/4265.png"
                    },
                    "player": {
                        "id": 26637,
                        "name": "N. Sessa"
                    },
                    "assist": {
                        "id": 90756,
                        "name": "T. Knost"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879466,
                "referee": "Patrick Kessel, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 3263,
                    "name": "Carl-Benz-Stadion",
                    "city": "Mannheim"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 4268,
                    "name": "Waldhof Mannheim",
                    "logo": "https://media-1.api-sports.io/football/teams/4268.png",
                    "winner": false
                },
                "away": {
                    "id": 9347,
                    "name": "VfB Oldenburg",
                    "logo": "https://media-3.api-sports.io/football/teams/9347.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-3.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 1823,
                        "name": "M. Stendera"
                    },
                    "assist": {
                        "id": 342133,
                        "name": "L. Schafer"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-2.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 24901,
                        "name": "O. Steurer"
                    },
                    "assist": {
                        "id": 26170,
                        "name": "M. Starke"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-1.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 125704,
                        "name": "A. Lebeau"
                    },
                    "assist": {
                        "id": 24908,
                        "name": "M. Schnatterer"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-2.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 24901,
                        "name": "O. Steurer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 1
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-1.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 26354,
                        "name": "B. B. Bahn H."
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-2.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 87935,
                        "name": "M. Wegner"
                    },
                    "assist": {
                        "id": 177348,
                        "name": "P. Hasenhuttl"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-3.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 122331,
                        "name": "A. Malachowski"
                    },
                    "assist": {
                        "id": 87944,
                        "name": "M. Karbstein"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 47,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-3.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 125704,
                        "name": "A. Lebeau"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-2.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 25498,
                        "name": "N. Knystock"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-2.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 24802,
                        "name": "M. Hoger"
                    },
                    "assist": {
                        "id": 26354,
                        "name": "B. B. Bahn H."
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-2.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 24856,
                        "name": "B. Taz"
                    },
                    "assist": {
                        "id": 202614,
                        "name": "M. Winkler"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-1.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 122331,
                        "name": "A. Malachowski"
                    },
                    "assist": {
                        "id": 125704,
                        "name": "A. Lebeau"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 4268,
                        "name": "Waldhof Mannheim",
                        "logo": "https://media-1.api-sports.io/football/teams/4268.png"
                    },
                    "player": {
                        "id": 90679,
                        "name": "M. Seegert"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-3.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 90771,
                        "name": "R. Brand"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 9347,
                        "name": "VfB Oldenburg",
                        "logo": "https://media-3.api-sports.io/football/teams/9347.png"
                    },
                    "player": {
                        "id": 90931,
                        "name": "L. Deichmann"
                    },
                    "assist": {
                        "id": 342133,
                        "name": "L. Schafer"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879468,
                "referee": "Benjamin Brand, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 758,
                    "name": "GGZ Arena",
                    "city": "Zwickau"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 66
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 1315,
                    "name": "FSV Zwickau",
                    "logo": "https://media-3.api-sports.io/football/teams/1315.png",
                    "winner": false
                },
                "away": {
                    "id": 183,
                    "name": "Dynamo Dresden",
                    "logo": "https://media-1.api-sports.io/football/teams/183.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 1315,
                        "name": "FSV Zwickau",
                        "logo": "https://media-2.api-sports.io/football/teams/1315.png"
                    },
                    "player": {
                        "id": 177441,
                        "name": "C. Coskun"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 183,
                        "name": "Dynamo Dresden",
                        "logo": "https://media-1.api-sports.io/football/teams/183.png"
                    },
                    "player": {
                        "id": 24800,
                        "name": "N. Hauptmann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 183,
                        "name": "Dynamo Dresden",
                        "logo": "https://media-2.api-sports.io/football/teams/183.png"
                    },
                    "player": {
                        "id": 24800,
                        "name": "N. Hauptmann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 39,
                        "extra": null
                    },
                    "team": {
                        "id": 183,
                        "name": "Dynamo Dresden",
                        "logo": "https://media-1.api-sports.io/football/teams/183.png"
                    },
                    "player": {
                        "id": 520,
                        "name": "P. Will"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 1315,
                        "name": "FSV Zwickau",
                        "logo": "https://media-2.api-sports.io/football/teams/1315.png"
                    },
                    "player": {
                        "id": 25817,
                        "name": "J. Lohmannsroben"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 1315,
                        "name": "FSV Zwickau",
                        "logo": "https://media-1.api-sports.io/football/teams/1315.png"
                    },
                    "player": {
                        "id": 177679,
                        "name": "Y. Moker"
                    },
                    "assist": {
                        "id": 25817,
                        "name": "J. Lohmannsroben"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 1315,
                        "name": "FSV Zwickau",
                        "logo": "https://media-1.api-sports.io/football/teams/1315.png"
                    },
                    "player": {
                        "id": 273721,
                        "name": "Y. Voigt"
                    },
                    "assist": {
                        "id": 177441,
                        "name": "C. Coskun"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 183,
                        "name": "Dynamo Dresden",
                        "logo": "https://media-2.api-sports.io/football/teams/183.png"
                    },
                    "player": {
                        "id": 162119,
                        "name": "D. Borkowski"
                    },
                    "assist": {
                        "id": 88029,
                        "name": "A. Arslan"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 183,
                        "name": "Dynamo Dresden",
                        "logo": "https://media-3.api-sports.io/football/teams/183.png"
                    },
                    "player": {
                        "id": 178084,
                        "name": "J. Lemmer"
                    },
                    "assist": {
                        "id": 64302,
                        "name": "C. Conteh"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879469,
                "referee": "Wolfgang Haslberger, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 11930,
                    "name": "Stadion Ludwigspark",
                    "city": "Saarbrücken"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 1639,
                    "name": "FC Saarbrucken",
                    "logo": "https://media-2.api-sports.io/football/teams/1639.png",
                    "winner": true
                },
                "away": {
                    "id": 1316,
                    "name": "Hallescher FC",
                    "logo": "https://media-3.api-sports.io/football/teams/1316.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": 25128,
                        "name": "E. Berko"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 12,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-3.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": 7707,
                        "name": "B. Thoelke"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": 120390,
                        "name": "A. Casar"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-1.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": 26502,
                        "name": "A. Grimaldi"
                    },
                    "assist": {
                        "id": 26502,
                        "name": "A. Grimaldi"
                    },
                    "type": "Goal",
                    "detail": "Missed Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 37,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": 26351,
                        "name": "N. Landgraf"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-2.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": 24942,
                        "name": "R. Neudecker"
                    },
                    "assist": {
                        "id": 26502,
                        "name": "A. Grimaldi"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-1.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": 25095,
                        "name": "C. Rizzuto"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": 91179,
                        "name": "J. Vollert"
                    },
                    "assist": {
                        "id": 178091,
                        "name": "N. Hug"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": 26516,
                        "name": "A. Winkler"
                    },
                    "assist": {
                        "id": 26351,
                        "name": "N. Landgraf"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-3.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": 26593,
                        "name": "D. Ernst"
                    },
                    "assist": {
                        "id": 25095,
                        "name": "C. Rizzuto"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 1639,
                        "name": "FC Saarbrucken",
                        "logo": "https://media-3.api-sports.io/football/teams/1639.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Cuni"
                    },
                    "assist": {
                        "id": 26502,
                        "name": "A. Grimaldi"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 1316,
                        "name": "Hallescher FC",
                        "logo": "https://media-1.api-sports.io/football/teams/1316.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Loder"
                    },
                    "assist": {
                        "id": 25128,
                        "name": "E. Berko"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879470,
                "referee": "Timo Gerach, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 12274,
                    "name": "Dreisamstadion",
                    "city": "Freiburg im Breisgau"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 80
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 9363,
                    "name": "Freiburg II",
                    "logo": "https://media-2.api-sports.io/football/teams/9363.png",
                    "winner": true
                },
                "away": {
                    "id": 1660,
                    "name": "SV Elversberg",
                    "logo": "https://media-3.api-sports.io/football/teams/1660.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 9363,
                        "name": "Freiburg II",
                        "logo": "https://media-3.api-sports.io/football/teams/9363.png"
                    },
                    "player": {
                        "id": 202783,
                        "name": "L. Kehl"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 1660,
                        "name": "SV Elversberg",
                        "logo": "https://media-3.api-sports.io/football/teams/1660.png"
                    },
                    "player": {
                        "id": 287932,
                        "name": "B. Bobzien"
                    },
                    "assist": {
                        "id": 125712,
                        "name": "J. Rochelt"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 9363,
                        "name": "Freiburg II",
                        "logo": "https://media-2.api-sports.io/football/teams/9363.png"
                    },
                    "player": {
                        "id": 178117,
                        "name": "P. Lienhard"
                    },
                    "assist": {
                        "id": 202738,
                        "name": "J. Stark"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 9363,
                        "name": "Freiburg II",
                        "logo": "https://media-3.api-sports.io/football/teams/9363.png"
                    },
                    "player": {
                        "id": 280023,
                        "name": "P. Fahrner"
                    },
                    "assist": {
                        "id": 89489,
                        "name": "A. Hoti"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 9363,
                        "name": "Freiburg II",
                        "logo": "https://media-2.api-sports.io/football/teams/9363.png"
                    },
                    "player": {
                        "id": 202783,
                        "name": "L. Kehl"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 76,
                        "extra": null
                    },
                    "team": {
                        "id": 1660,
                        "name": "SV Elversberg",
                        "logo": "https://media-2.api-sports.io/football/teams/1660.png"
                    },
                    "player": {
                        "id": 177731,
                        "name": "L. Pinckert"
                    },
                    "assist": {
                        "id": 143831,
                        "name": "R. Fellhauer"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 76,
                        "extra": null
                    },
                    "team": {
                        "id": 1660,
                        "name": "SV Elversberg",
                        "logo": "https://media-3.api-sports.io/football/teams/1660.png"
                    },
                    "player": {
                        "id": 25718,
                        "name": "S. Tekerci"
                    },
                    "assist": {
                        "id": 25320,
                        "name": "T. Jacobsen"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879471,
                "referee": "Richard Hempel, Germany",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6433,
                    "name": "Hans-Walter-Wild-Stadion",
                    "city": "Bayreuth"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 75
                }
            },
            "league": {
                "id": 80,
                "name": "3. Liga",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/80.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 9325,
                    "name": "Bayreuth",
                    "logo": "https://media-1.api-sports.io/football/teams/9325.png",
                    "winner": false
                },
                "away": {
                    "id": 1620,
                    "name": "FC Viktoria Koln",
                    "logo": "https://media-1.api-sports.io/football/teams/1620.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-1.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 177478,
                        "name": "E. Schwarz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 28,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-3.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 177462,
                        "name": "M. Thomann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-2.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 177478,
                        "name": "E. Schwarz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 38,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-3.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 282087,
                        "name": "S. Hong"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 2
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-1.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 26523,
                        "name": "L. Marseiler"
                    },
                    "assist": {
                        "id": 26062,
                        "name": "P. Koronkiewicz"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-2.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 25162,
                        "name": "D. Steininger"
                    },
                    "assist": {
                        "id": 177462,
                        "name": "M. Thomann"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-1.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 319845,
                        "name": "N. Moos"
                    },
                    "assist": {
                        "id": 90732,
                        "name": "S. Eder"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-1.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 178037,
                        "name": "L. Petzold"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 55,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-2.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 91068,
                        "name": "A. Becker"
                    },
                    "assist": {
                        "id": 202988,
                        "name": "N. May"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 56,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-2.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 91068,
                        "name": "A. Becker"
                    },
                    "assist": {
                        "id": 202988,
                        "name": "N. May"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-3.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 25670,
                        "name": "S. Maderer"
                    },
                    "assist": {
                        "id": 26142,
                        "name": "M. Ziereis"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-2.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 26078,
                        "name": "M. Wunderlich"
                    },
                    "assist": {
                        "id": 26523,
                        "name": "L. Marseiler"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-3.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Meissner"
                    },
                    "assist": {
                        "id": 282087,
                        "name": "S. Hong"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-1.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 177369,
                        "name": "T. Latteier"
                    },
                    "assist": {
                        "id": 24857,
                        "name": "E. Zejnullahu"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 9325,
                        "name": "Bayreuth",
                        "logo": "https://media-3.api-sports.io/football/teams/9325.png"
                    },
                    "player": {
                        "id": 25537,
                        "name": "A. Diawusie"
                    },
                    "assist": {
                        "id": 25154,
                        "name": "B. Kirsch"
                    },
                    "type": "subst",
                    "detail": "Substitution 5",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-2.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": 24808,
                        "name": "M. Risse"
                    },
                    "assist": {
                        "id": 91068,
                        "name": "A. Becker"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 1620,
                        "name": "FC Viktoria Koln",
                        "logo": "https://media-1.api-sports.io/football/teams/1620.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 879716,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2497,
                    "name": "Stadion Juliska",
                    "city": "Praha"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 346,
                "name": "FNL",
                "country": "Czech-Republic",
                "logo": "https://media-2.api-sports.io/football/leagues/346.png",
                "flag": "https://media-2.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 3715,
                    "name": "Dukla Praha",
                    "logo": "https://media-3.api-sports.io/football/teams/3715.png",
                    "winner": false
                },
                "away": {
                    "id": 3716,
                    "name": "Karviná",
                    "logo": "https://media-2.api-sports.io/football/teams/3716.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 3716,
                        "name": "Karviná",
                        "logo": "https://media-1.api-sports.io/football/teams/3716.png"
                    },
                    "player": {
                        "id": 57260,
                        "name": "A. Akinyemi"
                    },
                    "assist": {
                        "id": null,
                        "name": "J. Malek"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-3.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": 66615,
                        "name": "M. Zapletal"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 3716,
                        "name": "Karviná",
                        "logo": "https://media-3.api-sports.io/football/teams/3716.png"
                    },
                    "player": {
                        "id": 66194,
                        "name": "L. Budinsky"
                    },
                    "assist": {
                        "id": 66194,
                        "name": "L. Budinsky"
                    },
                    "type": "Goal",
                    "detail": "Missed Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-1.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Hrubes"
                    },
                    "assist": {
                        "id": 80424,
                        "name": "M. Cervenka"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-2.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": 66555,
                        "name": "L. Buchvaldek"
                    },
                    "assist": {
                        "id": null,
                        "name": "S. Sebrle"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-3.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": 66497,
                        "name": "J. Piroch"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 3716,
                        "name": "Karviná",
                        "logo": "https://media-1.api-sports.io/football/teams/3716.png"
                    },
                    "player": {
                        "id": 40608,
                        "name": "D. Bartl"
                    },
                    "assist": {
                        "id": null,
                        "name": "D. Moses"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 3716,
                        "name": "Karviná",
                        "logo": "https://media-3.api-sports.io/football/teams/3716.png"
                    },
                    "player": {
                        "id": 57260,
                        "name": "A. Akinyemi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 73,
                        "extra": null
                    },
                    "team": {
                        "id": 3716,
                        "name": "Karviná",
                        "logo": "https://media-3.api-sports.io/football/teams/3716.png"
                    },
                    "player": {
                        "id": 57260,
                        "name": "A. Akinyemi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-3.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Ullman"
                    },
                    "assist": {
                        "id": 66358,
                        "name": "F. Havelka"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 3715,
                        "name": "Dukla Praha",
                        "logo": "https://media-3.api-sports.io/football/teams/3715.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Doudera"
                    },
                    "assist": {
                        "id": 66341,
                        "name": "P. Moulis"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 881584,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 1353,
                    "name": "Akhmat Arena",
                    "city": "Groznyi"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 236,
                "name": "First League",
                "country": "Russia",
                "logo": "https://media-1.api-sports.io/football/leagues/236.png",
                "flag": "https://media-3.api-sports.io/flags/ru.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 6787,
                    "name": "Alaniya Vladikavkaz",
                    "logo": "https://media-3.api-sports.io/football/teams/6787.png",
                    "winner": true
                },
                "away": {
                    "id": 2015,
                    "name": "Krasnodar 2",
                    "logo": "https://media-1.api-sports.io/football/teams/2015.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-1.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 417088,
                        "name": "V. Yarlykov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-1.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 417088,
                        "name": "V. Yarlykov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 38,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-2.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 43382,
                        "name": "K. Khosonov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 40,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-1.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 362565,
                        "name": "Z. Tarba"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 41,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-1.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 108492,
                        "name": "N. Giorgobiani"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 44,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-1.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 358558,
                        "name": "J. Okoronkwo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-1.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 108492,
                        "name": "N. Giorgobiani"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-3.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 306909,
                        "name": "R. Safronov"
                    },
                    "assist": {
                        "id": 308852,
                        "name": "M. Shtepa"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-3.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 43831,
                        "name": "D. Karpov"
                    },
                    "assist": {
                        "id": 359059,
                        "name": "K. Bogdanets"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-1.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 149571,
                        "name": "S. Kachmazov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-1.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 358888,
                        "name": "D. Kuchugura"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-2.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 7916,
                        "name": "A. Chochiev"
                    },
                    "assist": {
                        "id": 362565,
                        "name": "Z. Tarba"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 6787,
                        "name": "Alaniya Vladikavkaz",
                        "logo": "https://media-2.api-sports.io/football/teams/6787.png"
                    },
                    "player": {
                        "id": 116111,
                        "name": "A. Galoyan"
                    },
                    "assist": {
                        "id": 268958,
                        "name": "A. Mazurin"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-3.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 291773,
                        "name": "M. Bersnev"
                    },
                    "assist": {
                        "id": 43570,
                        "name": "M. Kutovoy"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-1.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 358947,
                        "name": "R. Zashchepkin"
                    },
                    "assist": {
                        "id": 43569,
                        "name": "R. Khalnazarov"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 2015,
                        "name": "Krasnodar 2",
                        "logo": "https://media-2.api-sports.io/football/teams/2015.png"
                    },
                    "player": {
                        "id": 358888,
                        "name": "D. Kuchugura"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 883387,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:15:00+00:00",
                "timestamp": 1683980100,
                "periods": {
                    "first": 1683980100,
                    "second": 1683983700
                },
                "venue": {
                    "id": 817,
                    "name": "Illovszky Rudolf Stadion",
                    "city": "Budapest"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 65
                }
            },
            "league": {
                "id": 271,
                "name": "NB I",
                "country": "Hungary",
                "logo": "https://media-3.api-sports.io/football/leagues/271.png",
                "flag": "https://media-2.api-sports.io/flags/hu.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 675,
                    "name": "Vasas",
                    "logo": "https://media-1.api-sports.io/football/teams/675.png",
                    "winner": null
                },
                "away": {
                    "id": 2414,
                    "name": "Zalaegerszegi TE",
                    "logo": "https://media-2.api-sports.io/football/teams/2414.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 2414,
                        "name": "Zalaegerszegi TE",
                        "logo": "https://media-3.api-sports.io/football/teams/2414.png"
                    },
                    "player": {
                        "id": 289517,
                        "name": "D. Nemeth"
                    },
                    "assist": {
                        "id": 198276,
                        "name": "B. Kovacs"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 28,
                        "extra": null
                    },
                    "team": {
                        "id": 675,
                        "name": "Vasas",
                        "logo": "https://media-3.api-sports.io/football/teams/675.png"
                    },
                    "player": {
                        "id": 2339,
                        "name": "Z. Berecz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 675,
                        "name": "Vasas",
                        "logo": "https://media-2.api-sports.io/football/teams/675.png"
                    },
                    "player": {
                        "id": 28431,
                        "name": "D. Cipf"
                    },
                    "assist": {
                        "id": 89022,
                        "name": "P. Hidi"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 675,
                        "name": "Vasas",
                        "logo": "https://media-1.api-sports.io/football/teams/675.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Hidi M"
                    },
                    "assist": {
                        "id": null,
                        "name": "K. Szilagyi"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 2414,
                        "name": "Zalaegerszegi TE",
                        "logo": "https://media-2.api-sports.io/football/teams/2414.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Ubochioma"
                    },
                    "assist": {
                        "id": 289517,
                        "name": "D. Nemeth"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 675,
                        "name": "Vasas",
                        "logo": "https://media-1.api-sports.io/football/teams/675.png"
                    },
                    "player": {
                        "id": 27836,
                        "name": "K. Hinora"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 885529,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": null,
                    "name": "Wienerwaldstadion",
                    "city": "Neulengbach"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 72
                }
            },
            "league": {
                "id": 484,
                "name": "Frauenliga",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/484.png",
                "flag": "https://media-1.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 10226,
                    "name": "Neulengbach W",
                    "logo": "https://media-3.api-sports.io/football/teams/10226.png",
                    "winner": true
                },
                "away": {
                    "id": 17576,
                    "name": "First Vienna W",
                    "logo": "https://media-1.api-sports.io/football/teams/17576.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 10226,
                        "name": "Neulengbach W",
                        "logo": "https://media-3.api-sports.io/football/teams/10226.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 10226,
                        "name": "Neulengbach W",
                        "logo": "https://media-2.api-sports.io/football/teams/10226.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 885532,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 3793,
                    "name": "Sportplatz FC Bergheim",
                    "city": "Bergheim"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 81
                }
            },
            "league": {
                "id": 484,
                "name": "Frauenliga",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/484.png",
                "flag": "https://media-1.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 10231,
                    "name": "Bergheim W",
                    "logo": "https://media-1.api-sports.io/football/teams/10231.png",
                    "winner": null
                },
                "away": {
                    "id": 10233,
                    "name": "Wacker Innsbruck W",
                    "logo": "https://media-1.api-sports.io/football/teams/10233.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 10233,
                        "name": "Wacker Innsbruck W",
                        "logo": "https://media-3.api-sports.io/football/teams/10233.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Krajinovic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 10231,
                        "name": "Bergheim W",
                        "logo": "https://media-3.api-sports.io/football/teams/10231.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Gierzinger"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 10231,
                        "name": "Bergheim W",
                        "logo": "https://media-1.api-sports.io/football/teams/10231.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Gierzinger"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 10233,
                        "name": "Wacker Innsbruck W",
                        "logo": "https://media-1.api-sports.io/football/teams/10233.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Hartlieb"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 885533,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": null,
                    "name": "Generali Arena - Platz 2",
                    "city": "Wien"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 63
                }
            },
            "league": {
                "id": 484,
                "name": "Frauenliga",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/484.png",
                "flag": "https://media-1.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 17575,
                    "name": "Austria Wien W",
                    "logo": "https://media-1.api-sports.io/football/teams/17575.png",
                    "winner": true
                },
                "away": {
                    "id": 10230,
                    "name": "Altenmarkt W",
                    "logo": "https://media-2.api-sports.io/football/teams/10230.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 12,
                        "extra": null
                    },
                    "team": {
                        "id": 17575,
                        "name": "Austria Wien W",
                        "logo": "https://media-1.api-sports.io/football/teams/17575.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Kunina"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 17575,
                        "name": "Austria Wien W",
                        "logo": "https://media-1.api-sports.io/football/teams/17575.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Kunina"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 17575,
                        "name": "Austria Wien W",
                        "logo": "https://media-1.api-sports.io/football/teams/17575.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Batarilo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 50,
                        "extra": null
                    },
                    "team": {
                        "id": 17575,
                        "name": "Austria Wien W",
                        "logo": "https://media-3.api-sports.io/football/teams/17575.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 17575,
                        "name": "Austria Wien W",
                        "logo": "https://media-1.api-sports.io/football/teams/17575.png"
                    },
                    "player": {
                        "id": null,
                        "name": "V. Volkmer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 900113,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 2865,
                    "name": "Sportpark de Boshoek",
                    "city": "Hardenberg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 48
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 1278,
                    "name": "HHC",
                    "logo": "https://media-2.api-sports.io/football/teams/1278.png",
                    "winner": true
                },
                "away": {
                    "id": 1257,
                    "name": "FC Lisse",
                    "logo": "https://media-3.api-sports.io/football/teams/1257.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 1257,
                        "name": "FC Lisse",
                        "logo": "https://media-1.api-sports.io/football/teams/1257.png"
                    },
                    "player": {
                        "id": 37840,
                        "name": "E. Stroo"
                    },
                    "assist": {
                        "id": null,
                        "name": "J. van der Putten"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 14,
                        "extra": null
                    },
                    "team": {
                        "id": 1278,
                        "name": "HHC",
                        "logo": "https://media-2.api-sports.io/football/teams/1278.png"
                    },
                    "player": {
                        "id": 37286,
                        "name": "G. Klok"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 1
                    },
                    "team": {
                        "id": 1278,
                        "name": "HHC",
                        "logo": "https://media-3.api-sports.io/football/teams/1278.png"
                    },
                    "player": {
                        "id": 38587,
                        "name": "D. Bouws"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903902,
                "referee": "Andrea Colombo, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 876,
                    "name": "Stadio Cino e Lillo Del Duca",
                    "city": "Ascoli Piceno"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 507,
                    "name": "Ascoli",
                    "logo": "https://media-3.api-sports.io/football/teams/507.png",
                    "winner": null
                },
                "away": {
                    "id": 10137,
                    "name": "Nuova Cosenza",
                    "logo": "https://media-3.api-sports.io/football/teams/10137.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-3.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 31327,
                        "name": "T. D'Orazio"
                    },
                    "assist": {
                        "id": 26982,
                        "name": "C. D'Urso"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-1.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 345467,
                        "name": "M. Nasti"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-3.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 30987,
                        "name": "S. Vaisanen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-1.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 48459,
                        "name": "I. Voca"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 507,
                        "name": "Ascoli",
                        "logo": "https://media-2.api-sports.io/football/teams/507.png"
                    },
                    "player": {
                        "id": 70351,
                        "name": "M. Buchel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 1
                    },
                    "team": {
                        "id": 507,
                        "name": "Ascoli",
                        "logo": "https://media-3.api-sports.io/football/teams/507.png"
                    },
                    "player": {
                        "id": 37142,
                        "name": "E. Botteghin"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-3.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 282409,
                        "name": "A. Florenzi"
                    },
                    "assist": {
                        "id": 26982,
                        "name": "C. D'Urso"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 10137,
                        "name": "Nuova Cosenza",
                        "logo": "https://media-3.api-sports.io/football/teams/10137.png"
                    },
                    "player": {
                        "id": 14349,
                        "name": "I. Delic"
                    },
                    "assist": {
                        "id": 30664,
                        "name": "M. Finotto"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 507,
                        "name": "Ascoli",
                        "logo": "https://media-3.api-sports.io/football/teams/507.png"
                    },
                    "player": {
                        "id": 237150,
                        "name": "S. Giovane"
                    },
                    "assist": {
                        "id": 70351,
                        "name": "M. Buchel"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 507,
                        "name": "Ascoli",
                        "logo": "https://media-1.api-sports.io/football/teams/507.png"
                    },
                    "player": {
                        "id": 57016,
                        "name": "C. Gondo"
                    },
                    "assist": {
                        "id": 8737,
                        "name": "F. Forte"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 507,
                        "name": "Ascoli",
                        "logo": "https://media-1.api-sports.io/football/teams/507.png"
                    },
                    "player": {
                        "id": 31246,
                        "name": "D. Marsura"
                    },
                    "assist": {
                        "id": 237150,
                        "name": "S. Giovane"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903903,
                "referee": "Daniele Minelli, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2763,
                    "name": "Stadio Comunale San Nicola",
                    "city": "Bari"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 508,
                    "name": "Bari",
                    "logo": "https://media-3.api-sports.io/football/teams/508.png",
                    "winner": true
                },
                "away": {
                    "id": 1692,
                    "name": "Reggina",
                    "logo": "https://media-3.api-sports.io/football/teams/1692.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 5,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-3.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 284935,
                        "name": "M. Dorval"
                    },
                    "assist": {
                        "id": 31676,
                        "name": "R. Pucino"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-1.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 56851,
                        "name": "M. Folorunsho"
                    },
                    "assist": {
                        "id": 215,
                        "name": "S. Esposito"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-1.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 56796,
                        "name": "M. Maita"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-1.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 91527,
                        "name": "L. Benedetti"
                    },
                    "assist": {
                        "id": 56851,
                        "name": "M. Folorunsho"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-2.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 56324,
                        "name": "D. Ceter"
                    },
                    "assist": {
                        "id": 56877,
                        "name": "N. Bellomo"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1692,
                        "name": "Reggina",
                        "logo": "https://media-1.api-sports.io/football/teams/1692.png"
                    },
                    "player": {
                        "id": 30713,
                        "name": "D. Liotti"
                    },
                    "assist": {
                        "id": 30618,
                        "name": "G. Di Chiara"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1692,
                        "name": "Reggina",
                        "logo": "https://media-1.api-sports.io/football/teams/1692.png"
                    },
                    "player": {
                        "id": 31280,
                        "name": "R. Rivas"
                    },
                    "assist": {
                        "id": 31611,
                        "name": "E. Terranova"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 508,
                        "name": "Bari",
                        "logo": "https://media-3.api-sports.io/football/teams/508.png"
                    },
                    "player": {
                        "id": 91494,
                        "name": "V. Di Cesare"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 73,
                        "extra": null
                    },
                    "team": {
                        "id": 1692,
                        "name": "Reggina",
                        "logo": "https://media-3.api-sports.io/football/teams/1692.png"
                    },
                    "player": {
                        "id": 30625,
                        "name": "L. Crisetig"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903904,
                "referee": "Davide Ghersini, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 880,
                    "name": "Stadio Ciro Vigorito",
                    "city": "Benevento"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 506,
                    "name": "Benevento",
                    "logo": "https://media-1.api-sports.io/football/teams/506.png",
                    "winner": true
                },
                "away": {
                    "id": 899,
                    "name": "Modena",
                    "logo": "https://media-1.api-sports.io/football/teams/899.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 899,
                        "name": "Modena",
                        "logo": "https://media-2.api-sports.io/football/teams/899.png"
                    },
                    "player": {
                        "id": 30663,
                        "name": "D. Diaw"
                    },
                    "assist": {
                        "id": 31765,
                        "name": "L. Magnino"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-2.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 32038,
                        "name": "H. El Kaouakibi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-1.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 31091,
                        "name": "C. Ciano"
                    },
                    "assist": {
                        "id": 136093,
                        "name": "N. Karic"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 2
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-1.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 8719,
                        "name": "D. Foulon"
                    },
                    "assist": {
                        "id": 97,
                        "name": "K. Glik"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-1.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 30636,
                        "name": "R. Improta"
                    },
                    "assist": {
                        "id": 40236,
                        "name": "K. Kubica"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 48,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-2.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 97,
                        "name": "K. Glik"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 899,
                        "name": "Modena",
                        "logo": "https://media-3.api-sports.io/football/teams/899.png"
                    },
                    "player": {
                        "id": 31629,
                        "name": "L. Strizzolo"
                    },
                    "assist": {
                        "id": 32161,
                        "name": "N. Mosti"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-2.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 31001,
                        "name": "S. Pettinari"
                    },
                    "assist": {
                        "id": 31061,
                        "name": "D. Farias"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 506,
                        "name": "Benevento",
                        "logo": "https://media-3.api-sports.io/football/teams/506.png"
                    },
                    "player": {
                        "id": 31050,
                        "name": "F. Veseli"
                    },
                    "assist": {
                        "id": 32038,
                        "name": "H. El Kaouakibi"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903905,
                "referee": "Gianluca Aureliano, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 882,
                    "name": "Stadio Mario Rigamonti",
                    "city": "Brescia"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 518,
                    "name": "Brescia",
                    "logo": "https://media-1.api-sports.io/football/teams/518.png",
                    "winner": true
                },
                "away": {
                    "id": 801,
                    "name": "Pisa",
                    "logo": "https://media-1.api-sports.io/football/teams/801.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 49,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-2.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 2785,
                        "name": "H. Hermannsson"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 518,
                        "name": "Brescia",
                        "logo": "https://media-3.api-sports.io/football/teams/518.png"
                    },
                    "player": {
                        "id": 31139,
                        "name": "D. Bisoli"
                    },
                    "assist": {
                        "id": 162029,
                        "name": "P. Rodriguez"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 518,
                        "name": "Brescia",
                        "logo": "https://media-1.api-sports.io/football/teams/518.png"
                    },
                    "player": {
                        "id": 162029,
                        "name": "P. Rodriguez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-1.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 31996,
                        "name": "G. Sibilli"
                    },
                    "assist": {
                        "id": 31153,
                        "name": "E. Torregrossa"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-2.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 30728,
                        "name": "G. Masucci"
                    },
                    "assist": {
                        "id": 182467,
                        "name": "E. Zuelli"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 60,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-3.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 30728,
                        "name": "G. Masucci"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 518,
                        "name": "Brescia",
                        "logo": "https://media-2.api-sports.io/football/teams/518.png"
                    },
                    "player": {
                        "id": 266481,
                        "name": "F. Bianchi"
                    },
                    "assist": {
                        "id": 162029,
                        "name": "P. Rodriguez"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 518,
                        "name": "Brescia",
                        "logo": "https://media-3.api-sports.io/football/teams/518.png"
                    },
                    "player": {
                        "id": 31144,
                        "name": "E. Ndoj"
                    },
                    "assist": {
                        "id": 31130,
                        "name": "A. Cistana"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-1.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 43024,
                        "name": "O. Morutan"
                    },
                    "assist": {
                        "id": 20959,
                        "name": "M. Tramoni"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-3.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 32158,
                        "name": "M. Gargiulo"
                    },
                    "assist": {
                        "id": 30846,
                        "name": "G. Mastinu"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 518,
                        "name": "Brescia",
                        "logo": "https://media-2.api-sports.io/football/teams/518.png"
                    },
                    "player": {
                        "id": 38125,
                        "name": "T. Van de Looi"
                    },
                    "assist": {
                        "id": 40348,
                        "name": "J. Labojko"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 73,
                        "extra": null
                    },
                    "team": {
                        "id": 801,
                        "name": "Pisa",
                        "logo": "https://media-2.api-sports.io/football/teams/801.png"
                    },
                    "player": {
                        "id": 31996,
                        "name": "G. Sibilli"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903906,
                "referee": "Paolo Valeri, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 12275,
                    "name": "Unipol Domus",
                    "city": "Cagliari"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 490,
                    "name": "Cagliari",
                    "logo": "https://media-2.api-sports.io/football/teams/490.png",
                    "winner": true
                },
                "away": {
                    "id": 522,
                    "name": "Palermo",
                    "logo": "https://media-2.api-sports.io/football/teams/522.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-3.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31370,
                        "name": "J. Segre"
                    },
                    "assist": {
                        "id": 31450,
                        "name": "I. Marconi"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-1.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 200,
                        "name": "G. Zappa"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 25,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-2.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 30561,
                        "name": "A. Deiola"
                    },
                    "assist": {
                        "id": 2614,
                        "name": "N. Nandez"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-1.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31135,
                        "name": "A. Mateju"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 50,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-3.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 32034,
                        "name": "A. Dossena"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-2.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31450,
                        "name": "I. Marconi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 56,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-3.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31450,
                        "name": "I. Marconi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 56,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-3.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31450,
                        "name": "I. Marconi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 60,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-2.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 31477,
                        "name": "D. Bettella"
                    },
                    "assist": {
                        "id": 31348,
                        "name": "G. Tutino"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-1.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 30790,
                        "name": "G. Lapadula"
                    },
                    "assist": {
                        "id": 30561,
                        "name": "A. Deiola"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-3.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 321744,
                        "name": "A. Obert"
                    },
                    "assist": {
                        "id": 32034,
                        "name": "A. Dossena"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 490,
                        "name": "Cagliari",
                        "logo": "https://media-3.api-sports.io/football/teams/490.png"
                    },
                    "player": {
                        "id": 56287,
                        "name": "A. Di Pardo"
                    },
                    "assist": {
                        "id": 200,
                        "name": "G. Zappa"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 522,
                        "name": "Palermo",
                        "logo": "https://media-2.api-sports.io/football/teams/522.png"
                    },
                    "player": {
                        "id": 264477,
                        "name": "G. Aurelio"
                    },
                    "assist": {
                        "id": 56161,
                        "name": "M. Sala"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903907,
                "referee": "Matteo Gariglio, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 892,
                    "name": "Stadio Giuseppe Sinigaglia",
                    "city": "Como"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 895,
                    "name": "como",
                    "logo": "https://media-3.api-sports.io/football/teams/895.png",
                    "winner": true
                },
                "away": {
                    "id": 516,
                    "name": "Ternana",
                    "logo": "https://media-3.api-sports.io/football/teams/516.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-3.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 30788,
                        "name": "A. Favilli"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 44,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-2.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 31680,
                        "name": "F. Di Tacchio"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-2.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 31182,
                        "name": "M. Chajia"
                    },
                    "assist": {
                        "id": 108,
                        "name": "C. Fabregas"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-2.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 30840,
                        "name": "L. Vignali"
                    },
                    "assist": {
                        "id": 154799,
                        "name": "L. Binks"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-1.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 162266,
                        "name": "L. Da Cunha"
                    },
                    "assist": {
                        "id": 30508,
                        "name": "V. Parigini"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 50,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-1.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 30958,
                        "name": "D. Agazzi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-3.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 31134,
                        "name": "B. Martella"
                    },
                    "assist": {
                        "id": 31266,
                        "name": "M. Defendi"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-3.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 56655,
                        "name": "M. Proietti"
                    },
                    "assist": {
                        "id": 31680,
                        "name": "F. Di Tacchio"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-3.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 30840,
                        "name": "L. Vignali"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-2.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 56860,
                        "name": "A. Partipilo"
                    },
                    "assist": {
                        "id": 31553,
                        "name": "C. Falletti"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-1.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 30958,
                        "name": "D. Agazzi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 516,
                        "name": "Ternana",
                        "logo": "https://media-3.api-sports.io/football/teams/516.png"
                    },
                    "player": {
                        "id": 30958,
                        "name": "D. Agazzi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-1.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 162266,
                        "name": "L. Da Cunha"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 895,
                        "name": "como",
                        "logo": "https://media-3.api-sports.io/football/teams/895.png"
                    },
                    "player": {
                        "id": 15281,
                        "name": "N. Ioannou"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903909,
                "referee": "Massimiliano Irrati, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 938,
                    "name": "Stadio Paolo Mazza",
                    "city": "Ferrara"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 493,
                    "name": "Spal",
                    "logo": "https://media-1.api-sports.io/football/teams/493.png",
                    "winner": false
                },
                "away": {
                    "id": 523,
                    "name": "Parma",
                    "logo": "https://media-3.api-sports.io/football/teams/523.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 493,
                        "name": "Spal",
                        "logo": "https://media-2.api-sports.io/football/teams/493.png"
                    },
                    "player": {
                        "id": 196843,
                        "name": "C. Dalle Mura"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 17,
                        "extra": null
                    },
                    "team": {
                        "id": 523,
                        "name": "Parma",
                        "logo": "https://media-1.api-sports.io/football/teams/523.png"
                    },
                    "player": {
                        "id": 128338,
                        "name": "W. Coulibaly"
                    },
                    "assist": {
                        "id": 30496,
                        "name": "C. Ansaldi"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 523,
                        "name": "Parma",
                        "logo": "https://media-1.api-sports.io/football/teams/523.png"
                    },
                    "player": {
                        "id": 91424,
                        "name": "D. Camara"
                    },
                    "assist": {
                        "id": 628,
                        "name": "A. Bernabe"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 523,
                        "name": "Parma",
                        "logo": "https://media-3.api-sports.io/football/teams/523.png"
                    },
                    "player": {
                        "id": 56304,
                        "name": "L. Zanimacchia"
                    },
                    "assist": {
                        "id": 43036,
                        "name": "D. Man"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 523,
                        "name": "Parma",
                        "logo": "https://media-2.api-sports.io/football/teams/523.png"
                    },
                    "player": {
                        "id": 43056,
                        "name": "V. Mihaila"
                    },
                    "assist": {
                        "id": 40592,
                        "name": "A. Benedyczak"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 493,
                        "name": "Spal",
                        "logo": "https://media-2.api-sports.io/football/teams/493.png"
                    },
                    "player": {
                        "id": 91429,
                        "name": "G. Rossi"
                    },
                    "assist": {
                        "id": 152885,
                        "name": "G. Tunjov"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 493,
                        "name": "Spal",
                        "logo": "https://media-3.api-sports.io/football/teams/493.png"
                    },
                    "player": {
                        "id": 56433,
                        "name": "R. Celia"
                    },
                    "assist": {
                        "id": 196843,
                        "name": "C. Dalle Mura"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 493,
                        "name": "Spal",
                        "logo": "https://media-1.api-sports.io/football/teams/493.png"
                    },
                    "player": {
                        "id": 68192,
                        "name": "G. Fetfatzidis"
                    },
                    "assist": {
                        "id": 126766,
                        "name": "N. Rauti"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 523,
                        "name": "Parma",
                        "logo": "https://media-1.api-sports.io/football/teams/523.png"
                    },
                    "player": {
                        "id": 2057,
                        "name": "F. Vazquez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903910,
                "referee": "Marco Serra, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 940,
                    "name": "Stadio Marco Druso",
                    "city": "Bozen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 1578,
                    "name": "Sudtirol",
                    "logo": "https://media-3.api-sports.io/football/teams/1578.png",
                    "winner": null
                },
                "away": {
                    "id": 510,
                    "name": "Cittadella",
                    "logo": "https://media-1.api-sports.io/football/teams/510.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-2.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 31625,
                        "name": "M. Carretta"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 24,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-1.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 31898,
                        "name": "N. Pavan"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 41,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-2.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 31051,
                        "name": "L. Belardinelli"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-3.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 31040,
                        "name": "M. Curto"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-3.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 31554,
                        "name": "L. Fiordilino"
                    },
                    "assist": {
                        "id": 31123,
                        "name": "S. Mazzocchi"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-2.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 30826,
                        "name": "F. De Col"
                    },
                    "assist": {
                        "id": 31040,
                        "name": "M. Curto"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-1.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 133638,
                        "name": "S. Davi"
                    },
                    "assist": {
                        "id": 56642,
                        "name": "A. Celli"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 49,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-2.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 31497,
                        "name": "M. Antonucci"
                    },
                    "assist": {
                        "id": 341912,
                        "name": "G. Ambrosino"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-1.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 31474,
                        "name": "E. Kastrati"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-2.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 70570,
                        "name": "J. Larrivey"
                    },
                    "assist": {
                        "id": 31625,
                        "name": "M. Carretta"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-1.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 31597,
                        "name": "T. Maistrello"
                    },
                    "assist": {
                        "id": 341912,
                        "name": "G. Ambrosino"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-1.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 31675,
                        "name": "R. Perticone"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 1578,
                        "name": "Sudtirol",
                        "logo": "https://media-3.api-sports.io/football/teams/1578.png"
                    },
                    "player": {
                        "id": 127945,
                        "name": "R. Odogwu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-2.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 51608,
                        "name": "I. Lores"
                    },
                    "assist": {
                        "id": 56954,
                        "name": "A. Magrassi"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 510,
                        "name": "Cittadella",
                        "logo": "https://media-3.api-sports.io/football/teams/510.png"
                    },
                    "player": {
                        "id": 91526,
                        "name": "V. Mastrantonio"
                    },
                    "assist": {
                        "id": 31237,
                        "name": "G. Crociata"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 903911,
                "referee": "Lorenzo Maggioni, Italy",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 948,
                    "name": "Stadio Pierluigi Penzo",
                    "city": "Venezia"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 75
                }
            },
            "league": {
                "id": 136,
                "name": "Serie B",
                "country": "Italy",
                "logo": "https://media-2.api-sports.io/football/leagues/136.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 517,
                    "name": "Venezia",
                    "logo": "https://media-2.api-sports.io/football/teams/517.png",
                    "winner": true
                },
                "away": {
                    "id": 524,
                    "name": "Perugia",
                    "logo": "https://media-2.api-sports.io/football/teams/524.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 3,
                        "extra": null
                    },
                    "team": {
                        "id": 524,
                        "name": "Perugia",
                        "logo": "https://media-3.api-sports.io/football/teams/524.png"
                    },
                    "player": {
                        "id": 8552,
                        "name": "G. Angella"
                    },
                    "assist": {
                        "id": 51085,
                        "name": "A. Struna"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-1.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 30849,
                        "name": "N. Pierini"
                    },
                    "assist": {
                        "id": 89520,
                        "name": "M. E. Ellertsson"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-2.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 193270,
                        "name": "A. Carboni"
                    },
                    "assist": {
                        "id": 15905,
                        "name": "M. K. Andersen"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 524,
                        "name": "Perugia",
                        "logo": "https://media-1.api-sports.io/football/teams/524.png"
                    },
                    "player": {
                        "id": 30979,
                        "name": "M. Curado"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 524,
                        "name": "Perugia",
                        "logo": "https://media-3.api-sports.io/football/teams/524.png"
                    },
                    "player": {
                        "id": 281291,
                        "name": "E. Iannoni"
                    },
                    "assist": {
                        "id": 31053,
                        "name": "L. Capezzi"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 524,
                        "name": "Perugia",
                        "logo": "https://media-3.api-sports.io/football/teams/524.png"
                    },
                    "player": {
                        "id": 32040,
                        "name": "G. Luperini"
                    },
                    "assist": {
                        "id": 30831,
                        "name": "P. Bartolomei"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 60,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-1.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 89520,
                        "name": "M. E. Ellertsson"
                    },
                    "assist": {
                        "id": 986,
                        "name": "J. Pohjanpalo"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-3.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 51266,
                        "name": "G. Busio"
                    },
                    "assist": {
                        "id": 15905,
                        "name": "M. K. Andersen"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-3.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 26095,
                        "name": "M. Sverko"
                    },
                    "assist": {
                        "id": 193270,
                        "name": "A. Carboni"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 524,
                        "name": "Perugia",
                        "logo": "https://media-2.api-sports.io/football/teams/524.png"
                    },
                    "player": {
                        "id": 32040,
                        "name": "G. Luperini"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-2.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 923,
                        "name": "D. Cheryshev"
                    },
                    "assist": {
                        "id": 30849,
                        "name": "N. Pierini"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 73,
                        "extra": null
                    },
                    "team": {
                        "id": 517,
                        "name": "Venezia",
                        "logo": "https://media-2.api-sports.io/football/teams/517.png"
                    },
                    "player": {
                        "id": 37026,
                        "name": "A. Novakovich"
                    },
                    "assist": {
                        "id": 986,
                        "name": "J. Pohjanpalo"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904363,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 749,
                    "name": "Alpenbauer Sportpark",
                    "city": "Unterhaching"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 70
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 1314,
                    "name": "SpVgg Unterhaching",
                    "logo": "https://media-2.api-sports.io/football/teams/1314.png",
                    "winner": null
                },
                "away": {
                    "id": 9336,
                    "name": "Viktoria Aschaffenburg",
                    "logo": "https://media-1.api-sports.io/football/teams/9336.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 904366,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 11969,
                    "name": "NGN-Arena",
                    "city": "Aubstadt"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 9323,
                    "name": "Aubstadt",
                    "logo": "https://media-2.api-sports.io/football/teams/9323.png",
                    "winner": true
                },
                "away": {
                    "id": 9333,
                    "name": "Rain / Lech",
                    "logo": "https://media-1.api-sports.io/football/teams/9333.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 9323,
                        "name": "Aubstadt",
                        "logo": "https://media-2.api-sports.io/football/teams/9323.png"
                    },
                    "player": {
                        "id": 87945,
                        "name": "J. Endres"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 9333,
                        "name": "Rain / Lech",
                        "logo": "https://media-2.api-sports.io/football/teams/9333.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Gutia"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 9323,
                        "name": "Aubstadt",
                        "logo": "https://media-1.api-sports.io/football/teams/9323.png"
                    },
                    "player": {
                        "id": 87945,
                        "name": "J. Endres"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 9323,
                        "name": "Aubstadt",
                        "logo": "https://media-1.api-sports.io/football/teams/9323.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Nickel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 9323,
                        "name": "Aubstadt",
                        "logo": "https://media-1.api-sports.io/football/teams/9323.png"
                    },
                    "player": {
                        "id": 177364,
                        "name": "P. Harlass"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 9323,
                        "name": "Aubstadt",
                        "logo": "https://media-3.api-sports.io/football/teams/9323.png"
                    },
                    "player": {
                        "id": 87945,
                        "name": "J. Endres"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904367,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 742,
                    "name": "Willy-Sachs-Stadion",
                    "city": "Schweinfurt"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 1635,
                    "name": "FC Schweinfurt 05",
                    "logo": "https://media-1.api-sports.io/football/teams/1635.png",
                    "winner": null
                },
                "away": {
                    "id": 12893,
                    "name": "Vilzing",
                    "logo": "https://media-1.api-sports.io/football/teams/12893.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 48,
                        "extra": null
                    },
                    "team": {
                        "id": 12893,
                        "name": "Vilzing",
                        "logo": "https://media-3.api-sports.io/football/teams/12893.png"
                    },
                    "player": {
                        "id": 177406,
                        "name": "A. Junger"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 1635,
                        "name": "FC Schweinfurt 05",
                        "logo": "https://media-2.api-sports.io/football/teams/1635.png"
                    },
                    "player": {
                        "id": 25669,
                        "name": "A. Jabiri"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904369,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6432,
                    "name": "Rosenaustadion",
                    "city": "Augsburg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 9324,
                    "name": "Augsburg II",
                    "logo": "https://media-3.api-sports.io/football/teams/9324.png",
                    "winner": true
                },
                "away": {
                    "id": 4262,
                    "name": "Eichstätt",
                    "logo": "https://media-3.api-sports.io/football/teams/4262.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 9324,
                        "name": "Augsburg II",
                        "logo": "https://media-1.api-sports.io/football/teams/9324.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Muller"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904370,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6437,
                    "name": "Sportpark Heimstetten",
                    "city": "Kirchheim bei München"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 9329,
                    "name": "Heimstetten",
                    "logo": "https://media-2.api-sports.io/football/teams/9329.png",
                    "winner": true
                },
                "away": {
                    "id": 12832,
                    "name": "Pipinsried",
                    "logo": "https://media-3.api-sports.io/football/teams/12832.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 11,
                        "extra": null
                    },
                    "team": {
                        "id": 9329,
                        "name": "Heimstetten",
                        "logo": "https://media-2.api-sports.io/football/teams/9329.png"
                    },
                    "player": {
                        "id": 177391,
                        "name": "L. Riglewski"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 29,
                        "extra": null
                    },
                    "team": {
                        "id": 9329,
                        "name": "Heimstetten",
                        "logo": "https://media-3.api-sports.io/football/teams/9329.png"
                    },
                    "player": {
                        "id": 177391,
                        "name": "L. Riglewski"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 9329,
                        "name": "Heimstetten",
                        "logo": "https://media-3.api-sports.io/football/teams/9329.png"
                    },
                    "player": {
                        "id": 177329,
                        "name": "I. Ezeala"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 12832,
                        "name": "Pipinsried",
                        "logo": "https://media-1.api-sports.io/football/teams/12832.png"
                    },
                    "player": {
                        "id": null,
                        "name": "B. Idrizovic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 12832,
                        "name": "Pipinsried",
                        "logo": "https://media-2.api-sports.io/football/teams/12832.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Milican"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904371,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6444,
                    "name": "Wacker-Arena",
                    "city": "Burghausen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 72
                }
            },
            "league": {
                "id": 83,
                "name": "Regionalliga - Bayern",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/83.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern - 36"
            },
            "teams": {
                "home": {
                    "id": 9337,
                    "name": "Wacker Burghausen",
                    "logo": "https://media-2.api-sports.io/football/teams/9337.png",
                    "winner": false
                },
                "away": {
                    "id": 9332,
                    "name": "Nürnberg II",
                    "logo": "https://media-3.api-sports.io/football/teams/9332.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 11,
                        "extra": null
                    },
                    "team": {
                        "id": 9332,
                        "name": "Nürnberg II",
                        "logo": "https://media-2.api-sports.io/football/teams/9332.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Sausen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904672,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 704,
                    "name": "Ernst-Abbe-Sportfeld",
                    "city": "Jena"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 80
                }
            },
            "league": {
                "id": 85,
                "name": "Regionalliga - Nordost",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/85.png",
                "flag": "https://media-2.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost - 32"
            },
            "teams": {
                "home": {
                    "id": 1325,
                    "name": "Carl Zeiss Jena",
                    "logo": "https://media-3.api-sports.io/football/teams/1325.png",
                    "winner": null
                },
                "away": {
                    "id": 1622,
                    "name": "SV Babelsberg 03",
                    "logo": "https://media-2.api-sports.io/football/teams/1622.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 904980,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 1828,
                    "name": "SIBRE Sportzentrum Haarwasen Haiger",
                    "city": "Haiger"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 86,
                "name": "Regionalliga - SudWest",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/86.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Südwest - 32"
            },
            "teams": {
                "home": {
                    "id": 1656,
                    "name": "TSV Steinbach",
                    "logo": "https://media-2.api-sports.io/football/teams/1656.png",
                    "winner": true
                },
                "away": {
                    "id": 1626,
                    "name": "FC Astoria Walldorf",
                    "logo": "https://media-2.api-sports.io/football/teams/1626.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 1656,
                        "name": "TSV Steinbach",
                        "logo": "https://media-1.api-sports.io/football/teams/1656.png"
                    },
                    "player": {
                        "id": 178069,
                        "name": "A. Guclu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904982,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6464,
                    "name": "Kaiserstuhlstadion",
                    "city": "Bahlingen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 86,
                "name": "Regionalliga - SudWest",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/86.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Südwest - 32"
            },
            "teams": {
                "home": {
                    "id": 9359,
                    "name": "Bahlinger SC",
                    "logo": "https://media-3.api-sports.io/football/teams/9359.png",
                    "winner": false
                },
                "away": {
                    "id": 12788,
                    "name": "Hessen Kassel",
                    "logo": "https://media-3.api-sports.io/football/teams/12788.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 37,
                        "extra": null
                    },
                    "team": {
                        "id": 12788,
                        "name": "Hessen Kassel",
                        "logo": "https://media-1.api-sports.io/football/teams/12788.png"
                    },
                    "player": {
                        "id": 373782,
                        "name": "P. Pululu"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 12788,
                        "name": "Hessen Kassel",
                        "logo": "https://media-2.api-sports.io/football/teams/12788.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Jones"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 904986,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 1880,
                    "name": "Stadion Oberwerth",
                    "city": "Koblenz"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 86,
                "name": "Regionalliga - SudWest",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/86.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Südwest - 32"
            },
            "teams": {
                "home": {
                    "id": 1657,
                    "name": "TuS RW Koblenz",
                    "logo": "https://media-1.api-sports.io/football/teams/1657.png",
                    "winner": false
                },
                "away": {
                    "id": 12846,
                    "name": "SGV Freiberg",
                    "logo": "https://media-1.api-sports.io/football/teams/12846.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 12846,
                        "name": "SGV Freiberg",
                        "logo": "https://media-3.api-sports.io/football/teams/12846.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Barini"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 12846,
                        "name": "SGV Freiberg",
                        "logo": "https://media-2.api-sports.io/football/teams/12846.png"
                    },
                    "player": {
                        "id": 91164,
                        "name": "C. Mauersberger"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 1657,
                        "name": "TuS RW Koblenz",
                        "logo": "https://media-3.api-sports.io/football/teams/1657.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905153,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8120,
                    "name": "Gigaset Arena",
                    "city": "Bocholt"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 72
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 12764,
                    "name": "FC Bocholt",
                    "logo": "https://media-2.api-sports.io/football/teams/12764.png",
                    "winner": false
                },
                "away": {
                    "id": 1658,
                    "name": "Rot-weiss Oberhausen",
                    "logo": "https://media-3.api-sports.io/football/teams/1658.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 5
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 4
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 6,
                        "extra": null
                    },
                    "team": {
                        "id": 1658,
                        "name": "Rot-weiss Oberhausen",
                        "logo": "https://media-1.api-sports.io/football/teams/1658.png"
                    },
                    "player": {
                        "id": null,
                        "name": "R. Rexha"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 1658,
                        "name": "Rot-weiss Oberhausen",
                        "logo": "https://media-2.api-sports.io/football/teams/1658.png"
                    },
                    "player": {
                        "id": 26081,
                        "name": "S. Kreyer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 1658,
                        "name": "Rot-weiss Oberhausen",
                        "logo": "https://media-3.api-sports.io/football/teams/1658.png"
                    },
                    "player": {
                        "id": 26081,
                        "name": "S. Kreyer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 2
                    },
                    "team": {
                        "id": 1658,
                        "name": "Rot-weiss Oberhausen",
                        "logo": "https://media-2.api-sports.io/football/teams/1658.png"
                    },
                    "player": {
                        "id": 26081,
                        "name": "S. Kreyer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 54,
                        "extra": null
                    },
                    "team": {
                        "id": 1658,
                        "name": "Rot-weiss Oberhausen",
                        "logo": "https://media-3.api-sports.io/football/teams/1658.png"
                    },
                    "player": {
                        "id": 26081,
                        "name": "S. Kreyer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905304,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 11975,
                    "name": "Parkstadion",
                    "city": "Gelsenkirchen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 9373,
                    "name": "Schalke 04 II",
                    "logo": "https://media-3.api-sports.io/football/teams/9373.png",
                    "winner": true
                },
                "away": {
                    "id": 9368,
                    "name": "Borussia M'gladbach II",
                    "logo": "https://media-3.api-sports.io/football/teams/9368.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 9,
                        "extra": null
                    },
                    "team": {
                        "id": 9373,
                        "name": "Schalke 04 II",
                        "logo": "https://media-3.api-sports.io/football/teams/9373.png"
                    },
                    "player": {
                        "id": 129124,
                        "name": "I. Cisse"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 9373,
                        "name": "Schalke 04 II",
                        "logo": "https://media-3.api-sports.io/football/teams/9373.png"
                    },
                    "player": {
                        "id": 26389,
                        "name": "R. Dadashov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 39,
                        "extra": null
                    },
                    "team": {
                        "id": 9373,
                        "name": "Schalke 04 II",
                        "logo": "https://media-1.api-sports.io/football/teams/9373.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Balouk"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 9368,
                        "name": "Borussia M'gladbach II",
                        "logo": "https://media-3.api-sports.io/football/teams/9368.png"
                    },
                    "player": {
                        "id": 321716,
                        "name": "S. Telalovic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 9368,
                        "name": "Borussia M'gladbach II",
                        "logo": "https://media-1.api-sports.io/football/teams/9368.png"
                    },
                    "player": {
                        "id": 321716,
                        "name": "S. Telalovic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 9373,
                        "name": "Schalke 04 II",
                        "logo": "https://media-1.api-sports.io/football/teams/9373.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. H. Castelle"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 59,
                        "extra": null
                    },
                    "team": {
                        "id": 9368,
                        "name": "Borussia M'gladbach II",
                        "logo": "https://media-1.api-sports.io/football/teams/9368.png"
                    },
                    "player": {
                        "id": 321716,
                        "name": "S. Telalovic"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 9373,
                        "name": "Schalke 04 II",
                        "logo": "https://media-2.api-sports.io/football/teams/9373.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Sane"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905305,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8634,
                    "name": "Leimbachstadion",
                    "city": "Siegen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 74
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 12799,
                    "name": "Kaan-Marienborn",
                    "logo": "https://media-1.api-sports.io/football/teams/12799.png",
                    "winner": true
                },
                "away": {
                    "id": 4259,
                    "name": "Alemannia Aachen",
                    "logo": "https://media-3.api-sports.io/football/teams/4259.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 14,
                        "extra": null
                    },
                    "team": {
                        "id": 12799,
                        "name": "Kaan-Marienborn",
                        "logo": "https://media-2.api-sports.io/football/teams/12799.png"
                    },
                    "player": {
                        "id": 119172,
                        "name": "L. Scepanik"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 28,
                        "extra": null
                    },
                    "team": {
                        "id": 12799,
                        "name": "Kaan-Marienborn",
                        "logo": "https://media-1.api-sports.io/football/teams/12799.png"
                    },
                    "player": {
                        "id": 374847,
                        "name": "J. El Mansoury"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 55,
                        "extra": null
                    },
                    "team": {
                        "id": 4259,
                        "name": "Alemannia Aachen",
                        "logo": "https://media-1.api-sports.io/football/teams/4259.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905307,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8112,
                    "name": "Westkampfbahn",
                    "city": "Düren"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 67
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 12754,
                    "name": "Düren Merzenich",
                    "logo": "https://media-3.api-sports.io/football/teams/12754.png",
                    "winner": true
                },
                "away": {
                    "id": 12897,
                    "name": "Wiedenbrück",
                    "logo": "https://media-2.api-sports.io/football/teams/12897.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 12754,
                        "name": "Düren Merzenich",
                        "logo": "https://media-1.api-sports.io/football/teams/12754.png"
                    },
                    "player": {
                        "id": 259730,
                        "name": "P. Simon"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 12897,
                        "name": "Wiedenbrück",
                        "logo": "https://media-1.api-sports.io/football/teams/12897.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Amedick"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 12897,
                        "name": "Wiedenbrück",
                        "logo": "https://media-2.api-sports.io/football/teams/12897.png"
                    },
                    "player": {
                        "id": 26621,
                        "name": "M. Buyuksakarya"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 3
                    },
                    "team": {
                        "id": 12754,
                        "name": "Düren Merzenich",
                        "logo": "https://media-2.api-sports.io/football/teams/12754.png"
                    },
                    "player": {
                        "id": 178420,
                        "name": "M. Kuhnel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 12897,
                        "name": "Wiedenbrück",
                        "logo": "https://media-2.api-sports.io/football/teams/12897.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Szeleschus"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 56,
                        "extra": null
                    },
                    "team": {
                        "id": 12754,
                        "name": "Düren Merzenich",
                        "logo": "https://media-2.api-sports.io/football/teams/12754.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905308,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6474,
                    "name": "Paul-Janes-Stadion",
                    "city": "Düsseldorf"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 82
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 9369,
                    "name": "Fortuna Düsseldorf II",
                    "logo": "https://media-3.api-sports.io/football/teams/9369.png",
                    "winner": false
                },
                "away": {
                    "id": 1629,
                    "name": "SG Wattenscheid 09",
                    "logo": "https://media-2.api-sports.io/football/teams/1629.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 1629,
                        "name": "SG Wattenscheid 09",
                        "logo": "https://media-3.api-sports.io/football/teams/1629.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Brdaric"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 1629,
                        "name": "SG Wattenscheid 09",
                        "logo": "https://media-3.api-sports.io/football/teams/1629.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Knabe-Lerche"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 58,
                        "extra": null
                    },
                    "team": {
                        "id": 1629,
                        "name": "SG Wattenscheid 09",
                        "logo": "https://media-3.api-sports.io/football/teams/1629.png"
                    },
                    "player": {
                        "id": null,
                        "name": "F. Casalino"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905309,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 737,
                    "name": "Preußen-Stadion",
                    "city": "Münster"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 74
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 1313,
                    "name": "Preussen Munster",
                    "logo": "https://media-1.api-sports.io/football/teams/1313.png",
                    "winner": true
                },
                "away": {
                    "id": 12839,
                    "name": "Rot Weiss Ahlen",
                    "logo": "https://media-2.api-sports.io/football/teams/12839.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 1313,
                        "name": "Preussen Munster",
                        "logo": "https://media-2.api-sports.io/football/teams/1313.png"
                    },
                    "player": {
                        "id": 26559,
                        "name": "G. Wegkamp"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 25,
                        "extra": null
                    },
                    "team": {
                        "id": 1313,
                        "name": "Preussen Munster",
                        "logo": "https://media-2.api-sports.io/football/teams/1313.png"
                    },
                    "player": {
                        "id": 260898,
                        "name": "N. Remberg"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 54,
                        "extra": null
                    },
                    "team": {
                        "id": 1313,
                        "name": "Preussen Munster",
                        "logo": "https://media-3.api-sports.io/football/teams/1313.png"
                    },
                    "player": {
                        "id": null,
                        "name": "Y. Bouchama"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905310,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 715,
                    "name": "Südstadion",
                    "city": "Köln"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 75
                }
            },
            "league": {
                "id": 87,
                "name": "Regionalliga - West",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/87.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "West - 34"
            },
            "teams": {
                "home": {
                    "id": 1326,
                    "name": "Fortuna Koln",
                    "logo": "https://media-1.api-sports.io/football/teams/1326.png",
                    "winner": false
                },
                "away": {
                    "id": 9375,
                    "name": "Wuppertaler SV",
                    "logo": "https://media-3.api-sports.io/football/teams/9375.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 9375,
                        "name": "Wuppertaler SV",
                        "logo": "https://media-1.api-sports.io/football/teams/9375.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Guler"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 9375,
                        "name": "Wuppertaler SV",
                        "logo": "https://media-3.api-sports.io/football/teams/9375.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Peitz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 47,
                        "extra": null
                    },
                    "team": {
                        "id": 9375,
                        "name": "Wuppertaler SV",
                        "logo": "https://media-2.api-sports.io/football/teams/9375.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Guler"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 51,
                        "extra": null
                    },
                    "team": {
                        "id": 9375,
                        "name": "Wuppertaler SV",
                        "logo": "https://media-3.api-sports.io/football/teams/9375.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Guler"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 1326,
                        "name": "Fortuna Koln",
                        "logo": "https://media-2.api-sports.io/football/teams/1326.png"
                    },
                    "player": {
                        "id": 25811,
                        "name": "J. Scholz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905752,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 10725,
                    "name": "Waldstadion",
                    "city": "Ludwigsfelde"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 14720,
                    "name": "Ludwigsfelde",
                    "logo": "https://media-3.api-sports.io/football/teams/14720.png",
                    "winner": true
                },
                "away": {
                    "id": 16125,
                    "name": "Blau-Weiß Zorbau",
                    "logo": "https://media-3.api-sports.io/football/teams/16125.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 14720,
                        "name": "Ludwigsfelde",
                        "logo": "https://media-1.api-sports.io/football/teams/14720.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Bache"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905904,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 12635,
                    "name": "SpA Hainsberg Rasenplatz",
                    "city": "Freital"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 18170,
                    "name": "SC Freital",
                    "logo": "https://media-3.api-sports.io/football/teams/18170.png",
                    "winner": false
                },
                "away": {
                    "id": 14548,
                    "name": "Einheit Rudolstadt",
                    "logo": "https://media-3.api-sports.io/football/teams/14548.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 18170,
                        "name": "SC Freital",
                        "logo": "https://media-3.api-sports.io/football/teams/18170.png"
                    },
                    "player": {
                        "id": null,
                        "name": "P. Schmidt"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 14548,
                        "name": "Einheit Rudolstadt",
                        "logo": "https://media-2.api-sports.io/football/teams/14548.png"
                    },
                    "player": {
                        "id": null,
                        "name": "B. Bahner"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 41,
                        "extra": null
                    },
                    "team": {
                        "id": 18170,
                        "name": "SC Freital",
                        "logo": "https://media-2.api-sports.io/football/teams/18170.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Herzig"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 14548,
                        "name": "Einheit Rudolstadt",
                        "logo": "https://media-2.api-sports.io/football/teams/14548.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905907,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6455,
                    "name": "Arena zur Vogtlandweide",
                    "city": "Auerbach"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 9350,
                    "name": "Auerbach",
                    "logo": "https://media-1.api-sports.io/football/teams/9350.png",
                    "winner": true
                },
                "away": {
                    "id": 14713,
                    "name": "Krieschow",
                    "logo": "https://media-1.api-sports.io/football/teams/14713.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 9350,
                        "name": "Auerbach",
                        "logo": "https://media-3.api-sports.io/football/teams/9350.png"
                    },
                    "player": {
                        "id": 88073,
                        "name": "M. Zimmermann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 9350,
                        "name": "Auerbach",
                        "logo": "https://media-1.api-sports.io/football/teams/9350.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Graf"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905908,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8182,
                    "name": "Sternquell-Arena",
                    "city": "Plauen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 12833,
                    "name": "Plauen",
                    "logo": "https://media-1.api-sports.io/football/teams/12833.png",
                    "winner": null
                },
                "away": {
                    "id": 12756,
                    "name": "Eilenburg",
                    "logo": "https://media-1.api-sports.io/football/teams/12756.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 12756,
                        "name": "Eilenburg",
                        "logo": "https://media-1.api-sports.io/football/teams/12756.png"
                    },
                    "player": {
                        "id": 315234,
                        "name": "N. Baumann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 64,
                        "extra": null
                    },
                    "team": {
                        "id": 12833,
                        "name": "Plauen",
                        "logo": "https://media-1.api-sports.io/football/teams/12833.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Will"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905910,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6457,
                    "name": "Volksbank Arena Bischofswerda",
                    "city": "Bischofswerda"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 9352,
                    "name": "Bischofswerdaer FV",
                    "logo": "https://media-1.api-sports.io/football/teams/9352.png",
                    "winner": true
                },
                "away": {
                    "id": 16124,
                    "name": "An der Fahner Höhe",
                    "logo": "https://media-2.api-sports.io/football/teams/16124.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 7,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 12,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-3.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Hoffmann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-3.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Sobe"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-3.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Rodrigues"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-2.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Rodrigues"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 50,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-3.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Rodrigues"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-1.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Hoffmann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 9352,
                        "name": "Bischofswerdaer FV",
                        "logo": "https://media-2.api-sports.io/football/teams/9352.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Sobe"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 905911,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 10753,
                    "name": "HWG-Stadion am Zoo",
                    "city": "Saale"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 46
                }
            },
            "league": {
                "id": 755,
                "name": "Oberliga - Nordost-Süd",
                "country": "Germany",
                "logo": "https://media-1.api-sports.io/football/leagues/755.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Nordost-Süd - 31"
            },
            "teams": {
                "home": {
                    "id": 14812,
                    "name": "VfL Halle",
                    "logo": "https://media-3.api-sports.io/football/teams/14812.png",
                    "winner": true
                },
                "away": {
                    "id": 14741,
                    "name": "Oberlausitz Neugersdorf",
                    "logo": "https://media-3.api-sports.io/football/teams/14741.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 14741,
                        "name": "Oberlausitz Neugersdorf",
                        "logo": "https://media-3.api-sports.io/football/teams/14741.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Olaoye"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 14812,
                        "name": "VfL Halle",
                        "logo": "https://media-1.api-sports.io/football/teams/14812.png"
                    },
                    "player": {
                        "id": 177895,
                        "name": "F. Lubsch"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 55,
                        "extra": null
                    },
                    "team": {
                        "id": 14812,
                        "name": "VfL Halle",
                        "logo": "https://media-2.api-sports.io/football/teams/14812.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Jagupov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 14812,
                        "name": "VfL Halle",
                        "logo": "https://media-3.api-sports.io/football/teams/14812.png"
                    },
                    "player": {
                        "id": 177895,
                        "name": "F. Lubsch"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907184,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2712,
                    "name": "EBRA-Stadion im Wiesental",
                    "city": "Ravensburg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 753,
                "name": "Oberliga - Baden-Württemberg",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/753.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Baden-Württemberg - 32"
            },
            "teams": {
                "home": {
                    "id": 1624,
                    "name": "FV Ravensburg",
                    "logo": "https://media-1.api-sports.io/football/teams/1624.png",
                    "winner": true
                },
                "away": {
                    "id": 1619,
                    "name": "FC 08 Villingen",
                    "logo": "https://media-1.api-sports.io/football/teams/1619.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 1624,
                        "name": "FV Ravensburg",
                        "logo": "https://media-2.api-sports.io/football/teams/1624.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Zimmermann"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907185,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8211,
                    "name": "GAZİ-Stadion auf der Waldau",
                    "city": "Stuttgart"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 753,
                "name": "Oberliga - Baden-Württemberg",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/753.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Baden-Württemberg - 32"
            },
            "teams": {
                "home": {
                    "id": 12868,
                    "name": "Stuttgarter Kickers",
                    "logo": "https://media-3.api-sports.io/football/teams/12868.png",
                    "winner": null
                },
                "away": {
                    "id": 1317,
                    "name": "SG Sonnenhof Grossaspach",
                    "logo": "https://media-3.api-sports.io/football/teams/1317.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 37,
                        "extra": null
                    },
                    "team": {
                        "id": 12868,
                        "name": "Stuttgarter Kickers",
                        "logo": "https://media-3.api-sports.io/football/teams/12868.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Dicklhuber"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 41,
                        "extra": null
                    },
                    "team": {
                        "id": 1317,
                        "name": "SG Sonnenhof Grossaspach",
                        "logo": "https://media-3.api-sports.io/football/teams/1317.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Mohr"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907186,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 18704,
                    "name": "Etzwiesenstadion",
                    "city": "Backnang"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 753,
                "name": "Oberliga - Baden-Württemberg",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/753.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Baden-Württemberg - 32"
            },
            "teams": {
                "home": {
                    "id": 16113,
                    "name": "Backnang",
                    "logo": "https://media-2.api-sports.io/football/teams/16113.png",
                    "winner": true
                },
                "away": {
                    "id": 12819,
                    "name": "Neckarsulmer SU",
                    "logo": "https://media-3.api-sports.io/football/teams/12819.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 12819,
                        "name": "Neckarsulmer SU",
                        "logo": "https://media-3.api-sports.io/football/teams/12819.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Muller"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 16113,
                        "name": "Backnang",
                        "logo": "https://media-3.api-sports.io/football/teams/16113.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Weller"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 16113,
                        "name": "Backnang",
                        "logo": "https://media-3.api-sports.io/football/teams/16113.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Weller"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907551,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 6467,
                    "name": "Waldstadion Gießen",
                    "city": "Gießen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 73
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 9362,
                    "name": "FC Gießen",
                    "logo": "https://media-1.api-sports.io/football/teams/9362.png",
                    "winner": true
                },
                "away": {
                    "id": 16102,
                    "name": "Rot-Weiß Walldorf",
                    "logo": "https://media-3.api-sports.io/football/teams/16102.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 9362,
                        "name": "FC Gießen",
                        "logo": "https://media-3.api-sports.io/football/teams/9362.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Gorbunow"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 908190,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 8213,
                    "name": "Stadion Eckener Straße",
                    "city": "Flensburg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 66
                }
            },
            "league": {
                "id": 744,
                "name": "Oberliga - Schleswig-Holstein",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/744.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Schleswig-Holstein - 33"
            },
            "teams": {
                "home": {
                    "id": 12872,
                    "name": "TSB Flensburg",
                    "logo": "https://media-1.api-sports.io/football/teams/12872.png",
                    "winner": null
                },
                "away": {
                    "id": 16067,
                    "name": "Dornbreite Lübeck",
                    "logo": "https://media-3.api-sports.io/football/teams/16067.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 12872,
                        "name": "TSB Flensburg",
                        "logo": "https://media-1.api-sports.io/football/teams/12872.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Nitsch"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 16067,
                        "name": "Dornbreite Lübeck",
                        "logo": "https://media-3.api-sports.io/football/teams/16067.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Amara"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 908191,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 19407,
                    "name": "Kunstrasenplatz Kilia",
                    "city": "Kiel"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 744,
                "name": "Oberliga - Schleswig-Holstein",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/744.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Schleswig-Holstein - 33"
            },
            "teams": {
                "home": {
                    "id": 14500,
                    "name": "Kilia Kiel",
                    "logo": "https://media-1.api-sports.io/football/teams/14500.png",
                    "winner": true
                },
                "away": {
                    "id": 14496,
                    "name": "Husumer",
                    "logo": "https://media-3.api-sports.io/football/teams/14496.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 14500,
                        "name": "Kilia Kiel",
                        "logo": "https://media-1.api-sports.io/football/teams/14500.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Seidel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 69,
                        "extra": null
                    },
                    "team": {
                        "id": 14500,
                        "name": "Kilia Kiel",
                        "logo": "https://media-1.api-sports.io/football/teams/14500.png"
                    },
                    "player": {
                        "id": 300974,
                        "name": "B. Petrick"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 908713,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": null,
                    "name": "Elm-Stadion",
                    "city": "Schöningen"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 74
                }
            },
            "league": {
                "id": 748,
                "name": "Oberliga - Niedersachsen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/748.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Niedersachsen - 33"
            },
            "teams": {
                "home": {
                    "id": 19475,
                    "name": "Schöningen",
                    "logo": "https://media-2.api-sports.io/football/teams/19475.png",
                    "winner": null
                },
                "away": {
                    "id": 12888,
                    "name": "VfL Oldenburg",
                    "logo": "https://media-2.api-sports.io/football/teams/12888.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 926507,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 18716,
                    "name": "Metallbau Herold Sportstätte",
                    "city": "Wiesentheid"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 49
                }
            },
            "league": {
                "id": 938,
                "name": "Oberliga - Bayern Nord",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/938.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Nord - 32"
            },
            "teams": {
                "home": {
                    "id": 19229,
                    "name": "Geesdorf",
                    "logo": "https://media-3.api-sports.io/football/teams/19229.png",
                    "winner": false
                },
                "away": {
                    "id": 12757,
                    "name": "Eintracht Bamberg",
                    "logo": "https://media-2.api-sports.io/football/teams/12757.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 12757,
                        "name": "Eintracht Bamberg",
                        "logo": "https://media-3.api-sports.io/football/teams/12757.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Humpenoder"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Own Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 926812,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 18653,
                    "name": "Sportzentrum am Hungerbachweg",
                    "city": "Landsberg am Lech"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 939,
                "name": "Oberliga - Bayern Süd",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/939.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Süd - 32"
            },
            "teams": {
                "home": {
                    "id": 14717,
                    "name": "Landsberg",
                    "logo": "https://media-2.api-sports.io/football/teams/14717.png",
                    "winner": true
                },
                "away": {
                    "id": 19220,
                    "name": "Erlbach",
                    "logo": "https://media-2.api-sports.io/football/teams/19220.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 14717,
                        "name": "Landsberg",
                        "logo": "https://media-3.api-sports.io/football/teams/14717.png"
                    },
                    "player": {
                        "id": 25663,
                        "name": "S. Krautschneider"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 14717,
                        "name": "Landsberg",
                        "logo": "https://media-2.api-sports.io/football/teams/14717.png"
                    },
                    "player": {
                        "id": 25663,
                        "name": "S. Krautschneider"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 14717,
                        "name": "Landsberg",
                        "logo": "https://media-1.api-sports.io/football/teams/14717.png"
                    },
                    "player": {
                        "id": 25663,
                        "name": "S. Krautschneider"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 926814,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 18690,
                    "name": "Sportanlage Gilching",
                    "city": "Gilching"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 77
                }
            },
            "league": {
                "id": 939,
                "name": "Oberliga - Bayern Süd",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/939.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Bayern Süd - 32"
            },
            "teams": {
                "home": {
                    "id": 12724,
                    "name": "1860 München II",
                    "logo": "https://media-3.api-sports.io/football/teams/12724.png",
                    "winner": null
                },
                "away": {
                    "id": 12750,
                    "name": "Dachau",
                    "logo": "https://media-1.api-sports.io/football/teams/12750.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 26,
                        "extra": null
                    },
                    "team": {
                        "id": 12750,
                        "name": "Dachau",
                        "logo": "https://media-1.api-sports.io/football/teams/12750.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Masmanidis"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 12750,
                        "name": "Dachau",
                        "logo": "https://media-3.api-sports.io/football/teams/12750.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Leiber"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 65,
                        "extra": null
                    },
                    "team": {
                        "id": 12750,
                        "name": "Dachau",
                        "logo": "https://media-2.api-sports.io/football/teams/12750.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Leiber"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 76,
                        "extra": null
                    },
                    "team": {
                        "id": 12724,
                        "name": "1860 München II",
                        "logo": "https://media-1.api-sports.io/football/teams/12724.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 975287,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 18765,
                    "name": "Stadion Tochovice",
                    "city": "Tochovice"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 350,
                "name": "4. liga - Divizie A",
                "country": "Czech-Republic",
                "logo": "https://media-3.api-sports.io/football/leagues/350.png",
                "flag": "https://media-1.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Division A - 26"
            },
            "teams": {
                "home": {
                    "id": 17236,
                    "name": "Tochovice",
                    "logo": "https://media-1.api-sports.io/football/teams/17236.png",
                    "winner": false
                },
                "away": {
                    "id": 7285,
                    "name": "Doubravka",
                    "logo": "https://media-1.api-sports.io/football/teams/7285.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 977437,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2427,
                    "name": "Stadion Ynist'",
                    "city": "Komsomol's'k"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 334,
                "name": "Persha Liga",
                "country": "Ukraine",
                "logo": "https://media-1.api-sports.io/football/leagues/334.png",
                "flag": "https://media-1.api-sports.io/flags/ua.svg",
                "season": 2022,
                "round": "Relegation Round - 6"
            },
            "teams": {
                "home": {
                    "id": 3624,
                    "name": "Hirnyk-Sport",
                    "logo": "https://media-2.api-sports.io/football/teams/3624.png",
                    "winner": null
                },
                "away": {
                    "id": 6487,
                    "name": "Dinaz Vyshhorod",
                    "logo": "https://media-2.api-sports.io/football/teams/6487.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 2,
                        "extra": null
                    },
                    "team": {
                        "id": 6487,
                        "name": "Dinaz Vyshhorod",
                        "logo": "https://media-3.api-sports.io/football/teams/6487.png"
                    },
                    "player": {
                        "id": 306307,
                        "name": "A. Salabay"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 41,
                        "extra": null
                    },
                    "team": {
                        "id": 3624,
                        "name": "Hirnyk-Sport",
                        "logo": "https://media-3.api-sports.io/football/teams/3624.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Soroka"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 6487,
                        "name": "Dinaz Vyshhorod",
                        "logo": "https://media-3.api-sports.io/football/teams/6487.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Bilous"
                    },
                    "assist": {
                        "id": null,
                        "name": "A. Solovyov"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 3624,
                        "name": "Hirnyk-Sport",
                        "logo": "https://media-3.api-sports.io/football/teams/3624.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Podrezan"
                    },
                    "assist": {
                        "id": null,
                        "name": "S. Lebedev"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 47,
                        "extra": null
                    },
                    "team": {
                        "id": 3624,
                        "name": "Hirnyk-Sport",
                        "logo": "https://media-1.api-sports.io/football/teams/3624.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Syomka"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 6487,
                        "name": "Dinaz Vyshhorod",
                        "logo": "https://media-3.api-sports.io/football/teams/6487.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Kos"
                    },
                    "assist": {
                        "id": 63494,
                        "name": "S. Starenkiy"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 3624,
                        "name": "Hirnyk-Sport",
                        "logo": "https://media-2.api-sports.io/football/teams/3624.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Romanov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 73,
                        "extra": null
                    },
                    "team": {
                        "id": 6487,
                        "name": "Dinaz Vyshhorod",
                        "logo": "https://media-2.api-sports.io/football/teams/6487.png"
                    },
                    "player": {
                        "id": null,
                        "name": "O. Litvinov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 3624,
                        "name": "Hirnyk-Sport",
                        "logo": "https://media-2.api-sports.io/football/teams/3624.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 989004,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": null,
                    "name": "Svangaskarð",
                    "city": "Toftir, Eysturoy"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 80
                }
            },
            "league": {
                "id": 366,
                "name": "1. Deild",
                "country": "Faroe-Islands",
                "logo": "https://media-3.api-sports.io/football/leagues/366.png",
                "flag": "https://media-1.api-sports.io/flags/fo.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 13467,
                    "name": "B68 II",
                    "logo": "https://media-3.api-sports.io/football/teams/13467.png",
                    "winner": false
                },
                "away": {
                    "id": 4183,
                    "name": "Víkingur II",
                    "logo": "https://media-1.api-sports.io/football/teams/4183.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 4183,
                        "name": "Víkingur II",
                        "logo": "https://media-3.api-sports.io/football/teams/4183.png"
                    },
                    "player": {
                        "id": null,
                        "name": "F. Skoradal"
                    },
                    "assist": {
                        "id": null,
                        "name": "R. Stolen"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 80,
                        "extra": null
                    },
                    "team": {
                        "id": 4183,
                        "name": "Víkingur II",
                        "logo": "https://media-2.api-sports.io/football/teams/4183.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 989091,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 609,
                    "name": "Gundadalur",
                    "city": "Tórshavn, Streymoy"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 81
                }
            },
            "league": {
                "id": 366,
                "name": "1. Deild",
                "country": "Faroe-Islands",
                "logo": "https://media-3.api-sports.io/football/leagues/366.png",
                "flag": "https://media-1.api-sports.io/flags/fo.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 4185,
                    "name": "B36 II",
                    "logo": "https://media-2.api-sports.io/football/teams/4185.png",
                    "winner": true
                },
                "away": {
                    "id": 10076,
                    "name": "Hoyvík",
                    "logo": "https://media-2.api-sports.io/football/teams/10076.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 4185,
                        "name": "B36 II",
                        "logo": "https://media-3.api-sports.io/football/teams/4185.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 78,
                        "extra": null
                    },
                    "team": {
                        "id": 4185,
                        "name": "B36 II",
                        "logo": "https://media-3.api-sports.io/football/teams/4185.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. W. Joensen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 996409,
                "referee": "Oliver Reitala, Finland",
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 616,
                    "name": "Tapiolan Urheilupuisto",
                    "city": "Esbo"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 74
                }
            },
            "league": {
                "id": 244,
                "name": "Veikkausliiga",
                "country": "Finland",
                "logo": "https://media-1.api-sports.io/football/leagues/244.png",
                "flag": "https://media-2.api-sports.io/flags/fi.svg",
                "season": 2023,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 1169,
                    "name": "Honka",
                    "logo": "https://media-3.api-sports.io/football/teams/1169.png",
                    "winner": false
                },
                "away": {
                    "id": 1165,
                    "name": "KuPS",
                    "logo": "https://media-1.api-sports.io/football/teams/1165.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 12,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-1.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 280963,
                        "name": "J. Alegria"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-2.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 340221,
                        "name": "D. Naamo"
                    },
                    "assist": {
                        "id": 55465,
                        "name": "H. Aalto"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 1
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-3.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 16231,
                        "name": "L. Ortiz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 1165,
                        "name": "KuPS",
                        "logo": "https://media-3.api-sports.io/football/teams/1165.png"
                    },
                    "player": {
                        "id": 8620,
                        "name": "U. Nissila"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 56,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-2.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 162735,
                        "name": "F. Krebs"
                    },
                    "assist": {
                        "id": 162735,
                        "name": "F. Krebs"
                    },
                    "type": "Goal",
                    "detail": "Missed Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 1165,
                        "name": "KuPS",
                        "logo": "https://media-2.api-sports.io/football/teams/1165.png"
                    },
                    "player": {
                        "id": 19349,
                        "name": "J. Oksanen"
                    },
                    "assist": {
                        "id": 55634,
                        "name": "A. Popovitch"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-3.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 264133,
                        "name": "N. Saarikivi"
                    },
                    "assist": {
                        "id": 16231,
                        "name": "L. Ortiz"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-3.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 62127,
                        "name": "C. Bauque"
                    },
                    "assist": {
                        "id": 55476,
                        "name": "L. Kaufmann"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 70,
                        "extra": null
                    },
                    "team": {
                        "id": 1169,
                        "name": "Honka",
                        "logo": "https://media-1.api-sports.io/football/teams/1169.png"
                    },
                    "player": {
                        "id": 269448,
                        "name": "O. Koskinen"
                    },
                    "assist": {
                        "id": 280963,
                        "name": "J. Alegria"
                    },
                    "type": "subst",
                    "detail": "Substitution 4",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 71,
                        "extra": null
                    },
                    "team": {
                        "id": 1165,
                        "name": "KuPS",
                        "logo": "https://media-1.api-sports.io/football/teams/1165.png"
                    },
                    "player": {
                        "id": 19349,
                        "name": "J. Oksanen"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 997480,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:15:00+00:00",
                "timestamp": 1683980100,
                "periods": {
                    "first": 1683980100,
                    "second": 1683983700
                },
                "venue": {
                    "id": 1050,
                    "name": "Stadium Sultan Ibrahim Larkin",
                    "city": "Nusajaya"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 60
                }
            },
            "league": {
                "id": 278,
                "name": "Super League",
                "country": "Malaysia",
                "logo": "https://media-3.api-sports.io/football/leagues/278.png",
                "flag": "https://media-2.api-sports.io/flags/my.svg",
                "season": 2023,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 2523,
                    "name": "Johor Darul Takzim FC",
                    "logo": "https://media-3.api-sports.io/football/teams/2523.png",
                    "winner": true
                },
                "away": {
                    "id": 10107,
                    "name": "Kelantan United",
                    "logo": "https://media-1.api-sports.io/football/teams/10107.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 2523,
                        "name": "Johor Darul Takzim FC",
                        "logo": "https://media-1.api-sports.io/football/teams/2523.png"
                    },
                    "player": {
                        "id": 77665,
                        "name": "Bergson"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 21,
                        "extra": null
                    },
                    "team": {
                        "id": 10107,
                        "name": "Kelantan United",
                        "logo": "https://media-2.api-sports.io/football/teams/10107.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. Sharvin"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 2523,
                        "name": "Johor Darul Takzim FC",
                        "logo": "https://media-1.api-sports.io/football/teams/2523.png"
                    },
                    "player": {
                        "id": 19399,
                        "name": "F. Forestieri"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 2523,
                        "name": "Johor Darul Takzim FC",
                        "logo": "https://media-1.api-sports.io/football/teams/2523.png"
                    },
                    "player": {
                        "id": 35240,
                        "name": "Endrick"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 998440,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2643,
                    "name": "Alytaus m. centrinis stadionas",
                    "city": "Alytus"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 81
                }
            },
            "league": {
                "id": 362,
                "name": "A Lyga",
                "country": "Lithuania",
                "logo": "https://media-3.api-sports.io/football/leagues/362.png",
                "flag": "https://media-1.api-sports.io/flags/lt.svg",
                "season": 2023,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 3859,
                    "name": "Dainava",
                    "logo": "https://media-3.api-sports.io/football/teams/3859.png",
                    "winner": true
                },
                "away": {
                    "id": 638,
                    "name": "FK Trakai",
                    "logo": "https://media-2.api-sports.io/football/teams/638.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-2.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": 69978,
                        "name": "R. Rasimavicius"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-2.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": 72411,
                        "name": "K. Kramens"
                    },
                    "assist": {
                        "id": 63819,
                        "name": "A. Radchenko"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 638,
                        "name": "FK Trakai",
                        "logo": "https://media-2.api-sports.io/football/teams/638.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Onah"
                    },
                    "assist": {
                        "id": 179577,
                        "name": "Nathan Palafoz"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-1.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 54,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-3.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": 69966,
                        "name": "E. Stockunas"
                    },
                    "assist": {
                        "id": null,
                        "name": "P. O. Ademo"
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 638,
                        "name": "FK Trakai",
                        "logo": "https://media-1.api-sports.io/football/teams/638.png"
                    },
                    "player": {
                        "id": 72349,
                        "name": "F. Brisola"
                    },
                    "assist": {
                        "id": null,
                        "name": "M. Ramanauskas"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 66,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-1.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": null,
                        "name": "P. Olugbogi"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-2.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Baftalovskiy"
                    },
                    "assist": {
                        "id": 69966,
                        "name": "E. Stockunas"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 67,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-1.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": 158599,
                        "name": "S. Sorokin"
                    },
                    "assist": {
                        "id": null,
                        "name": "P. O. Ademo"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 75,
                        "extra": null
                    },
                    "team": {
                        "id": 638,
                        "name": "FK Trakai",
                        "logo": "https://media-2.api-sports.io/football/teams/638.png"
                    },
                    "player": {
                        "id": 69960,
                        "name": "M. Grigaravicius"
                    },
                    "assist": {
                        "id": 153505,
                        "name": "C. Odutayo"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 76,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-1.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": 69846,
                        "name": "R. Banevicius"
                    },
                    "assist": {
                        "id": 63819,
                        "name": "A. Radchenko"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 80,
                        "extra": null
                    },
                    "team": {
                        "id": 3859,
                        "name": "Dainava",
                        "logo": "https://media-3.api-sports.io/football/teams/3859.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1001442,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 10593,
                    "name": "Sportland Arena",
                    "city": "Tallinn"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 76
                }
            },
            "league": {
                "id": 328,
                "name": "Esiliiga A",
                "country": "Estonia",
                "logo": "https://media-2.api-sports.io/football/leagues/328.png",
                "flag": "https://media-1.api-sports.io/flags/ee.svg",
                "season": 2023,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 13152,
                    "name": "Legion",
                    "logo": "https://media-1.api-sports.io/football/teams/13152.png",
                    "winner": false
                },
                "away": {
                    "id": 3516,
                    "name": "Elva",
                    "logo": "https://media-3.api-sports.io/football/teams/3516.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 3,
                        "extra": null
                    },
                    "team": {
                        "id": 3516,
                        "name": "Elva",
                        "logo": "https://media-2.api-sports.io/football/teams/3516.png"
                    },
                    "player": {
                        "id": 60733,
                        "name": "A. Paju"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 3516,
                        "name": "Elva",
                        "logo": "https://media-2.api-sports.io/football/teams/3516.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 31,
                        "extra": null
                    },
                    "team": {
                        "id": 13152,
                        "name": "Legion",
                        "logo": "https://media-3.api-sports.io/football/teams/13152.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Gasinski"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 3516,
                        "name": "Elva",
                        "logo": "https://media-3.api-sports.io/football/teams/3516.png"
                    },
                    "player": {
                        "id": 60425,
                        "name": "J. Reilson"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 2
                    },
                    "team": {
                        "id": 13152,
                        "name": "Legion",
                        "logo": "https://media-1.api-sports.io/football/teams/13152.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 50,
                        "extra": null
                    },
                    "team": {
                        "id": 3516,
                        "name": "Elva",
                        "logo": "https://media-3.api-sports.io/football/teams/3516.png"
                    },
                    "player": {
                        "id": null,
                        "name": "P. Alev"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 62,
                        "extra": null
                    },
                    "team": {
                        "id": 3516,
                        "name": "Elva",
                        "logo": "https://media-3.api-sports.io/football/teams/3516.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 63,
                        "extra": null
                    },
                    "team": {
                        "id": 13152,
                        "name": "Legion",
                        "logo": "https://media-3.api-sports.io/football/teams/13152.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1010557,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 185,
                    "name": "AFAS-stadion Achter de Kazerne",
                    "city": "Malines"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 74
                }
            },
            "league": {
                "id": 146,
                "name": "Super League Women",
                "country": "Belgium",
                "logo": "https://media-3.api-sports.io/football/leagues/146.png",
                "flag": "https://media-1.api-sports.io/flags/be.svg",
                "season": 2022,
                "round": "Lower Table Round - 10"
            },
            "teams": {
                "home": {
                    "id": 19160,
                    "name": "Mechelen",
                    "logo": "https://media-1.api-sports.io/football/teams/19160.png",
                    "winner": true
                },
                "away": {
                    "id": 14036,
                    "name": "Charleroi W",
                    "logo": "https://media-1.api-sports.io/football/teams/14036.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 14036,
                        "name": "Charleroi W",
                        "logo": "https://media-1.api-sports.io/football/teams/14036.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Red Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 19160,
                        "name": "Mechelen",
                        "logo": "https://media-1.api-sports.io/football/teams/19160.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 40,
                        "extra": null
                    },
                    "team": {
                        "id": 19160,
                        "name": "Mechelen",
                        "logo": "https://media-2.api-sports.io/football/teams/19160.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1011389,
                "referee": "A. Iannello",
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": null,
                    "name": "Puma House of Football - Centro P. Vismara",
                    "city": "Milano"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 50
                }
            },
            "league": {
                "id": 139,
                "name": "Serie A Women",
                "country": "Italy",
                "logo": "https://media-1.api-sports.io/football/leagues/139.png",
                "flag": "https://media-1.api-sports.io/flags/it.svg",
                "season": 2022,
                "round": "Championship Round - 8"
            },
            "teams": {
                "home": {
                    "id": 1893,
                    "name": "AC Milan W",
                    "logo": "https://media-2.api-sports.io/football/teams/1893.png",
                    "winner": true
                },
                "away": {
                    "id": 1892,
                    "name": "Roma W",
                    "logo": "https://media-3.api-sports.io/football/teams/1892.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 35,
                        "extra": null
                    },
                    "team": {
                        "id": 1892,
                        "name": "Roma W",
                        "logo": "https://media-2.api-sports.io/football/teams/1892.png"
                    },
                    "player": {
                        "id": 154906,
                        "name": "N. Cinotti"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 38,
                        "extra": null
                    },
                    "team": {
                        "id": 1893,
                        "name": "AC Milan W",
                        "logo": "https://media-2.api-sports.io/football/teams/1893.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Soffia"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1016233,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 2203,
                    "name": "Stadyen Lyakamatyu",
                    "city": "Baranovichi"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 117,
                "name": "1. Division",
                "country": "Belarus",
                "logo": "https://media-2.api-sports.io/football/leagues/117.png",
                "flag": "https://media-2.api-sports.io/flags/by.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 3383,
                    "name": "Baranovichi",
                    "logo": "https://media-3.api-sports.io/football/teams/3383.png",
                    "winner": true
                },
                "away": {
                    "id": 3395,
                    "name": "Volna",
                    "logo": "https://media-2.api-sports.io/football/teams/3395.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 3395,
                        "name": "Volna",
                        "logo": "https://media-2.api-sports.io/football/teams/3395.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Grechikha"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 15,
                        "extra": null
                    },
                    "team": {
                        "id": 3395,
                        "name": "Volna",
                        "logo": "https://media-2.api-sports.io/football/teams/3395.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Kovsh"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 19,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-1.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Galuza"
                    },
                    "assist": {
                        "id": 163268,
                        "name": "E. Kozel"
                    },
                    "type": "subst",
                    "detail": "Substitution 1",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 39,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-1.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Galuza"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 43,
                        "extra": null
                    },
                    "team": {
                        "id": 3395,
                        "name": "Volna",
                        "logo": "https://media-1.api-sports.io/football/teams/3395.png"
                    },
                    "player": {
                        "id": null,
                        "name": "K. Kovalevich"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 46,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-3.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "V. Syrisko"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 52,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-2.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Mikhey"
                    },
                    "assist": {
                        "id": 7936,
                        "name": "Y. Nedashkovskiy"
                    },
                    "type": "subst",
                    "detail": "Substitution 2",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 3395,
                        "name": "Volna",
                        "logo": "https://media-2.api-sports.io/football/teams/3395.png"
                    },
                    "player": {
                        "id": null,
                        "name": "I. Sushchinskiy"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 61,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-2.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Bolbat"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 72,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-1.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "D. Dubrov"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 3383,
                        "name": "Baranovichi",
                        "logo": "https://media-3.api-sports.io/football/teams/3383.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Domashevich"
                    },
                    "assist": {
                        "id": null,
                        "name": "D. Dubrov"
                    },
                    "type": "subst",
                    "detail": "Substitution 3",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1018454,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 7809,
                    "name": "Stadion Neftyanik",
                    "city": "Rudaki"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 571,
                "name": "Vysshaya Liga",
                "country": "Tajikistan",
                "logo": "https://media-1.api-sports.io/football/leagues/571.png",
                "flag": "https://media-1.api-sports.io/flags/tj.svg",
                "season": 2023,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 12266,
                    "name": "Kuktosh",
                    "logo": "https://media-3.api-sports.io/football/teams/12266.png",
                    "winner": false
                },
                "away": {
                    "id": 16494,
                    "name": "Eskhata",
                    "logo": "https://media-1.api-sports.io/football/teams/16494.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 16494,
                        "name": "Eskhata",
                        "logo": "https://media-1.api-sports.io/football/teams/16494.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1018846,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 1022,
                    "name": "RTU stadions",
                    "city": "Riga"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 81
                }
            },
            "league": {
                "id": 364,
                "name": "1. Liga",
                "country": "Latvia",
                "logo": "https://media-2.api-sports.io/football/leagues/364.png",
                "flag": "https://media-1.api-sports.io/flags/lv.svg",
                "season": 2023,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 14353,
                    "name": "Dinamo Rīga",
                    "logo": "https://media-1.api-sports.io/football/teams/14353.png",
                    "winner": null
                },
                "away": {
                    "id": 4152,
                    "name": "Progress / AFA Olaine",
                    "logo": "https://media-1.api-sports.io/football/teams/4152.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1020577,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 5847,
                    "name": "Hans-Ludwig-Stadion",
                    "city": "Wals"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 50
                }
            },
            "league": {
                "id": 688,
                "name": "Regionalliga - Salzburg",
                "country": "Austria",
                "logo": "https://media-2.api-sports.io/football/leagues/688.png",
                "flag": "https://media-2.api-sports.io/flags/at.svg",
                "season": 2022,
                "round": "Salzburg - 2nd Phase - 5"
            },
            "teams": {
                "home": {
                    "id": 8261,
                    "name": "Wals-Grünau",
                    "logo": "https://media-3.api-sports.io/football/teams/8261.png",
                    "winner": false
                },
                "away": {
                    "id": 5000,
                    "name": "Austria Salzburg",
                    "logo": "https://media-1.api-sports.io/football/teams/5000.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 5000,
                        "name": "Austria Salzburg",
                        "logo": "https://media-2.api-sports.io/football/teams/5000.png"
                    },
                    "player": {
                        "id": null,
                        "name": "N. Schiedermeier"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1020956,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": 1683984600
                },
                "venue": {
                    "id": 3465,
                    "name": "Mzuzu Stadium",
                    "city": "Mzuzu"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 47
                }
            },
            "league": {
                "id": 391,
                "name": "Super League",
                "country": "Malawi",
                "logo": "https://media-2.api-sports.io/football/leagues/391.png",
                "flag": "https://media-3.api-sports.io/flags/mw.svg",
                "season": 2023,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 4593,
                    "name": "Moyale Barracks",
                    "logo": "https://media-1.api-sports.io/football/teams/4593.png",
                    "winner": null
                },
                "away": {
                    "id": 4583,
                    "name": "Be Forward Wanderers",
                    "logo": "https://media-3.api-sports.io/football/teams/4583.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1021934,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 4495,
                    "name": "Middelfart Stadion",
                    "city": "Middelfart"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 82
                }
            },
            "league": {
                "id": 862,
                "name": "3. Division",
                "country": "Denmark",
                "logo": "https://media-3.api-sports.io/football/leagues/862.png",
                "flag": "https://media-3.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Promotion Group - 5"
            },
            "teams": {
                "home": {
                    "id": 6042,
                    "name": "Middelfart",
                    "logo": "https://media-2.api-sports.io/football/teams/6042.png",
                    "winner": false
                },
                "away": {
                    "id": 6064,
                    "name": "VSK Århus",
                    "logo": "https://media-3.api-sports.io/football/teams/6064.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 55,
                        "extra": null
                    },
                    "team": {
                        "id": 6064,
                        "name": "VSK Århus",
                        "logo": "https://media-3.api-sports.io/football/teams/6064.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1021961,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": null,
                    "name": "Fynske Bank Arena Høje Bøge",
                    "city": "Svendborg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 83
                }
            },
            "league": {
                "id": 862,
                "name": "3. Division",
                "country": "Denmark",
                "logo": "https://media-3.api-sports.io/football/leagues/862.png",
                "flag": "https://media-3.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Relegation Round - 5"
            },
            "teams": {
                "home": {
                    "id": 6052,
                    "name": "SfB-Oure",
                    "logo": "https://media-2.api-sports.io/football/teams/6052.png",
                    "winner": null
                },
                "away": {
                    "id": 6028,
                    "name": "Holstebro",
                    "logo": "https://media-2.api-sports.io/football/teams/6028.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1021962,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 459,
                    "name": "JYSK park",
                    "city": "Silkeborg"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 79
                }
            },
            "league": {
                "id": 862,
                "name": "3. Division",
                "country": "Denmark",
                "logo": "https://media-3.api-sports.io/football/leagues/862.png",
                "flag": "https://media-3.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Relegation Round - 5"
            },
            "teams": {
                "home": {
                    "id": 8648,
                    "name": "Silkeborg KFUM",
                    "logo": "https://media-3.api-sports.io/football/teams/8648.png",
                    "winner": true
                },
                "away": {
                    "id": 8641,
                    "name": "AB Tårnby",
                    "logo": "https://media-1.api-sports.io/football/teams/8641.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 1,
                        "extra": null
                    },
                    "team": {
                        "id": 8648,
                        "name": "Silkeborg KFUM",
                        "logo": "https://media-2.api-sports.io/football/teams/8648.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 4,
                        "extra": null
                    },
                    "team": {
                        "id": 8641,
                        "name": "AB Tårnby",
                        "logo": "https://media-3.api-sports.io/football/teams/8641.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 8648,
                        "name": "Silkeborg KFUM",
                        "logo": "https://media-1.api-sports.io/football/teams/8648.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1022437,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 458,
                    "name": "Roskilde Idrætspark",
                    "city": "Roskilde"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 81
                }
            },
            "league": {
                "id": 122,
                "name": "2nd Division - Group 1",
                "country": "Denmark",
                "logo": "https://media-2.api-sports.io/football/leagues/122.png",
                "flag": "https://media-1.api-sports.io/flags/dk.svg",
                "season": 2022,
                "round": "Relegation Round - 5"
            },
            "teams": {
                "home": {
                    "id": 2067,
                    "name": "Roskilde",
                    "logo": "https://media-1.api-sports.io/football/teams/2067.png",
                    "winner": true
                },
                "away": {
                    "id": 2071,
                    "name": "Brabrand",
                    "logo": "https://media-2.api-sports.io/football/teams/2071.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 53,
                        "extra": null
                    },
                    "team": {
                        "id": 2067,
                        "name": "Roskilde",
                        "logo": "https://media-2.api-sports.io/football/teams/2067.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1026343,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:00:00+00:00",
                "timestamp": 1683979200,
                "periods": {
                    "first": 1683979200,
                    "second": 1683982800
                },
                "venue": {
                    "id": 12702,
                    "name": "Mainz Golden Eagles Stadium",
                    "city": "Mainz-Mombach"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 78
                }
            },
            "league": {
                "id": 988,
                "name": "Oberliga - Promotion Round",
                "country": "Germany",
                "logo": "https://media-2.api-sports.io/football/leagues/988.png",
                "flag": "https://media-1.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Rh/Pf/S - Promotion Round - 8"
            },
            "teams": {
                "home": {
                    "id": 14524,
                    "name": "Schott Mainz",
                    "logo": "https://media-2.api-sports.io/football/teams/14524.png",
                    "winner": true
                },
                "away": {
                    "id": 12800,
                    "name": "Kaiserslautern II",
                    "logo": "https://media-3.api-sports.io/football/teams/12800.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 14524,
                        "name": "Schott Mainz",
                        "logo": "https://media-3.api-sports.io/football/teams/14524.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Wimmer"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 14524,
                        "name": "Schott Mainz",
                        "logo": "https://media-2.api-sports.io/football/teams/14524.png"
                    },
                    "player": {
                        "id": 125293,
                        "name": "P. Merkel"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 14524,
                        "name": "Schott Mainz",
                        "logo": "https://media-3.api-sports.io/football/teams/14524.png"
                    },
                    "player": {
                        "id": 113590,
                        "name": "S. Schwarz"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 68,
                        "extra": null
                    },
                    "team": {
                        "id": 12800,
                        "name": "Kaiserslautern II",
                        "logo": "https://media-3.api-sports.io/football/teams/12800.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Thum"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1026590,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-12T22:15:00+00:00",
                "timestamp": 1683929700,
                "periods": {
                    "first": 1683929700,
                    "second": 1683933300
                },
                "venue": {
                    "id": 2604,
                    "name": "Estadio Luis Alberto Salinas Tanasio",
                    "city": "Itauguá"
                },
                "status": {
                    "long": "Second Half",
                    "short": "2H",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 251,
                "name": "Division Intermedia",
                "country": "Paraguay",
                "logo": "https://media-1.api-sports.io/football/leagues/251.png",
                "flag": "https://media-3.api-sports.io/flags/py.svg",
                "season": 2023,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 3832,
                    "name": "12 de Octubre",
                    "logo": "https://media-3.api-sports.io/football/teams/3832.png",
                    "winner": false
                },
                "away": {
                    "id": 10476,
                    "name": "Deportivo Recoleta",
                    "logo": "https://media-3.api-sports.io/football/teams/10476.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 10476,
                        "name": "Deportivo Recoleta",
                        "logo": "https://media-3.api-sports.io/football/teams/10476.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Gonzalez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 37,
                        "extra": null
                    },
                    "team": {
                        "id": 10476,
                        "name": "Deportivo Recoleta",
                        "logo": "https://media-2.api-sports.io/football/teams/10476.png"
                    },
                    "player": {
                        "id": 95350,
                        "name": "C. Garay"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 42,
                        "extra": null
                    },
                    "team": {
                        "id": 3832,
                        "name": "12 de Octubre",
                        "logo": "https://media-3.api-sports.io/football/teams/3832.png"
                    },
                    "player": {
                        "id": null,
                        "name": "E. Villalba"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 74,
                        "extra": null
                    },
                    "team": {
                        "id": 10476,
                        "name": "Deportivo Recoleta",
                        "logo": "https://media-3.api-sports.io/football/teams/10476.png"
                    },
                    "player": {
                        "id": null,
                        "name": "A. Gonzalez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 85,
                        "extra": null
                    },
                    "team": {
                        "id": 10476,
                        "name": "Deportivo Recoleta",
                        "logo": "https://media-3.api-sports.io/football/teams/10476.png"
                    },
                    "player": {
                        "id": 80584,
                        "name": "C. Benitez"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 900112,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 2902,
                    "name": "Sportpark Dijkpolder",
                    "city": "Maassluis"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 492,
                "name": "Tweede Divisie",
                "country": "Netherlands",
                "logo": "https://media-2.api-sports.io/football/leagues/492.png",
                "flag": "https://media-1.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 17129,
                    "name": "Excelsior Maassluis",
                    "logo": "https://media-2.api-sports.io/football/teams/17129.png",
                    "winner": null
                },
                "away": {
                    "id": 1232,
                    "name": "OFC Oostzaan",
                    "logo": "https://media-2.api-sports.io/football/teams/1232.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 1232,
                        "name": "OFC Oostzaan",
                        "logo": "https://media-1.api-sports.io/football/teams/1232.png"
                    },
                    "player": {
                        "id": null,
                        "name": "M. Veerman"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907188,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 12003,
                    "name": "Dietenbach-Sportpark",
                    "city": "Freiburg im Breisgau"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 753,
                "name": "Oberliga - Baden-Württemberg",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/753.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Baden-Württemberg - 32"
            },
            "teams": {
                "home": {
                    "id": 16115,
                    "name": "Freiburger FC",
                    "logo": "https://media-3.api-sports.io/football/teams/16115.png",
                    "winner": null
                },
                "away": {
                    "id": 13932,
                    "name": "Reutlingen",
                    "logo": "https://media-1.api-sports.io/football/teams/13932.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 4
                    },
                    "team": {
                        "id": 16115,
                        "name": "Freiburger FC",
                        "logo": "https://media-2.api-sports.io/football/teams/16115.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 4
                    },
                    "team": {
                        "id": 13932,
                        "name": "Reutlingen",
                        "logo": "https://media-2.api-sports.io/football/teams/13932.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 907552,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 3256,
                    "name": "Parkstadion",
                    "city": "Baunatal"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 750,
                "name": "Oberliga - Hessen",
                "country": "Germany",
                "logo": "https://media-3.api-sports.io/football/leagues/750.png",
                "flag": "https://media-3.api-sports.io/flags/de.svg",
                "season": 2022,
                "round": "Hessen - 35"
            },
            "teams": {
                "home": {
                    "id": 4261,
                    "name": "Baunatal",
                    "logo": "https://media-2.api-sports.io/football/teams/4261.png",
                    "winner": true
                },
                "away": {
                    "id": 14671,
                    "name": "FC 1906 Erlensee",
                    "logo": "https://media-3.api-sports.io/football/teams/14671.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 11,
                        "extra": null
                    },
                    "team": {
                        "id": 4261,
                        "name": "Baunatal",
                        "logo": "https://media-3.api-sports.io/football/teams/4261.png"
                    },
                    "player": {
                        "id": null,
                        "name": "H. Cakmak"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 16,
                        "extra": null
                    },
                    "team": {
                        "id": 14671,
                        "name": "FC 1906 Erlensee",
                        "logo": "https://media-2.api-sports.io/football/teams/14671.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": 1
                    },
                    "team": {
                        "id": 4261,
                        "name": "Baunatal",
                        "logo": "https://media-2.api-sports.io/football/teams/4261.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Lindenthal"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 943746,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 2969,
                    "name": "Catawiki Sportpark",
                    "city": "Assen"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 3911,
                    "name": "ACV",
                    "logo": "https://media-2.api-sports.io/football/teams/3911.png",
                    "winner": null
                },
                "away": {
                    "id": 3904,
                    "name": "Sportlust '46",
                    "logo": "https://media-3.api-sports.io/football/teams/3904.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 943747,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 2866,
                    "name": "Sportpark de Bosk",
                    "city": "Harkema"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1258,
                    "name": "Harkemase Boys",
                    "logo": "https://media-1.api-sports.io/football/teams/1258.png",
                    "winner": null
                },
                "away": {
                    "id": 1274,
                    "name": "Sparta Nijkerk",
                    "logo": "https://media-3.api-sports.io/football/teams/1274.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 943748,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": null,
                    "name": "Sportpark Panhuis",
                    "city": "Veenendaal"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1234,
                    "name": "Dovo",
                    "logo": "https://media-2.api-sports.io/football/teams/1234.png",
                    "winner": true
                },
                "away": {
                    "id": 3907,
                    "name": "VVOG",
                    "logo": "https://media-2.api-sports.io/football/teams/3907.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 1234,
                        "name": "Dovo",
                        "logo": "https://media-2.api-sports.io/football/teams/1234.png"
                    },
                    "player": {
                        "id": null,
                        "name": "L. Chisom Johnson"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 30,
                        "extra": null
                    },
                    "team": {
                        "id": 1234,
                        "name": "Dovo",
                        "logo": "https://media-3.api-sports.io/football/teams/1234.png"
                    },
                    "player": {
                        "id": null,
                        "name": "T. Pluk"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 1234,
                        "name": "Dovo",
                        "logo": "https://media-1.api-sports.io/football/teams/1234.png"
                    },
                    "player": {
                        "id": null,
                        "name": "G. van Dijk"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 943749,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 1148,
                    "name": "Sportpark Het Noorderslag",
                    "city": "Staphorst"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1239,
                    "name": "Staphorst",
                    "logo": "https://media-3.api-sports.io/football/teams/1239.png",
                    "winner": true
                },
                "away": {
                    "id": 1276,
                    "name": "Hoek",
                    "logo": "https://media-3.api-sports.io/football/teams/1276.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 13,
                        "extra": null
                    },
                    "team": {
                        "id": 1239,
                        "name": "Staphorst",
                        "logo": "https://media-1.api-sports.io/football/teams/1239.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. de Grote"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 27,
                        "extra": null
                    },
                    "team": {
                        "id": 1276,
                        "name": "Hoek",
                        "logo": "https://media-3.api-sports.io/football/teams/1276.png"
                    },
                    "player": {
                        "id": 93603,
                        "name": "Martens"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 1239,
                        "name": "Staphorst",
                        "logo": "https://media-2.api-sports.io/football/teams/1239.png"
                    },
                    "player": {
                        "id": null,
                        "name": "S. de Grote"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 943750,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 2875,
                    "name": "KWABO-stadion",
                    "city": "Volendam"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1238,
                    "name": "RKAV Volendam",
                    "logo": "https://media-3.api-sports.io/football/teams/1238.png",
                    "winner": false
                },
                "away": {
                    "id": 3905,
                    "name": "SteDoCo",
                    "logo": "https://media-3.api-sports.io/football/teams/3905.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 3905,
                        "name": "SteDoCo",
                        "logo": "https://media-3.api-sports.io/football/teams/3905.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 3905,
                        "name": "SteDoCo",
                        "logo": "https://media-1.api-sports.io/football/teams/3905.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 45,
                        "extra": null
                    },
                    "team": {
                        "id": 3905,
                        "name": "SteDoCo",
                        "logo": "https://media-2.api-sports.io/football/teams/3905.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 943751,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 2898,
                    "name": "Sportpark De Kooltuin",
                    "city": "Katwijk aan Zee"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 92,
                "name": "Derde Divisie - Saturday",
                "country": "Netherlands",
                "logo": "https://media-3.api-sports.io/football/leagues/92.png",
                "flag": "https://media-3.api-sports.io/flags/nl.svg",
                "season": 2022,
                "round": "Zaterdag - 32"
            },
            "teams": {
                "home": {
                    "id": 1288,
                    "name": "Rijnvogels",
                    "logo": "https://media-3.api-sports.io/football/teams/1288.png",
                    "winner": false
                },
                "away": {
                    "id": 1271,
                    "name": "Barendrecht",
                    "logo": "https://media-1.api-sports.io/football/teams/1271.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 33,
                        "extra": null
                    },
                    "team": {
                        "id": 1271,
                        "name": "Barendrecht",
                        "logo": "https://media-3.api-sports.io/football/teams/1271.png"
                    },
                    "player": {
                        "id": 93869,
                        "name": "M. van Dijk"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 966646,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:45:00+00:00",
                "timestamp": 1683981900,
                "periods": {
                    "first": 1683981900,
                    "second": null
                },
                "venue": {
                    "id": 2731,
                    "name": "Stadio Karditsas",
                    "city": "Karditsa"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 494,
                "name": "Super League 2",
                "country": "Greece",
                "logo": "https://media-1.api-sports.io/football/leagues/494.png",
                "flag": "https://media-3.api-sports.io/flags/gr.svg",
                "season": 2022,
                "round": "Group A - 25"
            },
            "teams": {
                "home": {
                    "id": 2094,
                    "name": "Anagennisi Karditsas",
                    "logo": "https://media-3.api-sports.io/football/teams/2094.png",
                    "winner": null
                },
                "away": {
                    "id": 2099,
                    "name": "Panserraikos",
                    "logo": "https://media-3.api-sports.io/football/teams/2099.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 974923,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 5369,
                    "name": "Stadion TJ Jiskra Ústí nad Orlicí",
                    "city": "Ústí nad Orlicí"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 352,
                "name": "4. liga - Divizie C",
                "country": "Czech-Republic",
                "logo": "https://media-1.api-sports.io/football/leagues/352.png",
                "flag": "https://media-1.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "Division C - 26"
            },
            "teams": {
                "home": {
                    "id": 7381,
                    "name": "Ústí nad Orlicí",
                    "logo": "https://media-3.api-sports.io/football/teams/7381.png",
                    "winner": null
                },
                "away": {
                    "id": 19641,
                    "name": "Chrudim II",
                    "logo": "https://media-2.api-sports.io/football/teams/19641.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 975165,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 5302,
                    "name": "Stadion Střelnice",
                    "city": "Domažlice"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 348,
                "name": "3. liga - CFL A",
                "country": "Czech-Republic",
                "logo": "https://media-1.api-sports.io/football/leagues/348.png",
                "flag": "https://media-3.api-sports.io/flags/cz.svg",
                "season": 2022,
                "round": "ČFL A - 26"
            },
            "teams": {
                "home": {
                    "id": 7304,
                    "name": "Jiskra Domažlice",
                    "logo": "https://media-1.api-sports.io/football/teams/7304.png",
                    "winner": true
                },
                "away": {
                    "id": 7350,
                    "name": "Sokol Hostouň",
                    "logo": "https://media-1.api-sports.io/football/teams/7350.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 2
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 8,
                        "extra": null
                    },
                    "team": {
                        "id": 7304,
                        "name": "Jiskra Domažlice",
                        "logo": "https://media-2.api-sports.io/football/teams/7304.png"
                    },
                    "player": {
                        "id": 66180,
                        "name": "E. Vuch"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 22,
                        "extra": null
                    },
                    "team": {
                        "id": 7350,
                        "name": "Sokol Hostouň",
                        "logo": "https://media-3.api-sports.io/football/teams/7350.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 23,
                        "extra": null
                    },
                    "team": {
                        "id": 7304,
                        "name": "Jiskra Domažlice",
                        "logo": "https://media-2.api-sports.io/football/teams/7304.png"
                    },
                    "player": {
                        "id": null,
                        "name": null
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Card",
                    "detail": "Yellow Card",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 32,
                        "extra": null
                    },
                    "team": {
                        "id": 7304,
                        "name": "Jiskra Domažlice",
                        "logo": "https://media-1.api-sports.io/football/teams/7304.png"
                    },
                    "player": {
                        "id": 140062,
                        "name": "P. Muzik"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Penalty",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 34,
                        "extra": null
                    },
                    "team": {
                        "id": 7350,
                        "name": "Sokol Hostouň",
                        "logo": "https://media-2.api-sports.io/football/teams/7350.png"
                    },
                    "player": {
                        "id": null,
                        "name": "Z. Hucek"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 36,
                        "extra": null
                    },
                    "team": {
                        "id": 7304,
                        "name": "Jiskra Domažlice",
                        "logo": "https://media-3.api-sports.io/football/teams/7304.png"
                    },
                    "player": {
                        "id": null,
                        "name": "J. Zajicek"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        },
        {
            "fixture": {
                "id": 1020959,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 3469,
                    "name": "Karonga Stadium",
                    "city": "Karonga"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 391,
                "name": "Super League",
                "country": "Malawi",
                "logo": "https://media-2.api-sports.io/football/leagues/391.png",
                "flag": "https://media-3.api-sports.io/flags/mw.svg",
                "season": 2023,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 4589,
                    "name": "Karonga United",
                    "logo": "https://media-3.api-sports.io/football/teams/4589.png",
                    "winner": null
                },
                "away": {
                    "id": 11125,
                    "name": "CIVO United",
                    "logo": "https://media-3.api-sports.io/football/teams/11125.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": []
        },
        {
            "fixture": {
                "id": 1020962,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-13T12:30:00+00:00",
                "timestamp": 1683981000,
                "periods": {
                    "first": 1683981000,
                    "second": null
                },
                "venue": {
                    "id": 3464,
                    "name": "Nankhaka Stadium",
                    "city": "Lilongwe"
                },
                "status": {
                    "long": "Halftime",
                    "short": "HT",
                    "elapsed": 45
                }
            },
            "league": {
                "id": 391,
                "name": "Super League",
                "country": "Malawi",
                "logo": "https://media-2.api-sports.io/football/leagues/391.png",
                "flag": "https://media-3.api-sports.io/flags/mw.svg",
                "season": 2023,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 4584,
                    "name": "Blue Eagles",
                    "logo": "https://media-1.api-sports.io/football/teams/4584.png",
                    "winner": null
                },
                "away": {
                    "id": 18747,
                    "name": "Dedza Dynamos",
                    "logo": "https://media-3.api-sports.io/football/teams/18747.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            },
            "events": [
                {
                    "time": {
                        "elapsed": 10,
                        "extra": null
                    },
                    "team": {
                        "id": 4584,
                        "name": "Blue Eagles",
                        "logo": "https://media-2.api-sports.io/football/teams/4584.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Gototo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                },
                {
                    "time": {
                        "elapsed": 18,
                        "extra": null
                    },
                    "team": {
                        "id": 18747,
                        "name": "Dedza Dynamos",
                        "logo": "https://media-2.api-sports.io/football/teams/18747.png"
                    },
                    "player": {
                        "id": null,
                        "name": "C. Nyondo"
                    },
                    "assist": {
                        "id": null,
                        "name": null
                    },
                    "type": "Goal",
                    "detail": "Normal Goal",
                    "comments": null
                }
            ]
        }
    ]
}